
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("giU2u", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bde9cc018c642020$export$6503ec6e8aabbaf; }, function (v) { return $bde9cc018c642020$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $bde9cc018c642020$export$f7ad0328861e2f03; }, function (v) { return $bde9cc018c642020$export$f7ad0328861e2f03 = v; });
var $bde9cc018c642020$export$6503ec6e8aabbaf;
var $bde9cc018c642020$export$f7ad0328861e2f03;
"use strict";
var $bde9cc018c642020$var$mapping = new Map();
function $bde9cc018c642020$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bde9cc018c642020$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bde9cc018c642020$var$resolve(id) {
    var resolved = $bde9cc018c642020$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bde9cc018c642020$export$6503ec6e8aabbaf = $bde9cc018c642020$var$register;
$bde9cc018c642020$export$f7ad0328861e2f03 = $bde9cc018c642020$var$resolve;

});

parcelRegister("5aRSq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kNOdC"));

});
parcelRegister("kNOdC", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $f24f56a526d65c9e$export$ffb0004e005737fa; }, function (v) { return $f24f56a526d65c9e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $f24f56a526d65c9e$export$34b9dba7ce09269b; }, function (v) { return $f24f56a526d65c9e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $f24f56a526d65c9e$export$25062201e9e25d76; }, function (v) { return $f24f56a526d65c9e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f24f56a526d65c9e$export$ffb0004e005737fa;
var $f24f56a526d65c9e$export$34b9dba7ce09269b;
var $f24f56a526d65c9e$export$25062201e9e25d76;
"use strict";
var $f24f56a526d65c9e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f24f56a526d65c9e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $f24f56a526d65c9e$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $f24f56a526d65c9e$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$f24f56a526d65c9e$export$ffb0004e005737fa = $f24f56a526d65c9e$var$REACT_FRAGMENT_TYPE;
$f24f56a526d65c9e$export$34b9dba7ce09269b = $f24f56a526d65c9e$var$jsxProd;
$f24f56a526d65c9e$export$25062201e9e25d76 = $f24f56a526d65c9e$var$jsxProd;

});


parcelRegister("GDJFN", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0802bf0880b1ef59$export$dca3b0875bd9a954; }, function (v) { return $0802bf0880b1ef59$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0802bf0880b1ef59$export$16fa2f45be04daa8; }, function (v) { return $0802bf0880b1ef59$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0802bf0880b1ef59$export$ffb0004e005737fa; }, function (v) { return $0802bf0880b1ef59$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0802bf0880b1ef59$export$e2c29f18771995cb; }, function (v) { return $0802bf0880b1ef59$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0802bf0880b1ef59$export$221d75b3f55bb0bd; }, function (v) { return $0802bf0880b1ef59$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0802bf0880b1ef59$export$5f8d39834fd61797; }, function (v) { return $0802bf0880b1ef59$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0802bf0880b1ef59$export$74bf444e3cd11ea5; }, function (v) { return $0802bf0880b1ef59$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $0802bf0880b1ef59$export$1ced07cd6b1985ce; }, function (v) { return $0802bf0880b1ef59$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $0802bf0880b1ef59$export$3ba232387fd5d6dd; }, function (v) { return $0802bf0880b1ef59$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $0802bf0880b1ef59$export$69a3209f1a06c04d; }, function (v) { return $0802bf0880b1ef59$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0802bf0880b1ef59$export$e530037191fcd5d7; }, function (v) { return $0802bf0880b1ef59$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0802bf0880b1ef59$export$fd42f52fd3ae1109; }, function (v) { return $0802bf0880b1ef59$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0802bf0880b1ef59$export$c8a8987d4410bf2d; }, function (v) { return $0802bf0880b1ef59$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $0802bf0880b1ef59$export$7d1e3a5e95ceca43; }, function (v) { return $0802bf0880b1ef59$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0802bf0880b1ef59$export$257a8862b851cb5b; }, function (v) { return $0802bf0880b1ef59$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0802bf0880b1ef59$export$a8257692ac88316c; }, function (v) { return $0802bf0880b1ef59$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0802bf0880b1ef59$export$488013bae63b21da; }, function (v) { return $0802bf0880b1ef59$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0802bf0880b1ef59$export$7c73462e0d25e514; }, function (v) { return $0802bf0880b1ef59$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0802bf0880b1ef59$export$7568632d0d33d16d; }, function (v) { return $0802bf0880b1ef59$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $0802bf0880b1ef59$export$f93f40ac0ca7e3a8; }, function (v) { return $0802bf0880b1ef59$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $0802bf0880b1ef59$export$1f96ae73734a86cc; }, function (v) { return $0802bf0880b1ef59$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $0802bf0880b1ef59$export$9a47ced3238df325; }, function (v) { return $0802bf0880b1ef59$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0802bf0880b1ef59$export$35808ee640e87ca7; }, function (v) { return $0802bf0880b1ef59$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0802bf0880b1ef59$export$fae74005e78b1a27; }, function (v) { return $0802bf0880b1ef59$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0802bf0880b1ef59$export$dc8fbce3eb94dc1e; }, function (v) { return $0802bf0880b1ef59$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0802bf0880b1ef59$export$6a7bc4e911dc01cf; }, function (v) { return $0802bf0880b1ef59$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0802bf0880b1ef59$export$6d9c69b0de29b591; }, function (v) { return $0802bf0880b1ef59$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $0802bf0880b1ef59$export$f680877a34711e37; }, function (v) { return $0802bf0880b1ef59$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0802bf0880b1ef59$export$d5a552a76deda3c2; }, function (v) { return $0802bf0880b1ef59$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0802bf0880b1ef59$export$aaabe4eda9ed9969; }, function (v) { return $0802bf0880b1ef59$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0802bf0880b1ef59$export$e5c5a5f917a5871c; }, function (v) { return $0802bf0880b1ef59$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0802bf0880b1ef59$export$1538c33de8887b59; }, function (v) { return $0802bf0880b1ef59$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $0802bf0880b1ef59$export$fca7f784ae7a249a; }, function (v) { return $0802bf0880b1ef59$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $0802bf0880b1ef59$export$13e3392192263954; }, function (v) { return $0802bf0880b1ef59$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0802bf0880b1ef59$export$b8f5890fc79d6aca; }, function (v) { return $0802bf0880b1ef59$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0802bf0880b1ef59$export$60241385465d0a34; }, function (v) { return $0802bf0880b1ef59$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0802bf0880b1ef59$export$306c0aa65ff9ec16; }, function (v) { return $0802bf0880b1ef59$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0802bf0880b1ef59$export$7b286972b8d8ccbf; }, function (v) { return $0802bf0880b1ef59$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0802bf0880b1ef59$export$83d89fbfd8236492; }, function (v) { return $0802bf0880b1ef59$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0802bf0880b1ef59$export$dca3b0875bd9a954;
var $0802bf0880b1ef59$export$16fa2f45be04daa8;
var $0802bf0880b1ef59$export$ffb0004e005737fa;
var $0802bf0880b1ef59$export$e2c29f18771995cb;
var $0802bf0880b1ef59$export$221d75b3f55bb0bd;
var $0802bf0880b1ef59$export$5f8d39834fd61797;
var $0802bf0880b1ef59$export$74bf444e3cd11ea5;
var $0802bf0880b1ef59$export$1ced07cd6b1985ce;
var $0802bf0880b1ef59$export$3ba232387fd5d6dd;
var $0802bf0880b1ef59$export$69a3209f1a06c04d;
var $0802bf0880b1ef59$export$e530037191fcd5d7;
var $0802bf0880b1ef59$export$fd42f52fd3ae1109;
var $0802bf0880b1ef59$export$c8a8987d4410bf2d;
var $0802bf0880b1ef59$export$7d1e3a5e95ceca43;
var $0802bf0880b1ef59$export$257a8862b851cb5b;
var $0802bf0880b1ef59$export$a8257692ac88316c;
var $0802bf0880b1ef59$export$488013bae63b21da;
var $0802bf0880b1ef59$export$7c73462e0d25e514;
var $0802bf0880b1ef59$export$7568632d0d33d16d;
var $0802bf0880b1ef59$export$f93f40ac0ca7e3a8;
var $0802bf0880b1ef59$export$1f96ae73734a86cc;
var $0802bf0880b1ef59$export$9a47ced3238df325;
var $0802bf0880b1ef59$export$35808ee640e87ca7;
var $0802bf0880b1ef59$export$fae74005e78b1a27;
var $0802bf0880b1ef59$export$dc8fbce3eb94dc1e;
var $0802bf0880b1ef59$export$6a7bc4e911dc01cf;
var $0802bf0880b1ef59$export$6d9c69b0de29b591;
var $0802bf0880b1ef59$export$f680877a34711e37;
var $0802bf0880b1ef59$export$d5a552a76deda3c2;
var $0802bf0880b1ef59$export$aaabe4eda9ed9969;
var $0802bf0880b1ef59$export$e5c5a5f917a5871c;
var $0802bf0880b1ef59$export$1538c33de8887b59;
var $0802bf0880b1ef59$export$fca7f784ae7a249a;
var $0802bf0880b1ef59$export$13e3392192263954;
var $0802bf0880b1ef59$export$b8f5890fc79d6aca;
var $0802bf0880b1ef59$export$60241385465d0a34;
var $0802bf0880b1ef59$export$306c0aa65ff9ec16;
var $0802bf0880b1ef59$export$7b286972b8d8ccbf;
var $0802bf0880b1ef59$export$83d89fbfd8236492;

var $7q8YY = parcelRequire("7q8YY");
"use strict";
var $0802bf0880b1ef59$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0802bf0880b1ef59$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0802bf0880b1ef59$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0802bf0880b1ef59$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0802bf0880b1ef59$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0802bf0880b1ef59$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0802bf0880b1ef59$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0802bf0880b1ef59$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0802bf0880b1ef59$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0802bf0880b1ef59$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0802bf0880b1ef59$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $0802bf0880b1ef59$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $0802bf0880b1ef59$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $0802bf0880b1ef59$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$0802bf0880b1ef59$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $0802bf0880b1ef59$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0802bf0880b1ef59$var$assign = Object.assign, $0802bf0880b1ef59$var$emptyObject = {};
function $0802bf0880b1ef59$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0802bf0880b1ef59$var$emptyObject;
    this.updater = updater || $0802bf0880b1ef59$var$ReactNoopUpdateQueue;
}
$0802bf0880b1ef59$var$Component.prototype.isReactComponent = {};
$0802bf0880b1ef59$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$0802bf0880b1ef59$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $0802bf0880b1ef59$var$ComponentDummy() {}
$0802bf0880b1ef59$var$ComponentDummy.prototype = $0802bf0880b1ef59$var$Component.prototype;
function $0802bf0880b1ef59$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0802bf0880b1ef59$var$emptyObject;
    this.updater = updater || $0802bf0880b1ef59$var$ReactNoopUpdateQueue;
}
var $0802bf0880b1ef59$var$pureComponentPrototype = $0802bf0880b1ef59$var$PureComponent.prototype = new $0802bf0880b1ef59$var$ComponentDummy();
$0802bf0880b1ef59$var$pureComponentPrototype.constructor = $0802bf0880b1ef59$var$PureComponent;
$0802bf0880b1ef59$var$assign($0802bf0880b1ef59$var$pureComponentPrototype, $0802bf0880b1ef59$var$Component.prototype);
$0802bf0880b1ef59$var$pureComponentPrototype.isPureReactComponent = !0;
var $0802bf0880b1ef59$var$isArrayImpl = Array.isArray, $0802bf0880b1ef59$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $0802bf0880b1ef59$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0802bf0880b1ef59$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $0802bf0880b1ef59$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $0802bf0880b1ef59$var$cloneAndReplaceKey(oldElement, newKey) {
    return $0802bf0880b1ef59$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $0802bf0880b1ef59$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $0802bf0880b1ef59$var$REACT_ELEMENT_TYPE;
}
function $0802bf0880b1ef59$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $0802bf0880b1ef59$var$userProvidedKeyEscapeRegex = /\/+/g;
function $0802bf0880b1ef59$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $0802bf0880b1ef59$var$escape("" + element.key) : index.toString(36);
}
function $0802bf0880b1ef59$var$noop$1() {}
function $0802bf0880b1ef59$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($0802bf0880b1ef59$var$noop$1, $0802bf0880b1ef59$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $0802bf0880b1ef59$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $0802bf0880b1ef59$var$REACT_ELEMENT_TYPE:
                case $0802bf0880b1ef59$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $0802bf0880b1ef59$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $0802bf0880b1ef59$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $0802bf0880b1ef59$var$getElementKey(children, 0) : nameSoFar, $0802bf0880b1ef59$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($0802bf0880b1ef59$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $0802bf0880b1ef59$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($0802bf0880b1ef59$var$isValidElement(callback) && (callback = $0802bf0880b1ef59$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($0802bf0880b1ef59$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($0802bf0880b1ef59$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $0802bf0880b1ef59$var$getElementKey(nameSoFar, i), invokeCallback += $0802bf0880b1ef59$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $0802bf0880b1ef59$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $0802bf0880b1ef59$var$getElementKey(nameSoFar, i++), invokeCallback += $0802bf0880b1ef59$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $0802bf0880b1ef59$var$mapIntoArray($0802bf0880b1ef59$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $0802bf0880b1ef59$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $0802bf0880b1ef59$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $0802bf0880b1ef59$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $0802bf0880b1ef59$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $7q8YY && "function" === typeof $7q8YY.emit) {
        $7q8YY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $0802bf0880b1ef59$var$noop() {}
$0802bf0880b1ef59$export$dca3b0875bd9a954 = {
    map: $0802bf0880b1ef59$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $0802bf0880b1ef59$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $0802bf0880b1ef59$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $0802bf0880b1ef59$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$0802bf0880b1ef59$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$0802bf0880b1ef59$export$16fa2f45be04daa8 = $0802bf0880b1ef59$var$Component;
$0802bf0880b1ef59$export$ffb0004e005737fa = $0802bf0880b1ef59$var$REACT_FRAGMENT_TYPE;
$0802bf0880b1ef59$export$e2c29f18771995cb = $0802bf0880b1ef59$var$REACT_PROFILER_TYPE;
$0802bf0880b1ef59$export$221d75b3f55bb0bd = $0802bf0880b1ef59$var$PureComponent;
$0802bf0880b1ef59$export$5f8d39834fd61797 = $0802bf0880b1ef59$var$REACT_STRICT_MODE_TYPE;
$0802bf0880b1ef59$export$74bf444e3cd11ea5 = $0802bf0880b1ef59$var$REACT_SUSPENSE_TYPE;
$0802bf0880b1ef59$export$1ced07cd6b1985ce = $0802bf0880b1ef59$var$ReactSharedInternals;
$0802bf0880b1ef59$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$0802bf0880b1ef59$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$0802bf0880b1ef59$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $0802bf0880b1ef59$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$0802bf0880b1ef59$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $0802bf0880b1ef59$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$0802bf0880b1ef59$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $0802bf0880b1ef59$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $0802bf0880b1ef59$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$0802bf0880b1ef59$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$0802bf0880b1ef59$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $0802bf0880b1ef59$var$ReactElement(type, key, void 0, void 0, null, props);
};
$0802bf0880b1ef59$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0802bf0880b1ef59$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $0802bf0880b1ef59$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$0802bf0880b1ef59$export$a8257692ac88316c = $0802bf0880b1ef59$var$isValidElement;
$0802bf0880b1ef59$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $0802bf0880b1ef59$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $0802bf0880b1ef59$var$lazyInitializer
    };
};
$0802bf0880b1ef59$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $0802bf0880b1ef59$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$0802bf0880b1ef59$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $0802bf0880b1ef59$var$ReactSharedInternals.T, currentTransition = {};
    $0802bf0880b1ef59$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $0802bf0880b1ef59$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($0802bf0880b1ef59$var$noop, $0802bf0880b1ef59$var$reportGlobalError);
    } catch (error) {
        $0802bf0880b1ef59$var$reportGlobalError(error);
    } finally{
        $0802bf0880b1ef59$var$ReactSharedInternals.T = prevTransition;
    }
};
$0802bf0880b1ef59$export$f93f40ac0ca7e3a8 = function() {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useCacheRefresh();
};
$0802bf0880b1ef59$export$1f96ae73734a86cc = function(usable) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.use(usable);
};
$0802bf0880b1ef59$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$0802bf0880b1ef59$export$35808ee640e87ca7 = function(callback, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$0802bf0880b1ef59$export$fae74005e78b1a27 = function(Context) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useContext(Context);
};
$0802bf0880b1ef59$export$dc8fbce3eb94dc1e = function() {};
$0802bf0880b1ef59$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$0802bf0880b1ef59$export$6d9c69b0de29b591 = function(create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useEffect(create, deps);
};
$0802bf0880b1ef59$export$f680877a34711e37 = function() {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useId();
};
$0802bf0880b1ef59$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$0802bf0880b1ef59$export$aaabe4eda9ed9969 = function(create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$0802bf0880b1ef59$export$e5c5a5f917a5871c = function(create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$0802bf0880b1ef59$export$1538c33de8887b59 = function(create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useMemo(create, deps);
};
$0802bf0880b1ef59$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$0802bf0880b1ef59$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$0802bf0880b1ef59$export$b8f5890fc79d6aca = function(initialValue) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useRef(initialValue);
};
$0802bf0880b1ef59$export$60241385465d0a34 = function(initialState) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useState(initialState);
};
$0802bf0880b1ef59$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$0802bf0880b1ef59$export$7b286972b8d8ccbf = function() {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useTransition();
};
$0802bf0880b1ef59$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("7q8YY", function(module, exports) {
// shim for using process in browser
var $5671edd534fa79c4$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5671edd534fa79c4$var$cachedSetTimeout;
var $5671edd534fa79c4$var$cachedClearTimeout;
function $5671edd534fa79c4$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $5671edd534fa79c4$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        else $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        else $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    }
})();
function $5671edd534fa79c4$var$runTimeout(fun) {
    if ($5671edd534fa79c4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedSetTimeout === $5671edd534fa79c4$var$defaultSetTimout || !$5671edd534fa79c4$var$cachedSetTimeout) && setTimeout) {
        $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5671edd534fa79c4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5671edd534fa79c4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5671edd534fa79c4$var$runClearTimeout(marker) {
    if ($5671edd534fa79c4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedClearTimeout === $5671edd534fa79c4$var$defaultClearTimeout || !$5671edd534fa79c4$var$cachedClearTimeout) && clearTimeout) {
        $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5671edd534fa79c4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5671edd534fa79c4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5671edd534fa79c4$var$queue = [];
var $5671edd534fa79c4$var$draining = false;
var $5671edd534fa79c4$var$currentQueue;
var $5671edd534fa79c4$var$queueIndex = -1;
function $5671edd534fa79c4$var$cleanUpNextTick() {
    if (!$5671edd534fa79c4$var$draining || !$5671edd534fa79c4$var$currentQueue) return;
    $5671edd534fa79c4$var$draining = false;
    if ($5671edd534fa79c4$var$currentQueue.length) $5671edd534fa79c4$var$queue = $5671edd534fa79c4$var$currentQueue.concat($5671edd534fa79c4$var$queue);
    else $5671edd534fa79c4$var$queueIndex = -1;
    if ($5671edd534fa79c4$var$queue.length) $5671edd534fa79c4$var$drainQueue();
}
function $5671edd534fa79c4$var$drainQueue() {
    if ($5671edd534fa79c4$var$draining) return;
    var timeout = $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$cleanUpNextTick);
    $5671edd534fa79c4$var$draining = true;
    var len = $5671edd534fa79c4$var$queue.length;
    while(len){
        $5671edd534fa79c4$var$currentQueue = $5671edd534fa79c4$var$queue;
        $5671edd534fa79c4$var$queue = [];
        while(++$5671edd534fa79c4$var$queueIndex < len)if ($5671edd534fa79c4$var$currentQueue) $5671edd534fa79c4$var$currentQueue[$5671edd534fa79c4$var$queueIndex].run();
        $5671edd534fa79c4$var$queueIndex = -1;
        len = $5671edd534fa79c4$var$queue.length;
    }
    $5671edd534fa79c4$var$currentQueue = null;
    $5671edd534fa79c4$var$draining = false;
    $5671edd534fa79c4$var$runClearTimeout(timeout);
}
$5671edd534fa79c4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5671edd534fa79c4$var$queue.push(new $5671edd534fa79c4$var$Item(fun, args));
    if ($5671edd534fa79c4$var$queue.length === 1 && !$5671edd534fa79c4$var$draining) $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$drainQueue);
};
// v8 likes predictible objects
function $5671edd534fa79c4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5671edd534fa79c4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5671edd534fa79c4$var$process.title = 'browser';
$5671edd534fa79c4$var$process.browser = true;
$5671edd534fa79c4$var$process.env = {};
$5671edd534fa79c4$var$process.argv = [];
$5671edd534fa79c4$var$process.version = ''; // empty string to avoid regexp issues
$5671edd534fa79c4$var$process.versions = {};
function $5671edd534fa79c4$var$noop() {}
$5671edd534fa79c4$var$process.on = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.addListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.once = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.off = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeAllListeners = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.emit = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependOnceListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.listeners = function(name) {
    return [];
};
$5671edd534fa79c4$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$5671edd534fa79c4$var$process.cwd = function() {
    return '/';
};
$5671edd534fa79c4$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$5671edd534fa79c4$var$process.umask = function() {
    return 0;
};

});


parcelRegister("5p4Xp", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $3ef321f56e16f92a$export$882461b6382ed46c; }, function (v) { return $3ef321f56e16f92a$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $3ef321f56e16f92a$export$757ceba2d55c277e; }, function (v) { return $3ef321f56e16f92a$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $3ef321f56e16f92a$export$83d89fbfd8236492; }, function (v) { return $3ef321f56e16f92a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $3ef321f56e16f92a$export$882461b6382ed46c;
var $3ef321f56e16f92a$export$757ceba2d55c277e;
var $3ef321f56e16f92a$export$83d89fbfd8236492;

var $7q8YY = parcelRequire("7q8YY");
"use strict";

var $1c3ne = parcelRequire("1c3ne");

var $4Iuzv = parcelRequire("4Iuzv");

var $hSThT = parcelRequire("hSThT");
function $3ef321f56e16f92a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $3ef321f56e16f92a$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $3ef321f56e16f92a$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $3ef321f56e16f92a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $3ef321f56e16f92a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $3ef321f56e16f92a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $3ef321f56e16f92a$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $3ef321f56e16f92a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $3ef321f56e16f92a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $3ef321f56e16f92a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $3ef321f56e16f92a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $3ef321f56e16f92a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $3ef321f56e16f92a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3ef321f56e16f92a$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $3ef321f56e16f92a$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $3ef321f56e16f92a$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $3ef321f56e16f92a$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $3ef321f56e16f92a$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$3ef321f56e16f92a$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $3ef321f56e16f92a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $3ef321f56e16f92a$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $3ef321f56e16f92a$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $3ef321f56e16f92a$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $3ef321f56e16f92a$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $3ef321f56e16f92a$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $3ef321f56e16f92a$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $3ef321f56e16f92a$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $3ef321f56e16f92a$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $3ef321f56e16f92a$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $3ef321f56e16f92a$var$getComponentNameFromType(type.type) || "Memo";
        case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $3ef321f56e16f92a$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $3ef321f56e16f92a$var$ReactSharedInternals = $4Iuzv.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $3ef321f56e16f92a$var$assign = Object.assign, $3ef321f56e16f92a$var$prefix, $3ef321f56e16f92a$var$suffix;
function $3ef321f56e16f92a$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $3ef321f56e16f92a$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $3ef321f56e16f92a$var$prefix = match && match[1] || "";
        $3ef321f56e16f92a$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $3ef321f56e16f92a$var$prefix + name + $3ef321f56e16f92a$var$suffix;
}
var $3ef321f56e16f92a$var$reentry = !1;
function $3ef321f56e16f92a$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $3ef321f56e16f92a$var$reentry) return "";
    $3ef321f56e16f92a$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $3ef321f56e16f92a$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $3ef321f56e16f92a$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $3ef321f56e16f92a$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $3ef321f56e16f92a$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $3ef321f56e16f92a$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $3ef321f56e16f92a$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $3ef321f56e16f92a$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $3ef321f56e16f92a$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $3ef321f56e16f92a$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $3ef321f56e16f92a$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $3ef321f56e16f92a$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $3ef321f56e16f92a$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $3ef321f56e16f92a$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $3ef321f56e16f92a$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $3ef321f56e16f92a$var$assertIsMounted(fiber) {
    if ($3ef321f56e16f92a$var$getNearestMountedFiber(fiber) !== fiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
}
function $3ef321f56e16f92a$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $3ef321f56e16f92a$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $3ef321f56e16f92a$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $3ef321f56e16f92a$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $3ef321f56e16f92a$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $3ef321f56e16f92a$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $3ef321f56e16f92a$var$isArrayImpl = Array.isArray, $3ef321f56e16f92a$var$ReactDOMSharedInternals = $hSThT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $3ef321f56e16f92a$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $3ef321f56e16f92a$var$valueStack = [], $3ef321f56e16f92a$var$index = -1;
function $3ef321f56e16f92a$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $3ef321f56e16f92a$var$pop(cursor) {
    0 > $3ef321f56e16f92a$var$index || (cursor.current = $3ef321f56e16f92a$var$valueStack[$3ef321f56e16f92a$var$index], $3ef321f56e16f92a$var$valueStack[$3ef321f56e16f92a$var$index] = null, $3ef321f56e16f92a$var$index--);
}
function $3ef321f56e16f92a$var$push(cursor, value) {
    $3ef321f56e16f92a$var$index++;
    $3ef321f56e16f92a$var$valueStack[$3ef321f56e16f92a$var$index] = cursor.current;
    cursor.current = value;
}
var $3ef321f56e16f92a$var$contextStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$contextFiberStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$rootInstanceStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$hostTransitionProviderCursor = $3ef321f56e16f92a$var$createCursor(null);
function $3ef321f56e16f92a$var$pushHostContainer(fiber, nextRootInstance) {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$rootInstanceStackCursor, nextRootInstance);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextFiberStackCursor, fiber);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $3ef321f56e16f92a$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $3ef321f56e16f92a$var$getOwnHostContext(fiber), nextRootInstance = $3ef321f56e16f92a$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextStackCursor);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextStackCursor, nextRootInstance);
}
function $3ef321f56e16f92a$var$popHostContainer() {
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextStackCursor);
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextFiberStackCursor);
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$rootInstanceStackCursor);
}
function $3ef321f56e16f92a$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$hostTransitionProviderCursor, fiber);
    var context = $3ef321f56e16f92a$var$contextStackCursor.current;
    var JSCompiler_inline_result = $3ef321f56e16f92a$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextFiberStackCursor, fiber), $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextStackCursor, JSCompiler_inline_result));
}
function $3ef321f56e16f92a$var$popHostContext(fiber) {
    $3ef321f56e16f92a$var$contextFiberStackCursor.current === fiber && ($3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextStackCursor), $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextFiberStackCursor));
    $3ef321f56e16f92a$var$hostTransitionProviderCursor.current === fiber && ($3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$hostTransitionProviderCursor), $3ef321f56e16f92a$var$HostTransitionContext._currentValue = $3ef321f56e16f92a$var$sharedNotPendingObject);
}
var $3ef321f56e16f92a$var$hasOwnProperty = Object.prototype.hasOwnProperty, $3ef321f56e16f92a$var$scheduleCallback$3 = $1c3ne.unstable_scheduleCallback, $3ef321f56e16f92a$var$cancelCallback$1 = $1c3ne.unstable_cancelCallback, $3ef321f56e16f92a$var$shouldYield = $1c3ne.unstable_shouldYield, $3ef321f56e16f92a$var$requestPaint = $1c3ne.unstable_requestPaint, $3ef321f56e16f92a$var$now = $1c3ne.unstable_now, $3ef321f56e16f92a$var$getCurrentPriorityLevel = $1c3ne.unstable_getCurrentPriorityLevel, $3ef321f56e16f92a$var$ImmediatePriority = $1c3ne.unstable_ImmediatePriority, $3ef321f56e16f92a$var$UserBlockingPriority = $1c3ne.unstable_UserBlockingPriority, $3ef321f56e16f92a$var$NormalPriority$1 = $1c3ne.unstable_NormalPriority, $3ef321f56e16f92a$var$LowPriority = $1c3ne.unstable_LowPriority, $3ef321f56e16f92a$var$IdlePriority = $1c3ne.unstable_IdlePriority, $3ef321f56e16f92a$var$log$1 = $1c3ne.log, $3ef321f56e16f92a$var$unstable_setDisableYieldValue = $1c3ne.unstable_setDisableYieldValue, $3ef321f56e16f92a$var$rendererID = null, $3ef321f56e16f92a$var$injectedHook = null;
function $3ef321f56e16f92a$var$onCommitRoot(root) {
    if ($3ef321f56e16f92a$var$injectedHook && "function" === typeof $3ef321f56e16f92a$var$injectedHook.onCommitFiberRoot) try {
        $3ef321f56e16f92a$var$injectedHook.onCommitFiberRoot($3ef321f56e16f92a$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $3ef321f56e16f92a$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $3ef321f56e16f92a$var$log$1 && $3ef321f56e16f92a$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($3ef321f56e16f92a$var$injectedHook && "function" === typeof $3ef321f56e16f92a$var$injectedHook.setStrictMode) try {
        $3ef321f56e16f92a$var$injectedHook.setStrictMode($3ef321f56e16f92a$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $3ef321f56e16f92a$var$clz32 = Math.clz32 ? Math.clz32 : $3ef321f56e16f92a$var$clz32Fallback, $3ef321f56e16f92a$var$log = Math.log, $3ef321f56e16f92a$var$LN2 = Math.LN2;
function $3ef321f56e16f92a$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($3ef321f56e16f92a$var$log(x) / $3ef321f56e16f92a$var$LN2 | 0) | 0;
}
var $3ef321f56e16f92a$var$nextTransitionLane = 128, $3ef321f56e16f92a$var$nextRetryLane = 4194304;
function $3ef321f56e16f92a$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $3ef321f56e16f92a$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $3ef321f56e16f92a$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3ef321f56e16f92a$var$claimNextTransitionLane() {
    var lane = $3ef321f56e16f92a$var$nextTransitionLane;
    $3ef321f56e16f92a$var$nextTransitionLane <<= 1;
    0 === ($3ef321f56e16f92a$var$nextTransitionLane & 4194176) && ($3ef321f56e16f92a$var$nextTransitionLane = 128);
    return lane;
}
function $3ef321f56e16f92a$var$claimNextRetryLane() {
    var lane = $3ef321f56e16f92a$var$nextRetryLane;
    $3ef321f56e16f92a$var$nextRetryLane <<= 1;
    0 === ($3ef321f56e16f92a$var$nextRetryLane & 62914560) && ($3ef321f56e16f92a$var$nextRetryLane = 4194304);
    return lane;
}
function $3ef321f56e16f92a$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $3ef321f56e16f92a$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $3ef321f56e16f92a$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $3ef321f56e16f92a$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $3ef321f56e16f92a$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $3ef321f56e16f92a$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $3ef321f56e16f92a$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $3ef321f56e16f92a$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $3ef321f56e16f92a$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $3ef321f56e16f92a$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $3ef321f56e16f92a$var$resolveUpdatePriority() {
    var updatePriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $3ef321f56e16f92a$var$getEventPriority(updatePriority.type);
}
function $3ef321f56e16f92a$var$runWithPriority(priority, fn) {
    var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    try {
        return $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $3ef321f56e16f92a$var$randomKey = Math.random().toString(36).slice(2), $3ef321f56e16f92a$var$internalInstanceKey = "__reactFiber$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalPropsKey = "__reactProps$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalContainerInstanceKey = "__reactContainer$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalEventHandlersKey = "__reactEvents$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalEventHandlerListenersKey = "__reactListeners$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalEventHandlesSetKey = "__reactHandles$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalRootNodeResourcesKey = "__reactResources$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalHoistableMarker = "__reactMarker$" + $3ef321f56e16f92a$var$randomKey;
function $3ef321f56e16f92a$var$detachDeletedInstance(node) {
    delete node[$3ef321f56e16f92a$var$internalInstanceKey];
    delete node[$3ef321f56e16f92a$var$internalPropsKey];
    delete node[$3ef321f56e16f92a$var$internalEventHandlersKey];
    delete node[$3ef321f56e16f92a$var$internalEventHandlerListenersKey];
    delete node[$3ef321f56e16f92a$var$internalEventHandlesSetKey];
}
function $3ef321f56e16f92a$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$3ef321f56e16f92a$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$3ef321f56e16f92a$var$internalContainerInstanceKey] || parentNode[$3ef321f56e16f92a$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $3ef321f56e16f92a$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$3ef321f56e16f92a$var$internalInstanceKey]) return parentNode;
                targetNode = $3ef321f56e16f92a$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $3ef321f56e16f92a$var$getInstanceFromNode(node) {
    if (node = node[$3ef321f56e16f92a$var$internalInstanceKey] || node[$3ef321f56e16f92a$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $3ef321f56e16f92a$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(33));
}
function $3ef321f56e16f92a$var$getResourcesFromRoot(root) {
    var resources = root[$3ef321f56e16f92a$var$internalRootNodeResourcesKey];
    resources || (resources = root[$3ef321f56e16f92a$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $3ef321f56e16f92a$var$markNodeAsHoistable(node) {
    node[$3ef321f56e16f92a$var$internalHoistableMarker] = !0;
}
var $3ef321f56e16f92a$var$allNativeEvents = new Set(), $3ef321f56e16f92a$var$registrationNameDependencies = {};
function $3ef321f56e16f92a$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $3ef321f56e16f92a$var$registerDirectEvent(registrationName, dependencies);
    $3ef321f56e16f92a$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $3ef321f56e16f92a$var$registerDirectEvent(registrationName, dependencies) {
    $3ef321f56e16f92a$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$3ef321f56e16f92a$var$allNativeEvents.add(dependencies[registrationName]);
}
var $3ef321f56e16f92a$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3ef321f56e16f92a$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $3ef321f56e16f92a$var$illegalAttributeNameCache = {}, $3ef321f56e16f92a$var$validatedAttributeNameCache = {};
function $3ef321f56e16f92a$var$isAttributeNameSafe(attributeName) {
    if ($3ef321f56e16f92a$var$hasOwnProperty.call($3ef321f56e16f92a$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($3ef321f56e16f92a$var$hasOwnProperty.call($3ef321f56e16f92a$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($3ef321f56e16f92a$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $3ef321f56e16f92a$var$validatedAttributeNameCache[attributeName] = !0;
    $3ef321f56e16f92a$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $3ef321f56e16f92a$var$setValueForAttribute(node, name, value) {
    if ($3ef321f56e16f92a$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $3ef321f56e16f92a$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $3ef321f56e16f92a$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $3ef321f56e16f92a$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $3ef321f56e16f92a$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $3ef321f56e16f92a$var$trackValueOnNode(node) {
    var valueField = $3ef321f56e16f92a$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $3ef321f56e16f92a$var$track(node) {
    node._valueTracker || (node._valueTracker = $3ef321f56e16f92a$var$trackValueOnNode(node));
}
function $3ef321f56e16f92a$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $3ef321f56e16f92a$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $3ef321f56e16f92a$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $3ef321f56e16f92a$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $3ef321f56e16f92a$var$getToStringValue(value);
        } else element.value !== "" + $3ef321f56e16f92a$var$getToStringValue(value) && (element.value = "" + $3ef321f56e16f92a$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $3ef321f56e16f92a$var$setDefaultValue(element, type, $3ef321f56e16f92a$var$getToStringValue(value)) : null != defaultValue ? $3ef321f56e16f92a$var$setDefaultValue(element, type, $3ef321f56e16f92a$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $3ef321f56e16f92a$var$getToStringValue(name) : element.removeAttribute("name");
}
function $3ef321f56e16f92a$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $3ef321f56e16f92a$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $3ef321f56e16f92a$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $3ef321f56e16f92a$var$setDefaultValue(node, type, value) {
    "number" === type && $3ef321f56e16f92a$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $3ef321f56e16f92a$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $3ef321f56e16f92a$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $3ef321f56e16f92a$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $3ef321f56e16f92a$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $3ef321f56e16f92a$var$getToStringValue(defaultValue) : "";
}
function $3ef321f56e16f92a$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(92));
            if ($3ef321f56e16f92a$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $3ef321f56e16f92a$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $3ef321f56e16f92a$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $3ef321f56e16f92a$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $3ef321f56e16f92a$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $3ef321f56e16f92a$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $3ef321f56e16f92a$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $3ef321f56e16f92a$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $3ef321f56e16f92a$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $3ef321f56e16f92a$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3ef321f56e16f92a$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $3ef321f56e16f92a$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $3ef321f56e16f92a$var$sanitizeURL(url) {
    return $3ef321f56e16f92a$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $3ef321f56e16f92a$var$currentReplayingEvent = null;
function $3ef321f56e16f92a$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $3ef321f56e16f92a$var$restoreTarget = null, $3ef321f56e16f92a$var$restoreQueue = null;
function $3ef321f56e16f92a$var$restoreStateOfTarget(target) {
    var internalInstance = $3ef321f56e16f92a$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$3ef321f56e16f92a$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $3ef321f56e16f92a$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$3ef321f56e16f92a$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(90));
                            $3ef321f56e16f92a$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $3ef321f56e16f92a$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $3ef321f56e16f92a$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $3ef321f56e16f92a$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $3ef321f56e16f92a$var$isInsideEventHandler = !1;
function $3ef321f56e16f92a$var$batchedUpdates$1(fn, a, b) {
    if ($3ef321f56e16f92a$var$isInsideEventHandler) return fn(a, b);
    $3ef321f56e16f92a$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($3ef321f56e16f92a$var$isInsideEventHandler = !1, null !== $3ef321f56e16f92a$var$restoreTarget || null !== $3ef321f56e16f92a$var$restoreQueue) {
            if ($3ef321f56e16f92a$var$flushSyncWork$1(), $3ef321f56e16f92a$var$restoreTarget && (a = $3ef321f56e16f92a$var$restoreTarget, fn = $3ef321f56e16f92a$var$restoreQueue, $3ef321f56e16f92a$var$restoreQueue = $3ef321f56e16f92a$var$restoreTarget = null, $3ef321f56e16f92a$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$3ef321f56e16f92a$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $3ef321f56e16f92a$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$3ef321f56e16f92a$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $3ef321f56e16f92a$var$passiveBrowserEventsSupported = !1;
if ($3ef321f56e16f92a$var$canUseDOM) try {
    var $3ef321f56e16f92a$var$options = {};
    Object.defineProperty($3ef321f56e16f92a$var$options, "passive", {
        get: function() {
            $3ef321f56e16f92a$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $3ef321f56e16f92a$var$options, $3ef321f56e16f92a$var$options);
    window.removeEventListener("test", $3ef321f56e16f92a$var$options, $3ef321f56e16f92a$var$options);
} catch (e) {
    $3ef321f56e16f92a$var$passiveBrowserEventsSupported = !1;
}
var $3ef321f56e16f92a$var$root = null, $3ef321f56e16f92a$var$startText = null, $3ef321f56e16f92a$var$fallbackText = null;
function $3ef321f56e16f92a$var$getData() {
    if ($3ef321f56e16f92a$var$fallbackText) return $3ef321f56e16f92a$var$fallbackText;
    var start, startValue = $3ef321f56e16f92a$var$startText, startLength = startValue.length, end, endValue = "value" in $3ef321f56e16f92a$var$root ? $3ef321f56e16f92a$var$root.value : $3ef321f56e16f92a$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $3ef321f56e16f92a$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $3ef321f56e16f92a$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $3ef321f56e16f92a$var$functionThatReturnsTrue() {
    return !0;
}
function $3ef321f56e16f92a$var$functionThatReturnsFalse() {
    return !1;
}
function $3ef321f56e16f92a$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $3ef321f56e16f92a$var$functionThatReturnsTrue : $3ef321f56e16f92a$var$functionThatReturnsFalse;
        this.isPropagationStopped = $3ef321f56e16f92a$var$functionThatReturnsFalse;
        return this;
    }
    $3ef321f56e16f92a$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $3ef321f56e16f92a$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $3ef321f56e16f92a$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $3ef321f56e16f92a$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $3ef321f56e16f92a$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3ef321f56e16f92a$var$SyntheticEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$EventInterface), $3ef321f56e16f92a$var$UIEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    view: 0,
    detail: 0
}), $3ef321f56e16f92a$var$SyntheticUIEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$UIEventInterface), $3ef321f56e16f92a$var$lastMovementX, $3ef321f56e16f92a$var$lastMovementY, $3ef321f56e16f92a$var$lastMouseEvent, $3ef321f56e16f92a$var$MouseEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3ef321f56e16f92a$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $3ef321f56e16f92a$var$lastMouseEvent && ($3ef321f56e16f92a$var$lastMouseEvent && "mousemove" === event.type ? ($3ef321f56e16f92a$var$lastMovementX = event.screenX - $3ef321f56e16f92a$var$lastMouseEvent.screenX, $3ef321f56e16f92a$var$lastMovementY = event.screenY - $3ef321f56e16f92a$var$lastMouseEvent.screenY) : $3ef321f56e16f92a$var$lastMovementY = $3ef321f56e16f92a$var$lastMovementX = 0, $3ef321f56e16f92a$var$lastMouseEvent = event);
        return $3ef321f56e16f92a$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $3ef321f56e16f92a$var$lastMovementY;
    }
}), $3ef321f56e16f92a$var$SyntheticMouseEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$MouseEventInterface), $3ef321f56e16f92a$var$DragEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$MouseEventInterface, {
    dataTransfer: 0
}), $3ef321f56e16f92a$var$SyntheticDragEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$DragEventInterface), $3ef321f56e16f92a$var$FocusEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$UIEventInterface, {
    relatedTarget: 0
}), $3ef321f56e16f92a$var$SyntheticFocusEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$FocusEventInterface), $3ef321f56e16f92a$var$AnimationEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3ef321f56e16f92a$var$SyntheticAnimationEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$AnimationEventInterface), $3ef321f56e16f92a$var$ClipboardEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $3ef321f56e16f92a$var$SyntheticClipboardEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$ClipboardEventInterface), $3ef321f56e16f92a$var$CompositionEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    data: 0
}), $3ef321f56e16f92a$var$SyntheticCompositionEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$CompositionEventInterface), $3ef321f56e16f92a$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3ef321f56e16f92a$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3ef321f56e16f92a$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3ef321f56e16f92a$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $3ef321f56e16f92a$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $3ef321f56e16f92a$var$getEventModifierState() {
    return $3ef321f56e16f92a$var$modifierStateGetter;
}
var $3ef321f56e16f92a$var$KeyboardEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $3ef321f56e16f92a$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $3ef321f56e16f92a$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $3ef321f56e16f92a$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3ef321f56e16f92a$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $3ef321f56e16f92a$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $3ef321f56e16f92a$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $3ef321f56e16f92a$var$SyntheticKeyboardEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$KeyboardEventInterface), $3ef321f56e16f92a$var$PointerEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3ef321f56e16f92a$var$SyntheticPointerEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$PointerEventInterface), $3ef321f56e16f92a$var$TouchEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3ef321f56e16f92a$var$getEventModifierState
}), $3ef321f56e16f92a$var$SyntheticTouchEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$TouchEventInterface), $3ef321f56e16f92a$var$TransitionEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3ef321f56e16f92a$var$SyntheticTransitionEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$TransitionEventInterface), $3ef321f56e16f92a$var$WheelEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3ef321f56e16f92a$var$SyntheticWheelEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$WheelEventInterface), $3ef321f56e16f92a$var$ToggleEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $3ef321f56e16f92a$var$SyntheticToggleEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$ToggleEventInterface), $3ef321f56e16f92a$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $3ef321f56e16f92a$var$canUseCompositionEvent = $3ef321f56e16f92a$var$canUseDOM && "CompositionEvent" in window, $3ef321f56e16f92a$var$documentMode = null;
$3ef321f56e16f92a$var$canUseDOM && "documentMode" in document && ($3ef321f56e16f92a$var$documentMode = document.documentMode);
var $3ef321f56e16f92a$var$canUseTextInputEvent = $3ef321f56e16f92a$var$canUseDOM && "TextEvent" in window && !$3ef321f56e16f92a$var$documentMode, $3ef321f56e16f92a$var$useFallbackCompositionData = $3ef321f56e16f92a$var$canUseDOM && (!$3ef321f56e16f92a$var$canUseCompositionEvent || $3ef321f56e16f92a$var$documentMode && 8 < $3ef321f56e16f92a$var$documentMode && 11 >= $3ef321f56e16f92a$var$documentMode), $3ef321f56e16f92a$var$SPACEBAR_CHAR = String.fromCharCode(32), $3ef321f56e16f92a$var$hasSpaceKeypress = !1;
function $3ef321f56e16f92a$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $3ef321f56e16f92a$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3ef321f56e16f92a$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $3ef321f56e16f92a$var$isComposing = !1;
function $3ef321f56e16f92a$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $3ef321f56e16f92a$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $3ef321f56e16f92a$var$hasSpaceKeypress = !0;
            return $3ef321f56e16f92a$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $3ef321f56e16f92a$var$SPACEBAR_CHAR && $3ef321f56e16f92a$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $3ef321f56e16f92a$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($3ef321f56e16f92a$var$isComposing) return "compositionend" === domEventName || !$3ef321f56e16f92a$var$canUseCompositionEvent && $3ef321f56e16f92a$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $3ef321f56e16f92a$var$getData(), $3ef321f56e16f92a$var$fallbackText = $3ef321f56e16f92a$var$startText = $3ef321f56e16f92a$var$root = null, $3ef321f56e16f92a$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $3ef321f56e16f92a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $3ef321f56e16f92a$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3ef321f56e16f92a$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$3ef321f56e16f92a$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $3ef321f56e16f92a$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $3ef321f56e16f92a$var$restoreTarget ? $3ef321f56e16f92a$var$restoreQueue ? $3ef321f56e16f92a$var$restoreQueue.push(target) : $3ef321f56e16f92a$var$restoreQueue = [
        target
    ] : $3ef321f56e16f92a$var$restoreTarget = target;
    inst = $3ef321f56e16f92a$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $3ef321f56e16f92a$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $3ef321f56e16f92a$var$activeElement$1 = null, $3ef321f56e16f92a$var$activeElementInst$1 = null;
function $3ef321f56e16f92a$var$runEventInBatch(dispatchQueue) {
    $3ef321f56e16f92a$var$processDispatchQueue(dispatchQueue, 0);
}
function $3ef321f56e16f92a$var$getInstIfValueChanged(targetInst) {
    var targetNode = $3ef321f56e16f92a$var$getNodeFromInstance(targetInst);
    if ($3ef321f56e16f92a$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $3ef321f56e16f92a$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $3ef321f56e16f92a$var$isInputEventSupported = !1;
if ($3ef321f56e16f92a$var$canUseDOM) {
    var $3ef321f56e16f92a$var$JSCompiler_inline_result$jscomp$283;
    if ($3ef321f56e16f92a$var$canUseDOM) {
        var $3ef321f56e16f92a$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$3ef321f56e16f92a$var$isSupported$jscomp$inline_418) {
            var $3ef321f56e16f92a$var$element$jscomp$inline_419 = document.createElement("div");
            $3ef321f56e16f92a$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $3ef321f56e16f92a$var$isSupported$jscomp$inline_418 = "function" === typeof $3ef321f56e16f92a$var$element$jscomp$inline_419.oninput;
        }
        $3ef321f56e16f92a$var$JSCompiler_inline_result$jscomp$283 = $3ef321f56e16f92a$var$isSupported$jscomp$inline_418;
    } else $3ef321f56e16f92a$var$JSCompiler_inline_result$jscomp$283 = !1;
    $3ef321f56e16f92a$var$isInputEventSupported = $3ef321f56e16f92a$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $3ef321f56e16f92a$var$stopWatchingForValueChange() {
    $3ef321f56e16f92a$var$activeElement$1 && ($3ef321f56e16f92a$var$activeElement$1.detachEvent("onpropertychange", $3ef321f56e16f92a$var$handlePropertyChange), $3ef321f56e16f92a$var$activeElementInst$1 = $3ef321f56e16f92a$var$activeElement$1 = null);
}
function $3ef321f56e16f92a$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $3ef321f56e16f92a$var$getInstIfValueChanged($3ef321f56e16f92a$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $3ef321f56e16f92a$var$createAndAccumulateChangeEvent(dispatchQueue, $3ef321f56e16f92a$var$activeElementInst$1, nativeEvent, $3ef321f56e16f92a$var$getEventTarget(nativeEvent));
        $3ef321f56e16f92a$var$batchedUpdates$1($3ef321f56e16f92a$var$runEventInBatch, dispatchQueue);
    }
}
function $3ef321f56e16f92a$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($3ef321f56e16f92a$var$stopWatchingForValueChange(), $3ef321f56e16f92a$var$activeElement$1 = target, $3ef321f56e16f92a$var$activeElementInst$1 = targetInst, $3ef321f56e16f92a$var$activeElement$1.attachEvent("onpropertychange", $3ef321f56e16f92a$var$handlePropertyChange)) : "focusout" === domEventName && $3ef321f56e16f92a$var$stopWatchingForValueChange();
}
function $3ef321f56e16f92a$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $3ef321f56e16f92a$var$getInstIfValueChanged($3ef321f56e16f92a$var$activeElementInst$1);
}
function $3ef321f56e16f92a$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $3ef321f56e16f92a$var$getInstIfValueChanged(targetInst);
}
function $3ef321f56e16f92a$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $3ef321f56e16f92a$var$getInstIfValueChanged(targetInst);
}
function $3ef321f56e16f92a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $3ef321f56e16f92a$var$objectIs = "function" === typeof Object.is ? Object.is : $3ef321f56e16f92a$var$is;
function $3ef321f56e16f92a$var$shallowEqual(objA, objB) {
    if ($3ef321f56e16f92a$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$3ef321f56e16f92a$var$hasOwnProperty.call(objB, currentKey) || !$3ef321f56e16f92a$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $3ef321f56e16f92a$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $3ef321f56e16f92a$var$getNodeForCharacterOffset(root, offset) {
    var node = $3ef321f56e16f92a$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $3ef321f56e16f92a$var$getLeafNode(node);
    }
}
function $3ef321f56e16f92a$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $3ef321f56e16f92a$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $3ef321f56e16f92a$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $3ef321f56e16f92a$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $3ef321f56e16f92a$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $3ef321f56e16f92a$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $3ef321f56e16f92a$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $3ef321f56e16f92a$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $3ef321f56e16f92a$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $3ef321f56e16f92a$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $3ef321f56e16f92a$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $3ef321f56e16f92a$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $3ef321f56e16f92a$var$skipSelectionChangeEvent = $3ef321f56e16f92a$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $3ef321f56e16f92a$var$activeElement = null, $3ef321f56e16f92a$var$activeElementInst = null, $3ef321f56e16f92a$var$lastSelection = null, $3ef321f56e16f92a$var$mouseDown = !1;
function $3ef321f56e16f92a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $3ef321f56e16f92a$var$mouseDown || null == $3ef321f56e16f92a$var$activeElement || $3ef321f56e16f92a$var$activeElement !== $3ef321f56e16f92a$var$getActiveElement(doc) || (doc = $3ef321f56e16f92a$var$activeElement, "selectionStart" in doc && $3ef321f56e16f92a$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $3ef321f56e16f92a$var$lastSelection && $3ef321f56e16f92a$var$shallowEqual($3ef321f56e16f92a$var$lastSelection, doc) || ($3ef321f56e16f92a$var$lastSelection = doc, doc = $3ef321f56e16f92a$var$accumulateTwoPhaseListeners($3ef321f56e16f92a$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $3ef321f56e16f92a$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $3ef321f56e16f92a$var$activeElement)));
}
function $3ef321f56e16f92a$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $3ef321f56e16f92a$var$vendorPrefixes = {
    animationend: $3ef321f56e16f92a$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $3ef321f56e16f92a$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $3ef321f56e16f92a$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $3ef321f56e16f92a$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $3ef321f56e16f92a$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $3ef321f56e16f92a$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $3ef321f56e16f92a$var$makePrefixMap("Transition", "TransitionEnd")
}, $3ef321f56e16f92a$var$prefixedEventNames = {}, $3ef321f56e16f92a$var$style = {};
$3ef321f56e16f92a$var$canUseDOM && ($3ef321f56e16f92a$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $3ef321f56e16f92a$var$vendorPrefixes.animationend.animation, delete $3ef321f56e16f92a$var$vendorPrefixes.animationiteration.animation, delete $3ef321f56e16f92a$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $3ef321f56e16f92a$var$vendorPrefixes.transitionend.transition);
function $3ef321f56e16f92a$var$getVendorPrefixedEventName(eventName) {
    if ($3ef321f56e16f92a$var$prefixedEventNames[eventName]) return $3ef321f56e16f92a$var$prefixedEventNames[eventName];
    if (!$3ef321f56e16f92a$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $3ef321f56e16f92a$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $3ef321f56e16f92a$var$style) return $3ef321f56e16f92a$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $3ef321f56e16f92a$var$ANIMATION_END = $3ef321f56e16f92a$var$getVendorPrefixedEventName("animationend"), $3ef321f56e16f92a$var$ANIMATION_ITERATION = $3ef321f56e16f92a$var$getVendorPrefixedEventName("animationiteration"), $3ef321f56e16f92a$var$ANIMATION_START = $3ef321f56e16f92a$var$getVendorPrefixedEventName("animationstart"), $3ef321f56e16f92a$var$TRANSITION_RUN = $3ef321f56e16f92a$var$getVendorPrefixedEventName("transitionrun"), $3ef321f56e16f92a$var$TRANSITION_START = $3ef321f56e16f92a$var$getVendorPrefixedEventName("transitionstart"), $3ef321f56e16f92a$var$TRANSITION_CANCEL = $3ef321f56e16f92a$var$getVendorPrefixedEventName("transitioncancel"), $3ef321f56e16f92a$var$TRANSITION_END = $3ef321f56e16f92a$var$getVendorPrefixedEventName("transitionend"), $3ef321f56e16f92a$var$topLevelEventsToReactNames = new Map(), $3ef321f56e16f92a$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $3ef321f56e16f92a$var$registerSimpleEvent(domEventName, reactName) {
    $3ef321f56e16f92a$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $3ef321f56e16f92a$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $3ef321f56e16f92a$var$concurrentQueues = [], $3ef321f56e16f92a$var$concurrentQueuesIndex = 0, $3ef321f56e16f92a$var$concurrentlyUpdatedLanes = 0;
function $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $3ef321f56e16f92a$var$concurrentQueuesIndex, i = $3ef321f56e16f92a$var$concurrentlyUpdatedLanes = $3ef321f56e16f92a$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $3ef321f56e16f92a$var$concurrentQueues[i];
        $3ef321f56e16f92a$var$concurrentQueues[i++] = null;
        var queue = $3ef321f56e16f92a$var$concurrentQueues[i];
        $3ef321f56e16f92a$var$concurrentQueues[i++] = null;
        var update = $3ef321f56e16f92a$var$concurrentQueues[i];
        $3ef321f56e16f92a$var$concurrentQueues[i++] = null;
        var lane = $3ef321f56e16f92a$var$concurrentQueues[i];
        $3ef321f56e16f92a$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $3ef321f56e16f92a$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $3ef321f56e16f92a$var$concurrentQueues[$3ef321f56e16f92a$var$concurrentQueuesIndex++] = fiber;
    $3ef321f56e16f92a$var$concurrentQueues[$3ef321f56e16f92a$var$concurrentQueuesIndex++] = queue;
    $3ef321f56e16f92a$var$concurrentQueues[$3ef321f56e16f92a$var$concurrentQueuesIndex++] = update;
    $3ef321f56e16f92a$var$concurrentQueues[$3ef321f56e16f92a$var$concurrentQueuesIndex++] = lane;
    $3ef321f56e16f92a$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $3ef321f56e16f92a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $3ef321f56e16f92a$var$getRootForUpdatedFiber(fiber);
}
function $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, null, null, lane);
    return $3ef321f56e16f92a$var$getRootForUpdatedFiber(fiber);
}
function $3ef321f56e16f92a$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $3ef321f56e16f92a$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $3ef321f56e16f92a$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $3ef321f56e16f92a$var$nestedUpdateCount) throw $3ef321f56e16f92a$var$nestedUpdateCount = 0, $3ef321f56e16f92a$var$rootWithNestedUpdates = null, Error($3ef321f56e16f92a$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $3ef321f56e16f92a$var$emptyContextObject = {}, $3ef321f56e16f92a$var$CapturedStacks = new WeakMap();
function $3ef321f56e16f92a$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $3ef321f56e16f92a$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $3ef321f56e16f92a$var$getStackByFiberInDevAndProd(source)
        };
        $3ef321f56e16f92a$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $3ef321f56e16f92a$var$getStackByFiberInDevAndProd(source)
    };
}
var $3ef321f56e16f92a$var$forkStack = [], $3ef321f56e16f92a$var$forkStackIndex = 0, $3ef321f56e16f92a$var$treeForkProvider = null, $3ef321f56e16f92a$var$treeForkCount = 0, $3ef321f56e16f92a$var$idStack = [], $3ef321f56e16f92a$var$idStackIndex = 0, $3ef321f56e16f92a$var$treeContextProvider = null, $3ef321f56e16f92a$var$treeContextId = 1, $3ef321f56e16f92a$var$treeContextOverflow = "";
function $3ef321f56e16f92a$var$pushTreeFork(workInProgress, totalChildren) {
    $3ef321f56e16f92a$var$forkStack[$3ef321f56e16f92a$var$forkStackIndex++] = $3ef321f56e16f92a$var$treeForkCount;
    $3ef321f56e16f92a$var$forkStack[$3ef321f56e16f92a$var$forkStackIndex++] = $3ef321f56e16f92a$var$treeForkProvider;
    $3ef321f56e16f92a$var$treeForkProvider = workInProgress;
    $3ef321f56e16f92a$var$treeForkCount = totalChildren;
}
function $3ef321f56e16f92a$var$pushTreeId(workInProgress, totalChildren, index) {
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextId;
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextOverflow;
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextProvider;
    $3ef321f56e16f92a$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $3ef321f56e16f92a$var$treeContextId;
    workInProgress = $3ef321f56e16f92a$var$treeContextOverflow;
    var baseLength = 32 - $3ef321f56e16f92a$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $3ef321f56e16f92a$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $3ef321f56e16f92a$var$treeContextId = 1 << 32 - $3ef321f56e16f92a$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $3ef321f56e16f92a$var$treeContextOverflow = length + workInProgress;
    } else $3ef321f56e16f92a$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $3ef321f56e16f92a$var$treeContextOverflow = workInProgress;
}
function $3ef321f56e16f92a$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($3ef321f56e16f92a$var$pushTreeFork(workInProgress, 1), $3ef321f56e16f92a$var$pushTreeId(workInProgress, 1, 0));
}
function $3ef321f56e16f92a$var$popTreeContext(workInProgress) {
    for(; workInProgress === $3ef321f56e16f92a$var$treeForkProvider;)$3ef321f56e16f92a$var$treeForkProvider = $3ef321f56e16f92a$var$forkStack[--$3ef321f56e16f92a$var$forkStackIndex], $3ef321f56e16f92a$var$forkStack[$3ef321f56e16f92a$var$forkStackIndex] = null, $3ef321f56e16f92a$var$treeForkCount = $3ef321f56e16f92a$var$forkStack[--$3ef321f56e16f92a$var$forkStackIndex], $3ef321f56e16f92a$var$forkStack[$3ef321f56e16f92a$var$forkStackIndex] = null;
    for(; workInProgress === $3ef321f56e16f92a$var$treeContextProvider;)$3ef321f56e16f92a$var$treeContextProvider = $3ef321f56e16f92a$var$idStack[--$3ef321f56e16f92a$var$idStackIndex], $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex] = null, $3ef321f56e16f92a$var$treeContextOverflow = $3ef321f56e16f92a$var$idStack[--$3ef321f56e16f92a$var$idStackIndex], $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex] = null, $3ef321f56e16f92a$var$treeContextId = $3ef321f56e16f92a$var$idStack[--$3ef321f56e16f92a$var$idStackIndex], $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex] = null;
}
var $3ef321f56e16f92a$var$hydrationParentFiber = null, $3ef321f56e16f92a$var$nextHydratableInstance = null, $3ef321f56e16f92a$var$isHydrating = !1, $3ef321f56e16f92a$var$hydrationErrors = null, $3ef321f56e16f92a$var$rootOrSingletonContext = !1, $3ef321f56e16f92a$var$HydrationMismatchException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(519));
function $3ef321f56e16f92a$var$throwOnHydrationMismatch(fiber) {
    var error = Error($3ef321f56e16f92a$var$formatProdErrorMessage(418, ""));
    $3ef321f56e16f92a$var$queueHydrationError($3ef321f56e16f92a$var$createCapturedValueAtFiber(error, fiber));
    throw $3ef321f56e16f92a$var$HydrationMismatchException;
}
function $3ef321f56e16f92a$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$3ef321f56e16f92a$var$internalInstanceKey] = fiber;
    instance[$3ef321f56e16f92a$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("cancel", instance);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $3ef321f56e16f92a$var$mediaEventTypes.length; type++)$3ef321f56e16f92a$var$listenToNonDelegatedEvent($3ef321f56e16f92a$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", instance);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", instance);
            $3ef321f56e16f92a$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $3ef321f56e16f92a$var$track(instance);
            break;
        case "select":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", instance), $3ef321f56e16f92a$var$initTextarea(instance, props.value, props.defaultValue, props.children), $3ef321f56e16f92a$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $3ef321f56e16f92a$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($3ef321f56e16f92a$var$listenToNonDelegatedEvent("beforetoggle", instance), $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $3ef321f56e16f92a$var$noop$1), instance = !0) : instance = !1;
    instance || $3ef321f56e16f92a$var$throwOnHydrationMismatch(fiber);
}
function $3ef321f56e16f92a$var$popToNextHostParent(fiber) {
    for($3ef321f56e16f92a$var$hydrationParentFiber = fiber.return; $3ef321f56e16f92a$var$hydrationParentFiber;)switch($3ef321f56e16f92a$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $3ef321f56e16f92a$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $3ef321f56e16f92a$var$rootOrSingletonContext = !1;
            return;
        default:
            $3ef321f56e16f92a$var$hydrationParentFiber = $3ef321f56e16f92a$var$hydrationParentFiber.return;
    }
}
function $3ef321f56e16f92a$var$popHydrationState(fiber) {
    if (fiber !== $3ef321f56e16f92a$var$hydrationParentFiber) return !1;
    if (!$3ef321f56e16f92a$var$isHydrating) return $3ef321f56e16f92a$var$popToNextHostParent(fiber), $3ef321f56e16f92a$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $3ef321f56e16f92a$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $3ef321f56e16f92a$var$nextHydratableInstance && $3ef321f56e16f92a$var$throwOnHydrationMismatch(fiber);
    $3ef321f56e16f92a$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $3ef321f56e16f92a$var$nextHydratableInstance = null;
        }
    } else $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$hydrationParentFiber ? $3ef321f56e16f92a$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $3ef321f56e16f92a$var$resetHydrationState() {
    $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$hydrationParentFiber = null;
    $3ef321f56e16f92a$var$isHydrating = !1;
}
function $3ef321f56e16f92a$var$queueHydrationError(error) {
    null === $3ef321f56e16f92a$var$hydrationErrors ? $3ef321f56e16f92a$var$hydrationErrors = [
        error
    ] : $3ef321f56e16f92a$var$hydrationErrors.push(error);
}
var $3ef321f56e16f92a$var$SuspenseException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(460)), $3ef321f56e16f92a$var$SuspenseyCommitException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(474)), $3ef321f56e16f92a$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $3ef321f56e16f92a$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $3ef321f56e16f92a$var$noop$3() {}
function $3ef321f56e16f92a$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($3ef321f56e16f92a$var$noop$3, $3ef321f56e16f92a$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $3ef321f56e16f92a$var$SuspenseException) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($3ef321f56e16f92a$var$noop$3, $3ef321f56e16f92a$var$noop$3);
            else {
                thenableState = $3ef321f56e16f92a$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $3ef321f56e16f92a$var$SuspenseException) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $3ef321f56e16f92a$var$suspendedThenable = thenable;
            throw $3ef321f56e16f92a$var$SuspenseException;
    }
}
var $3ef321f56e16f92a$var$suspendedThenable = null;
function $3ef321f56e16f92a$var$getSuspendedThenable() {
    if (null === $3ef321f56e16f92a$var$suspendedThenable) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(459));
    var thenable = $3ef321f56e16f92a$var$suspendedThenable;
    $3ef321f56e16f92a$var$suspendedThenable = null;
    return thenable;
}
var $3ef321f56e16f92a$var$thenableState$1 = null, $3ef321f56e16f92a$var$thenableIndexCounter$1 = 0;
function $3ef321f56e16f92a$var$unwrapThenable(thenable) {
    var index = $3ef321f56e16f92a$var$thenableIndexCounter$1;
    $3ef321f56e16f92a$var$thenableIndexCounter$1 += 1;
    null === $3ef321f56e16f92a$var$thenableState$1 && ($3ef321f56e16f92a$var$thenableState$1 = []);
    return $3ef321f56e16f92a$var$trackUsedThenable($3ef321f56e16f92a$var$thenableState$1, thenable, index);
}
function $3ef321f56e16f92a$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $3ef321f56e16f92a$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $3ef321f56e16f92a$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $3ef321f56e16f92a$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $3ef321f56e16f92a$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $3ef321f56e16f92a$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $3ef321f56e16f92a$var$REACT_LAZY_TYPE && $3ef321f56e16f92a$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $3ef321f56e16f92a$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $3ef321f56e16f92a$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $3ef321f56e16f92a$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $3ef321f56e16f92a$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $3ef321f56e16f92a$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $3ef321f56e16f92a$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE:
                    return lanes = $3ef321f56e16f92a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $3ef321f56e16f92a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
                    return newChild = $3ef321f56e16f92a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($3ef321f56e16f92a$var$isArrayImpl(newChild) || $3ef321f56e16f92a$var$getIteratorFn(newChild)) return newChild = $3ef321f56e16f92a$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $3ef321f56e16f92a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $3ef321f56e16f92a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $3ef321f56e16f92a$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($3ef321f56e16f92a$var$isArrayImpl(newChild) || $3ef321f56e16f92a$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $3ef321f56e16f92a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $3ef321f56e16f92a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $3ef321f56e16f92a$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($3ef321f56e16f92a$var$isArrayImpl(newChild) || $3ef321f56e16f92a$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $3ef321f56e16f92a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $3ef321f56e16f92a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $3ef321f56e16f92a$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $3ef321f56e16f92a$var$REACT_LAZY_TYPE && $3ef321f56e16f92a$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $3ef321f56e16f92a$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE ? (lanes = $3ef321f56e16f92a$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $3ef321f56e16f92a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $3ef321f56e16f92a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $3ef321f56e16f92a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($3ef321f56e16f92a$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($3ef321f56e16f92a$var$getIteratorFn(newChild)) {
                key = $3ef321f56e16f92a$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $3ef321f56e16f92a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $3ef321f56e16f92a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $3ef321f56e16f92a$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $3ef321f56e16f92a$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $3ef321f56e16f92a$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $3ef321f56e16f92a$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $3ef321f56e16f92a$var$SuspenseException) throw x;
            var fiber = $3ef321f56e16f92a$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $3ef321f56e16f92a$var$reconcileChildFibers = $3ef321f56e16f92a$var$createChildReconciler(!0), $3ef321f56e16f92a$var$mountChildFibers = $3ef321f56e16f92a$var$createChildReconciler(!1), $3ef321f56e16f92a$var$currentTreeHiddenStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$prevEntangledRenderLanesCursor = $3ef321f56e16f92a$var$createCursor(0);
function $3ef321f56e16f92a$var$pushHiddenContext(fiber, context) {
    fiber = $3ef321f56e16f92a$var$entangledRenderLanes;
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$prevEntangledRenderLanesCursor, fiber);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$currentTreeHiddenStackCursor, context);
    $3ef321f56e16f92a$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $3ef321f56e16f92a$var$reuseHiddenContextOnStack() {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$prevEntangledRenderLanesCursor, $3ef321f56e16f92a$var$entangledRenderLanes);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$currentTreeHiddenStackCursor, $3ef321f56e16f92a$var$currentTreeHiddenStackCursor.current);
}
function $3ef321f56e16f92a$var$popHiddenContext() {
    $3ef321f56e16f92a$var$entangledRenderLanes = $3ef321f56e16f92a$var$prevEntangledRenderLanesCursor.current;
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$currentTreeHiddenStackCursor);
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$prevEntangledRenderLanesCursor);
}
var $3ef321f56e16f92a$var$suspenseHandlerStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$shellBoundary = null;
function $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current & 1);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseHandlerStackCursor, handler);
    null === $3ef321f56e16f92a$var$shellBoundary && (null === current || null !== $3ef321f56e16f92a$var$currentTreeHiddenStackCursor.current ? $3ef321f56e16f92a$var$shellBoundary = handler : null !== current.memoizedState && ($3ef321f56e16f92a$var$shellBoundary = handler));
}
function $3ef321f56e16f92a$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current), $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseHandlerStackCursor, fiber), null === $3ef321f56e16f92a$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($3ef321f56e16f92a$var$shellBoundary = fiber);
        }
    } else $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(fiber);
}
function $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack() {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseHandlerStackCursor, $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current);
}
function $3ef321f56e16f92a$var$popSuspenseHandler(fiber) {
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseHandlerStackCursor);
    $3ef321f56e16f92a$var$shellBoundary === fiber && ($3ef321f56e16f92a$var$shellBoundary = null);
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseStackCursor);
}
var $3ef321f56e16f92a$var$suspenseStackCursor = $3ef321f56e16f92a$var$createCursor(0);
function $3ef321f56e16f92a$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $3ef321f56e16f92a$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $3ef321f56e16f92a$var$scheduleCallback$2 = $1c3ne.unstable_scheduleCallback, $3ef321f56e16f92a$var$NormalPriority = $1c3ne.unstable_NormalPriority, $3ef321f56e16f92a$var$CacheContext = {
    $$typeof: $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $3ef321f56e16f92a$var$createCache() {
    return {
        controller: new $3ef321f56e16f92a$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $3ef321f56e16f92a$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $3ef321f56e16f92a$var$scheduleCallback$2($3ef321f56e16f92a$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $3ef321f56e16f92a$var$currentEntangledListeners = null, $3ef321f56e16f92a$var$currentEntangledPendingCount = 0, $3ef321f56e16f92a$var$currentEntangledLane = 0, $3ef321f56e16f92a$var$currentEntangledActionThenable = null;
function $3ef321f56e16f92a$var$entangleAsyncAction(transition, thenable) {
    if (null === $3ef321f56e16f92a$var$currentEntangledListeners) {
        var entangledListeners = $3ef321f56e16f92a$var$currentEntangledListeners = [];
        $3ef321f56e16f92a$var$currentEntangledPendingCount = 0;
        $3ef321f56e16f92a$var$currentEntangledLane = $3ef321f56e16f92a$var$requestTransitionLane();
        $3ef321f56e16f92a$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $3ef321f56e16f92a$var$currentEntangledPendingCount++;
    thenable.then($3ef321f56e16f92a$var$pingEngtangledActionScope, $3ef321f56e16f92a$var$pingEngtangledActionScope);
    return thenable;
}
function $3ef321f56e16f92a$var$pingEngtangledActionScope() {
    if (0 === --$3ef321f56e16f92a$var$currentEntangledPendingCount && null !== $3ef321f56e16f92a$var$currentEntangledListeners) {
        null !== $3ef321f56e16f92a$var$currentEntangledActionThenable && ($3ef321f56e16f92a$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $3ef321f56e16f92a$var$currentEntangledListeners;
        $3ef321f56e16f92a$var$currentEntangledListeners = null;
        $3ef321f56e16f92a$var$currentEntangledLane = 0;
        $3ef321f56e16f92a$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $3ef321f56e16f92a$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $3ef321f56e16f92a$var$prevOnStartTransitionFinish = $3ef321f56e16f92a$var$ReactSharedInternals.S;
$3ef321f56e16f92a$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $3ef321f56e16f92a$var$entangleAsyncAction(transition, returnValue);
    null !== $3ef321f56e16f92a$var$prevOnStartTransitionFinish && $3ef321f56e16f92a$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $3ef321f56e16f92a$var$resumedCache = $3ef321f56e16f92a$var$createCursor(null);
function $3ef321f56e16f92a$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $3ef321f56e16f92a$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $3ef321f56e16f92a$var$workInProgressRoot.pooledCache;
}
function $3ef321f56e16f92a$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$resumedCache, $3ef321f56e16f92a$var$resumedCache.current) : $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$resumedCache, prevCachePool.pool);
}
function $3ef321f56e16f92a$var$getSuspendedCache() {
    var cacheFromPool = $3ef321f56e16f92a$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $3ef321f56e16f92a$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $3ef321f56e16f92a$var$renderLanes = 0, $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null, $3ef321f56e16f92a$var$currentHook = null, $3ef321f56e16f92a$var$workInProgressHook = null, $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate = !1, $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $3ef321f56e16f92a$var$localIdCounter = 0, $3ef321f56e16f92a$var$thenableIndexCounter = 0, $3ef321f56e16f92a$var$thenableState = null, $3ef321f56e16f92a$var$globalClientIdCounter = 0;
function $3ef321f56e16f92a$var$throwInvalidHookError() {
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(321));
}
function $3ef321f56e16f92a$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$3ef321f56e16f92a$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $3ef321f56e16f92a$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $3ef321f56e16f92a$var$renderLanes = nextRenderLanes;
    $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $3ef321f56e16f92a$var$HooksDispatcherOnMount : $3ef321f56e16f92a$var$HooksDispatcherOnUpdate;
    $3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $3ef321f56e16f92a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $3ef321f56e16f92a$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $3ef321f56e16f92a$var$finishRenderingHooks(current) {
    $3ef321f56e16f92a$var$ReactSharedInternals.H = $3ef321f56e16f92a$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $3ef321f56e16f92a$var$currentHook && null !== $3ef321f56e16f92a$var$currentHook.next;
    $3ef321f56e16f92a$var$renderLanes = 0;
    $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$currentHook = $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null;
    $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate = !1;
    $3ef321f56e16f92a$var$thenableIndexCounter = 0;
    $3ef321f56e16f92a$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(300));
    null === current || $3ef321f56e16f92a$var$didReceiveUpdate || (current = current.dependencies, null !== current && $3ef321f56e16f92a$var$checkIfContextChanged(current) && ($3ef321f56e16f92a$var$didReceiveUpdate = !0));
}
function $3ef321f56e16f92a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass && ($3ef321f56e16f92a$var$thenableState = null);
        $3ef321f56e16f92a$var$thenableIndexCounter = 0;
        $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $3ef321f56e16f92a$var$ReactSharedInternals.H = $3ef321f56e16f92a$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $3ef321f56e16f92a$var$TransitionAwareHostComponent() {
    var dispatcher = $3ef321f56e16f92a$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $3ef321f56e16f92a$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $3ef321f56e16f92a$var$currentHook ? $3ef321f56e16f92a$var$currentHook.memoizedState : null) !== dispatcher && ($3ef321f56e16f92a$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $3ef321f56e16f92a$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $3ef321f56e16f92a$var$localIdCounter;
    $3ef321f56e16f92a$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $3ef321f56e16f92a$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $3ef321f56e16f92a$var$resetHooksOnUnwind(workInProgress) {
    if ($3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate = !1;
    }
    $3ef321f56e16f92a$var$renderLanes = 0;
    $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$currentHook = $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null;
    $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $3ef321f56e16f92a$var$thenableIndexCounter = $3ef321f56e16f92a$var$localIdCounter = 0;
    $3ef321f56e16f92a$var$thenableState = null;
}
function $3ef321f56e16f92a$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3ef321f56e16f92a$var$workInProgressHook ? $3ef321f56e16f92a$var$currentlyRenderingFiber$1.memoizedState = $3ef321f56e16f92a$var$workInProgressHook = hook : $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$workInProgressHook.next = hook;
    return $3ef321f56e16f92a$var$workInProgressHook;
}
function $3ef321f56e16f92a$var$updateWorkInProgressHook() {
    if (null === $3ef321f56e16f92a$var$currentHook) {
        var nextCurrentHook = $3ef321f56e16f92a$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $3ef321f56e16f92a$var$currentHook.next;
    var nextWorkInProgressHook = null === $3ef321f56e16f92a$var$workInProgressHook ? $3ef321f56e16f92a$var$currentlyRenderingFiber$1.memoizedState : $3ef321f56e16f92a$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $3ef321f56e16f92a$var$workInProgressHook = nextWorkInProgressHook, $3ef321f56e16f92a$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $3ef321f56e16f92a$var$currentlyRenderingFiber$1.alternate) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(467));
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(310));
        }
        $3ef321f56e16f92a$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $3ef321f56e16f92a$var$currentHook.memoizedState,
            baseState: $3ef321f56e16f92a$var$currentHook.baseState,
            baseQueue: $3ef321f56e16f92a$var$currentHook.baseQueue,
            queue: $3ef321f56e16f92a$var$currentHook.queue,
            next: null
        };
        null === $3ef321f56e16f92a$var$workInProgressHook ? $3ef321f56e16f92a$var$currentlyRenderingFiber$1.memoizedState = $3ef321f56e16f92a$var$workInProgressHook = nextCurrentHook : $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$workInProgressHook.next = nextCurrentHook;
    }
    return $3ef321f56e16f92a$var$workInProgressHook;
}
var $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue;
$3ef321f56e16f92a$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $3ef321f56e16f92a$var$useThenable(thenable) {
    var index = $3ef321f56e16f92a$var$thenableIndexCounter;
    $3ef321f56e16f92a$var$thenableIndexCounter += 1;
    null === $3ef321f56e16f92a$var$thenableState && ($3ef321f56e16f92a$var$thenableState = []);
    thenable = $3ef321f56e16f92a$var$trackUsedThenable($3ef321f56e16f92a$var$thenableState, thenable, index);
    index = $3ef321f56e16f92a$var$currentlyRenderingFiber$1;
    null === (null === $3ef321f56e16f92a$var$workInProgressHook ? index.memoizedState : $3ef321f56e16f92a$var$workInProgressHook.next) && (index = index.alternate, $3ef321f56e16f92a$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $3ef321f56e16f92a$var$HooksDispatcherOnMount : $3ef321f56e16f92a$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $3ef321f56e16f92a$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $3ef321f56e16f92a$var$useThenable(usable);
        if (usable.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return $3ef321f56e16f92a$var$readContext(usable);
    }
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(438, String(usable)));
}
function $3ef321f56e16f92a$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $3ef321f56e16f92a$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $3ef321f56e16f92a$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue(), $3ef321f56e16f92a$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $3ef321f56e16f92a$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $3ef321f56e16f92a$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $3ef321f56e16f92a$var$updateReducer(reducer) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    return $3ef321f56e16f92a$var$updateReducerImpl(hook, $3ef321f56e16f92a$var$currentHook, reducer);
}
function $3ef321f56e16f92a$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($3ef321f56e16f92a$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $3ef321f56e16f92a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($3ef321f56e16f92a$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $3ef321f56e16f92a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $3ef321f56e16f92a$var$currentlyRenderingFiber$1.lanes |= revertLane, $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $3ef321f56e16f92a$var$currentlyRenderingFiber$1.lanes |= updateLane, $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$3ef321f56e16f92a$var$objectIs(pendingQueue, hook.memoizedState) && ($3ef321f56e16f92a$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $3ef321f56e16f92a$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $3ef321f56e16f92a$var$rerenderReducer(reducer) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $3ef321f56e16f92a$var$objectIs(newState, hook.memoizedState) || ($3ef321f56e16f92a$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $3ef321f56e16f92a$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $3ef321f56e16f92a$var$currentlyRenderingFiber$1, hook = $3ef321f56e16f92a$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $3ef321f56e16f92a$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$3ef321f56e16f92a$var$objectIs(($3ef321f56e16f92a$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $3ef321f56e16f92a$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $3ef321f56e16f92a$var$updateEffect($3ef321f56e16f92a$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $3ef321f56e16f92a$var$workInProgressHook && $3ef321f56e16f92a$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $3ef321f56e16f92a$var$pushEffect(9, $3ef321f56e16f92a$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $3ef321f56e16f92a$var$workInProgressRoot) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($3ef321f56e16f92a$var$renderLanes & 60) || $3ef321f56e16f92a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $3ef321f56e16f92a$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $3ef321f56e16f92a$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue(), $3ef321f56e16f92a$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $3ef321f56e16f92a$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $3ef321f56e16f92a$var$checkIfSnapshotChanged(inst) && $3ef321f56e16f92a$var$forceStoreRerender(fiber);
}
function $3ef321f56e16f92a$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $3ef321f56e16f92a$var$checkIfSnapshotChanged(inst) && $3ef321f56e16f92a$var$forceStoreRerender(fiber);
    });
}
function $3ef321f56e16f92a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$3ef321f56e16f92a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $3ef321f56e16f92a$var$forceStoreRerender(fiber) {
    var root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $3ef321f56e16f92a$var$mountStateImpl(initialState) {
    var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3ef321f56e16f92a$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $3ef321f56e16f92a$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $3ef321f56e16f92a$var$updateReducerImpl(hook, $3ef321f56e16f92a$var$currentHook, "function" === typeof reducer ? reducer : $3ef321f56e16f92a$var$basicStateReducer);
}
function $3ef321f56e16f92a$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $3ef321f56e16f92a$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $3ef321f56e16f92a$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $3ef321f56e16f92a$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T, currentTransition = {};
        $3ef321f56e16f92a$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $3ef321f56e16f92a$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $3ef321f56e16f92a$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $3ef321f56e16f92a$var$onActionError(actionQueue, node, error);
        } finally{
            $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $3ef321f56e16f92a$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $3ef321f56e16f92a$var$onActionError(actionQueue, node, error$60);
    }
}
function $3ef321f56e16f92a$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $3ef321f56e16f92a$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $3ef321f56e16f92a$var$onActionError(actionQueue, node, error);
    }) : $3ef321f56e16f92a$var$onActionSuccess(actionQueue, node, returnValue);
}
function $3ef321f56e16f92a$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $3ef321f56e16f92a$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $3ef321f56e16f92a$var$runActionStateAction(actionQueue, nextState)));
}
function $3ef321f56e16f92a$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $3ef321f56e16f92a$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $3ef321f56e16f92a$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $3ef321f56e16f92a$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $3ef321f56e16f92a$var$mountActionState(action, initialStateProp) {
    if ($3ef321f56e16f92a$var$isHydrating) {
        var ssrFormState = $3ef321f56e16f92a$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $3ef321f56e16f92a$var$currentlyRenderingFiber$1;
                if ($3ef321f56e16f92a$var$isHydrating) {
                    if ($3ef321f56e16f92a$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $3ef321f56e16f92a$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $3ef321f56e16f92a$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $3ef321f56e16f92a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $3ef321f56e16f92a$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3ef321f56e16f92a$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $3ef321f56e16f92a$var$dispatchSetState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $3ef321f56e16f92a$var$mountStateImpl(!1);
    inRootOrSingleton = $3ef321f56e16f92a$var$dispatchOptimisticSetState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $3ef321f56e16f92a$var$dispatchActionState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $3ef321f56e16f92a$var$updateActionState(action) {
    var stateHook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    return $3ef321f56e16f92a$var$updateActionStateImpl(stateHook, $3ef321f56e16f92a$var$currentHook, action);
}
function $3ef321f56e16f92a$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $3ef321f56e16f92a$var$updateReducerImpl(stateHook, currentStateHook, $3ef321f56e16f92a$var$actionStateReducer)[0];
    stateHook = $3ef321f56e16f92a$var$updateReducer($3ef321f56e16f92a$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $3ef321f56e16f92a$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $3ef321f56e16f92a$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($3ef321f56e16f92a$var$currentlyRenderingFiber$1.flags |= 2048, $3ef321f56e16f92a$var$pushEffect(9, $3ef321f56e16f92a$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $3ef321f56e16f92a$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $3ef321f56e16f92a$var$rerenderActionState(action) {
    var stateHook = $3ef321f56e16f92a$var$updateWorkInProgressHook(), currentStateHook = $3ef321f56e16f92a$var$currentHook;
    if (null !== currentStateHook) return $3ef321f56e16f92a$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $3ef321f56e16f92a$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $3ef321f56e16f92a$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $3ef321f56e16f92a$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue(), $3ef321f56e16f92a$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $3ef321f56e16f92a$var$updateRef() {
    return $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
}
function $3ef321f56e16f92a$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    $3ef321f56e16f92a$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $3ef321f56e16f92a$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $3ef321f56e16f92a$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $3ef321f56e16f92a$var$currentHook && null !== deps && $3ef321f56e16f92a$var$areHookInputsEqual(deps, $3ef321f56e16f92a$var$currentHook.memoizedState.deps) ? hook.memoizedState = $3ef321f56e16f92a$var$pushEffect(hookFlags, create, inst, deps) : ($3ef321f56e16f92a$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $3ef321f56e16f92a$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $3ef321f56e16f92a$var$mountEffect(create, deps) {
    $3ef321f56e16f92a$var$mountEffectImpl(8390656, 8, create, deps);
}
function $3ef321f56e16f92a$var$updateEffect(create, deps) {
    $3ef321f56e16f92a$var$updateEffectImpl(2048, 8, create, deps);
}
function $3ef321f56e16f92a$var$updateInsertionEffect(create, deps) {
    return $3ef321f56e16f92a$var$updateEffectImpl(4, 2, create, deps);
}
function $3ef321f56e16f92a$var$updateLayoutEffect(create, deps) {
    return $3ef321f56e16f92a$var$updateEffectImpl(4, 4, create, deps);
}
function $3ef321f56e16f92a$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $3ef321f56e16f92a$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $3ef321f56e16f92a$var$updateEffectImpl(4, 4, $3ef321f56e16f92a$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $3ef321f56e16f92a$var$mountDebugValue() {}
function $3ef321f56e16f92a$var$updateCallback(callback, deps) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $3ef321f56e16f92a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $3ef321f56e16f92a$var$updateMemo(nextCreate, deps) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $3ef321f56e16f92a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $3ef321f56e16f92a$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($3ef321f56e16f92a$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $3ef321f56e16f92a$var$requestDeferredLane();
    $3ef321f56e16f92a$var$currentlyRenderingFiber$1.lanes |= hook;
    $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $3ef321f56e16f92a$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($3ef321f56e16f92a$var$objectIs(value, prevValue)) return value;
    if (null !== $3ef321f56e16f92a$var$currentTreeHiddenStackCursor.current) return hook = $3ef321f56e16f92a$var$mountDeferredValueImpl(hook, value, initialValue), $3ef321f56e16f92a$var$objectIs(hook, prevValue) || ($3ef321f56e16f92a$var$didReceiveUpdate = !0), hook;
    if (0 === ($3ef321f56e16f92a$var$renderLanes & 42)) return $3ef321f56e16f92a$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $3ef321f56e16f92a$var$requestDeferredLane();
    $3ef321f56e16f92a$var$currentlyRenderingFiber$1.lanes |= hook;
    $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $3ef321f56e16f92a$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T, currentTransition = {};
    $3ef321f56e16f92a$var$ReactSharedInternals.T = currentTransition;
    $3ef321f56e16f92a$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $3ef321f56e16f92a$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $3ef321f56e16f92a$var$chainThenableValue(returnValue, finishedState);
            $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $3ef321f56e16f92a$var$requestUpdateLane(fiber));
        } else $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, finishedState, $3ef321f56e16f92a$var$requestUpdateLane(fiber));
    } catch (error) {
        $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $3ef321f56e16f92a$var$requestUpdateLane());
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $3ef321f56e16f92a$var$noop$2() {}
function $3ef321f56e16f92a$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(476));
    var queue = $3ef321f56e16f92a$var$ensureFormComponentIsStateful(formFiber).queue;
    $3ef321f56e16f92a$var$startTransition(formFiber, queue, pendingState, $3ef321f56e16f92a$var$sharedNotPendingObject, null === action ? $3ef321f56e16f92a$var$noop$2 : function() {
        $3ef321f56e16f92a$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $3ef321f56e16f92a$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $3ef321f56e16f92a$var$sharedNotPendingObject,
        baseState: $3ef321f56e16f92a$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $3ef321f56e16f92a$var$basicStateReducer,
            lastRenderedState: $3ef321f56e16f92a$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $3ef321f56e16f92a$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $3ef321f56e16f92a$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $3ef321f56e16f92a$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $3ef321f56e16f92a$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $3ef321f56e16f92a$var$requestUpdateLane());
}
function $3ef321f56e16f92a$var$useHostTransitionStatus() {
    return $3ef321f56e16f92a$var$readContext($3ef321f56e16f92a$var$HostTransitionContext);
}
function $3ef321f56e16f92a$var$updateId() {
    return $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
}
function $3ef321f56e16f92a$var$updateRefresh() {
    return $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
}
function $3ef321f56e16f92a$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $3ef321f56e16f92a$var$requestUpdateLane();
                fiber = $3ef321f56e16f92a$var$createUpdate(lane);
                var root$63 = $3ef321f56e16f92a$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(root$63, provider, lane), $3ef321f56e16f92a$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $3ef321f56e16f92a$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $3ef321f56e16f92a$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $3ef321f56e16f92a$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber) ? $3ef321f56e16f92a$var$enqueueRenderPhaseUpdate(queue, action) : (action = $3ef321f56e16f92a$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(action, fiber, lane), $3ef321f56e16f92a$var$entangleTransitionUpdate(action, queue, lane)));
}
function $3ef321f56e16f92a$var$dispatchSetState(fiber, queue, action) {
    var lane = $3ef321f56e16f92a$var$requestUpdateLane();
    $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber)) $3ef321f56e16f92a$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($3ef321f56e16f92a$var$objectIs(eagerState, currentState)) return $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, queue, update, 0), null === $3ef321f56e16f92a$var$workInProgressRoot && $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $3ef321f56e16f92a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $3ef321f56e16f92a$var$scheduleUpdateOnFiber(action, fiber, lane), $3ef321f56e16f92a$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $3ef321f56e16f92a$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $3ef321f56e16f92a$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $3ef321f56e16f92a$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $3ef321f56e16f92a$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $3ef321f56e16f92a$var$currentlyRenderingFiber$1;
}
function $3ef321f56e16f92a$var$enqueueRenderPhaseUpdate(queue, update) {
    $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass = $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $3ef321f56e16f92a$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $3ef321f56e16f92a$var$markRootEntangled(root, lane);
    }
}
var $3ef321f56e16f92a$var$ContextOnlyDispatcher = {
    readContext: $3ef321f56e16f92a$var$readContext,
    use: $3ef321f56e16f92a$var$use,
    useCallback: $3ef321f56e16f92a$var$throwInvalidHookError,
    useContext: $3ef321f56e16f92a$var$throwInvalidHookError,
    useEffect: $3ef321f56e16f92a$var$throwInvalidHookError,
    useImperativeHandle: $3ef321f56e16f92a$var$throwInvalidHookError,
    useLayoutEffect: $3ef321f56e16f92a$var$throwInvalidHookError,
    useInsertionEffect: $3ef321f56e16f92a$var$throwInvalidHookError,
    useMemo: $3ef321f56e16f92a$var$throwInvalidHookError,
    useReducer: $3ef321f56e16f92a$var$throwInvalidHookError,
    useRef: $3ef321f56e16f92a$var$throwInvalidHookError,
    useState: $3ef321f56e16f92a$var$throwInvalidHookError,
    useDebugValue: $3ef321f56e16f92a$var$throwInvalidHookError,
    useDeferredValue: $3ef321f56e16f92a$var$throwInvalidHookError,
    useTransition: $3ef321f56e16f92a$var$throwInvalidHookError,
    useSyncExternalStore: $3ef321f56e16f92a$var$throwInvalidHookError,
    useId: $3ef321f56e16f92a$var$throwInvalidHookError
};
$3ef321f56e16f92a$var$ContextOnlyDispatcher.useCacheRefresh = $3ef321f56e16f92a$var$throwInvalidHookError;
$3ef321f56e16f92a$var$ContextOnlyDispatcher.useMemoCache = $3ef321f56e16f92a$var$throwInvalidHookError;
$3ef321f56e16f92a$var$ContextOnlyDispatcher.useHostTransitionStatus = $3ef321f56e16f92a$var$throwInvalidHookError;
$3ef321f56e16f92a$var$ContextOnlyDispatcher.useFormState = $3ef321f56e16f92a$var$throwInvalidHookError;
$3ef321f56e16f92a$var$ContextOnlyDispatcher.useActionState = $3ef321f56e16f92a$var$throwInvalidHookError;
$3ef321f56e16f92a$var$ContextOnlyDispatcher.useOptimistic = $3ef321f56e16f92a$var$throwInvalidHookError;
var $3ef321f56e16f92a$var$HooksDispatcherOnMount = {
    readContext: $3ef321f56e16f92a$var$readContext,
    use: $3ef321f56e16f92a$var$use,
    useCallback: function(callback, deps) {
        $3ef321f56e16f92a$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $3ef321f56e16f92a$var$readContext,
    useEffect: $3ef321f56e16f92a$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $3ef321f56e16f92a$var$mountEffectImpl(4194308, 4, $3ef321f56e16f92a$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $3ef321f56e16f92a$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $3ef321f56e16f92a$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $3ef321f56e16f92a$var$dispatchReducerAction.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $3ef321f56e16f92a$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $3ef321f56e16f92a$var$dispatchSetState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $3ef321f56e16f92a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        return $3ef321f56e16f92a$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $3ef321f56e16f92a$var$mountStateImpl(!1);
        stateHook = $3ef321f56e16f92a$var$startTransition.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $3ef321f56e16f92a$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $3ef321f56e16f92a$var$currentlyRenderingFiber$1, hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        if ($3ef321f56e16f92a$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $3ef321f56e16f92a$var$workInProgressRoot) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(349));
            0 !== ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 60) || $3ef321f56e16f92a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $3ef321f56e16f92a$var$mountEffect($3ef321f56e16f92a$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $3ef321f56e16f92a$var$pushEffect(9, $3ef321f56e16f92a$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook(), identifierPrefix = $3ef321f56e16f92a$var$workInProgressRoot.identifierPrefix;
        if ($3ef321f56e16f92a$var$isHydrating) {
            var JSCompiler_inline_result = $3ef321f56e16f92a$var$treeContextOverflow;
            var idWithLeadingBit = $3ef321f56e16f92a$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $3ef321f56e16f92a$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $3ef321f56e16f92a$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $3ef321f56e16f92a$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $3ef321f56e16f92a$var$mountWorkInProgressHook().memoizedState = $3ef321f56e16f92a$var$refreshCache.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber$1);
    }
};
$3ef321f56e16f92a$var$HooksDispatcherOnMount.useMemoCache = $3ef321f56e16f92a$var$useMemoCache;
$3ef321f56e16f92a$var$HooksDispatcherOnMount.useHostTransitionStatus = $3ef321f56e16f92a$var$useHostTransitionStatus;
$3ef321f56e16f92a$var$HooksDispatcherOnMount.useFormState = $3ef321f56e16f92a$var$mountActionState;
$3ef321f56e16f92a$var$HooksDispatcherOnMount.useActionState = $3ef321f56e16f92a$var$mountActionState;
$3ef321f56e16f92a$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $3ef321f56e16f92a$var$dispatchOptimisticSetState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $3ef321f56e16f92a$var$HooksDispatcherOnUpdate = {
    readContext: $3ef321f56e16f92a$var$readContext,
    use: $3ef321f56e16f92a$var$use,
    useCallback: $3ef321f56e16f92a$var$updateCallback,
    useContext: $3ef321f56e16f92a$var$readContext,
    useEffect: $3ef321f56e16f92a$var$updateEffect,
    useImperativeHandle: $3ef321f56e16f92a$var$updateImperativeHandle,
    useInsertionEffect: $3ef321f56e16f92a$var$updateInsertionEffect,
    useLayoutEffect: $3ef321f56e16f92a$var$updateLayoutEffect,
    useMemo: $3ef321f56e16f92a$var$updateMemo,
    useReducer: $3ef321f56e16f92a$var$updateReducer,
    useRef: $3ef321f56e16f92a$var$updateRef,
    useState: function() {
        return $3ef321f56e16f92a$var$updateReducer($3ef321f56e16f92a$var$basicStateReducer);
    },
    useDebugValue: $3ef321f56e16f92a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
        return $3ef321f56e16f92a$var$updateDeferredValueImpl(hook, $3ef321f56e16f92a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $3ef321f56e16f92a$var$updateReducer($3ef321f56e16f92a$var$basicStateReducer)[0], start = $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $3ef321f56e16f92a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $3ef321f56e16f92a$var$updateSyncExternalStore,
    useId: $3ef321f56e16f92a$var$updateId
};
$3ef321f56e16f92a$var$HooksDispatcherOnUpdate.useCacheRefresh = $3ef321f56e16f92a$var$updateRefresh;
$3ef321f56e16f92a$var$HooksDispatcherOnUpdate.useMemoCache = $3ef321f56e16f92a$var$useMemoCache;
$3ef321f56e16f92a$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $3ef321f56e16f92a$var$useHostTransitionStatus;
$3ef321f56e16f92a$var$HooksDispatcherOnUpdate.useFormState = $3ef321f56e16f92a$var$updateActionState;
$3ef321f56e16f92a$var$HooksDispatcherOnUpdate.useActionState = $3ef321f56e16f92a$var$updateActionState;
$3ef321f56e16f92a$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    return $3ef321f56e16f92a$var$updateOptimisticImpl(hook, $3ef321f56e16f92a$var$currentHook, passthrough, reducer);
};
var $3ef321f56e16f92a$var$HooksDispatcherOnRerender = {
    readContext: $3ef321f56e16f92a$var$readContext,
    use: $3ef321f56e16f92a$var$use,
    useCallback: $3ef321f56e16f92a$var$updateCallback,
    useContext: $3ef321f56e16f92a$var$readContext,
    useEffect: $3ef321f56e16f92a$var$updateEffect,
    useImperativeHandle: $3ef321f56e16f92a$var$updateImperativeHandle,
    useInsertionEffect: $3ef321f56e16f92a$var$updateInsertionEffect,
    useLayoutEffect: $3ef321f56e16f92a$var$updateLayoutEffect,
    useMemo: $3ef321f56e16f92a$var$updateMemo,
    useReducer: $3ef321f56e16f92a$var$rerenderReducer,
    useRef: $3ef321f56e16f92a$var$updateRef,
    useState: function() {
        return $3ef321f56e16f92a$var$rerenderReducer($3ef321f56e16f92a$var$basicStateReducer);
    },
    useDebugValue: $3ef321f56e16f92a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
        return null === $3ef321f56e16f92a$var$currentHook ? $3ef321f56e16f92a$var$mountDeferredValueImpl(hook, value, initialValue) : $3ef321f56e16f92a$var$updateDeferredValueImpl(hook, $3ef321f56e16f92a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $3ef321f56e16f92a$var$rerenderReducer($3ef321f56e16f92a$var$basicStateReducer)[0], start = $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $3ef321f56e16f92a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $3ef321f56e16f92a$var$updateSyncExternalStore,
    useId: $3ef321f56e16f92a$var$updateId
};
$3ef321f56e16f92a$var$HooksDispatcherOnRerender.useCacheRefresh = $3ef321f56e16f92a$var$updateRefresh;
$3ef321f56e16f92a$var$HooksDispatcherOnRerender.useMemoCache = $3ef321f56e16f92a$var$useMemoCache;
$3ef321f56e16f92a$var$HooksDispatcherOnRerender.useHostTransitionStatus = $3ef321f56e16f92a$var$useHostTransitionStatus;
$3ef321f56e16f92a$var$HooksDispatcherOnRerender.useFormState = $3ef321f56e16f92a$var$rerenderActionState;
$3ef321f56e16f92a$var$HooksDispatcherOnRerender.useActionState = $3ef321f56e16f92a$var$rerenderActionState;
$3ef321f56e16f92a$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    if (null !== $3ef321f56e16f92a$var$currentHook) return $3ef321f56e16f92a$var$updateOptimisticImpl(hook, $3ef321f56e16f92a$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $3ef321f56e16f92a$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $3ef321f56e16f92a$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $3ef321f56e16f92a$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $3ef321f56e16f92a$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $3ef321f56e16f92a$var$requestUpdateLane(), update = $3ef321f56e16f92a$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $3ef321f56e16f92a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(payload, inst, lane), $3ef321f56e16f92a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $3ef321f56e16f92a$var$requestUpdateLane(), update = $3ef321f56e16f92a$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $3ef321f56e16f92a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(payload, inst, lane), $3ef321f56e16f92a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $3ef321f56e16f92a$var$requestUpdateLane(), update = $3ef321f56e16f92a$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $3ef321f56e16f92a$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(callback, inst, lane), $3ef321f56e16f92a$var$entangleTransitions(callback, inst, lane));
    }
};
function $3ef321f56e16f92a$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$3ef321f56e16f92a$var$shallowEqual(oldProps, newProps) || !$3ef321f56e16f92a$var$shallowEqual(oldState, newState) : !0;
}
function $3ef321f56e16f92a$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $3ef321f56e16f92a$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $3ef321f56e16f92a$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $3ef321f56e16f92a$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $3ef321f56e16f92a$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $7q8YY && "function" === typeof $7q8YY.emit) {
        $7q8YY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $3ef321f56e16f92a$var$defaultOnUncaughtError(error) {
    $3ef321f56e16f92a$var$reportGlobalError(error);
}
function $3ef321f56e16f92a$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $3ef321f56e16f92a$var$defaultOnRecoverableError(error) {
    $3ef321f56e16f92a$var$reportGlobalError(error);
}
function $3ef321f56e16f92a$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $3ef321f56e16f92a$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $3ef321f56e16f92a$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $3ef321f56e16f92a$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $3ef321f56e16f92a$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $3ef321f56e16f92a$var$createClassErrorUpdate(lane) {
    lane = $3ef321f56e16f92a$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $3ef321f56e16f92a$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $3ef321f56e16f92a$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $3ef321f56e16f92a$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed ? $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $3ef321f56e16f92a$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $3ef321f56e16f92a$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $3ef321f56e16f92a$var$shellBoundary ? $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $3ef321f56e16f92a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $3ef321f56e16f92a$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $3ef321f56e16f92a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $3ef321f56e16f92a$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $3ef321f56e16f92a$var$attachPingListener(root, value, rootRenderLanes);
        $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($3ef321f56e16f92a$var$isHydrating) return returnFiber = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $3ef321f56e16f92a$var$HydrationMismatchException && (root = Error($3ef321f56e16f92a$var$formatProdErrorMessage(422), {
        cause: value
    }), $3ef321f56e16f92a$var$queueHydrationError($3ef321f56e16f92a$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $3ef321f56e16f92a$var$HydrationMismatchException && (returnFiber = Error($3ef321f56e16f92a$var$formatProdErrorMessage(423), {
        cause: value
    }), $3ef321f56e16f92a$var$queueHydrationError($3ef321f56e16f92a$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $3ef321f56e16f92a$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $3ef321f56e16f92a$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $3ef321f56e16f92a$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($3ef321f56e16f92a$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $3ef321f56e16f92a$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors ? $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $3ef321f56e16f92a$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $3ef321f56e16f92a$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $3ef321f56e16f92a$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed || !$3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $3ef321f56e16f92a$var$createClassErrorUpdate(rootRenderLanes), $3ef321f56e16f92a$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $3ef321f56e16f92a$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $3ef321f56e16f92a$var$SelectiveHydrationException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(461)), $3ef321f56e16f92a$var$didReceiveUpdate = !1;
function $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $3ef321f56e16f92a$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $3ef321f56e16f92a$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $3ef321f56e16f92a$var$prepareToReadContext(workInProgress);
    nextProps = $3ef321f56e16f92a$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $3ef321f56e16f92a$var$checkDidRenderIdHook();
    if (null !== current && !$3ef321f56e16f92a$var$didReceiveUpdate) return $3ef321f56e16f92a$var$bailoutHooks(current, workInProgress, renderLanes), $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $3ef321f56e16f92a$var$isHydrating && key && $3ef321f56e16f92a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$3ef321f56e16f92a$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $3ef321f56e16f92a$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $3ef321f56e16f92a$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$3ef321f56e16f92a$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $3ef321f56e16f92a$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $3ef321f56e16f92a$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $3ef321f56e16f92a$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($3ef321f56e16f92a$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($3ef321f56e16f92a$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $3ef321f56e16f92a$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($3ef321f56e16f92a$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $3ef321f56e16f92a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $3ef321f56e16f92a$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $3ef321f56e16f92a$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $3ef321f56e16f92a$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $3ef321f56e16f92a$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $3ef321f56e16f92a$var$pushHiddenContext(workInProgress, prevState) : $3ef321f56e16f92a$var$reuseHiddenContextOnStack(), $3ef321f56e16f92a$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $3ef321f56e16f92a$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($3ef321f56e16f92a$var$pushTransition(workInProgress, prevState.cachePool), $3ef321f56e16f92a$var$pushHiddenContext(workInProgress, prevState), $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $3ef321f56e16f92a$var$pushTransition(workInProgress, null), $3ef321f56e16f92a$var$reuseHiddenContextOnStack(), $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress));
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $3ef321f56e16f92a$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $3ef321f56e16f92a$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $3ef321f56e16f92a$var$pushTransition(workInProgress, null);
    $3ef321f56e16f92a$var$reuseHiddenContextOnStack();
    $3ef321f56e16f92a$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $3ef321f56e16f92a$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $3ef321f56e16f92a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $3ef321f56e16f92a$var$prepareToReadContext(workInProgress);
    Component = $3ef321f56e16f92a$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $3ef321f56e16f92a$var$checkDidRenderIdHook();
    if (null !== current && !$3ef321f56e16f92a$var$didReceiveUpdate) return $3ef321f56e16f92a$var$bailoutHooks(current, workInProgress, renderLanes), $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $3ef321f56e16f92a$var$isHydrating && nextProps && $3ef321f56e16f92a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $3ef321f56e16f92a$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $3ef321f56e16f92a$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $3ef321f56e16f92a$var$finishRenderingHooks(current);
    Component = $3ef321f56e16f92a$var$checkDidRenderIdHook();
    if (null !== current && !$3ef321f56e16f92a$var$didReceiveUpdate) return $3ef321f56e16f92a$var$bailoutHooks(current, workInProgress, renderLanes), $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $3ef321f56e16f92a$var$isHydrating && Component && $3ef321f56e16f92a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $3ef321f56e16f92a$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $3ef321f56e16f92a$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $3ef321f56e16f92a$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $3ef321f56e16f92a$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $3ef321f56e16f92a$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $3ef321f56e16f92a$var$readContext(contextType) : $3ef321f56e16f92a$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($3ef321f56e16f92a$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $3ef321f56e16f92a$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $3ef321f56e16f92a$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $3ef321f56e16f92a$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $3ef321f56e16f92a$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $3ef321f56e16f92a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $3ef321f56e16f92a$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $3ef321f56e16f92a$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($3ef321f56e16f92a$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $3ef321f56e16f92a$var$hasForceUpdate || $3ef321f56e16f92a$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $3ef321f56e16f92a$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $3ef321f56e16f92a$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $3ef321f56e16f92a$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $3ef321f56e16f92a$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $3ef321f56e16f92a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $3ef321f56e16f92a$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $3ef321f56e16f92a$var$hasForceUpdate || null !== current && null !== current.dependencies && $3ef321f56e16f92a$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($3ef321f56e16f92a$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $3ef321f56e16f92a$var$hasForceUpdate || $3ef321f56e16f92a$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $3ef321f56e16f92a$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $3ef321f56e16f92a$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $3ef321f56e16f92a$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $3ef321f56e16f92a$var$resetHydrationState();
    workInProgress.flags |= 256;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $3ef321f56e16f92a$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3ef321f56e16f92a$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $3ef321f56e16f92a$var$getSuspendedCache()
    };
}
function $3ef321f56e16f92a$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $3ef321f56e16f92a$var$workInProgressDeferredLane);
    return current;
}
function $3ef321f56e16f92a$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($3ef321f56e16f92a$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($3ef321f56e16f92a$var$isHydrating) {
            showFallback ? $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($3ef321f56e16f92a$var$isHydrating) {
                var nextInstance = $3ef321f56e16f92a$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $3ef321f56e16f92a$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $3ef321f56e16f92a$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $3ef321f56e16f92a$var$treeContextProvider ? {
                            id: $3ef321f56e16f92a$var$treeContextId,
                            overflow: $3ef321f56e16f92a$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $3ef321f56e16f92a$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $3ef321f56e16f92a$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $3ef321f56e16f92a$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $3ef321f56e16f92a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $3ef321f56e16f92a$var$SUSPENDED_MARKER, nextProps;
        $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $3ef321f56e16f92a$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $3ef321f56e16f92a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $3ef321f56e16f92a$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $3ef321f56e16f92a$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $3ef321f56e16f92a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $3ef321f56e16f92a$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($3ef321f56e16f92a$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $3ef321f56e16f92a$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $3ef321f56e16f92a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($3ef321f56e16f92a$var$didReceiveUpdate || $3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $3ef321f56e16f92a$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $3ef321f56e16f92a$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(current, nextProps), $3ef321f56e16f92a$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $3ef321f56e16f92a$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible();
            workInProgress = $3ef321f56e16f92a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $3ef321f56e16f92a$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(nextInstance.nextSibling), $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$isHydrating = !0, $3ef321f56e16f92a$var$hydrationErrors = null, $3ef321f56e16f92a$var$rootOrSingletonContext = !1, null !== current && ($3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextId, $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextOverflow, $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextProvider, $3ef321f56e16f92a$var$treeContextId = current.id, $3ef321f56e16f92a$var$treeContextOverflow = current.overflow, $3ef321f56e16f92a$var$treeContextProvider = workInProgress), workInProgress = $3ef321f56e16f92a$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $3ef321f56e16f92a$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $3ef321f56e16f92a$var$createWorkInProgress(digest, showFallback) : (showFallback = $3ef321f56e16f92a$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $3ef321f56e16f92a$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $3ef321f56e16f92a$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $3ef321f56e16f92a$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $3ef321f56e16f92a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $3ef321f56e16f92a$var$SUSPENDED_MARKER, nextProps;
    $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $3ef321f56e16f92a$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $3ef321f56e16f92a$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $3ef321f56e16f92a$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $3ef321f56e16f92a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $3ef321f56e16f92a$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $3ef321f56e16f92a$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $3ef321f56e16f92a$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $3ef321f56e16f92a$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $3ef321f56e16f92a$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $3ef321f56e16f92a$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $3ef321f56e16f92a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $3ef321f56e16f92a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $3ef321f56e16f92a$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $3ef321f56e16f92a$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $3ef321f56e16f92a$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $3ef321f56e16f92a$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $3ef321f56e16f92a$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $3ef321f56e16f92a$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $3ef321f56e16f92a$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $3ef321f56e16f92a$var$checkIfContextChanged(current) ? !0 : !1;
}
function $3ef321f56e16f92a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $3ef321f56e16f92a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, current.memoizedState.cache);
            $3ef321f56e16f92a$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $3ef321f56e16f92a$var$pushHostContext(workInProgress);
            break;
        case 4:
            $3ef321f56e16f92a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $3ef321f56e16f92a$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $3ef321f56e16f92a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $3ef321f56e16f92a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $3ef321f56e16f92a$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, current.memoizedState.cache);
    }
    return $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $3ef321f56e16f92a$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $3ef321f56e16f92a$var$didReceiveUpdate = !0;
        else {
            if (!$3ef321f56e16f92a$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $3ef321f56e16f92a$var$didReceiveUpdate = !1, $3ef321f56e16f92a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $3ef321f56e16f92a$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $3ef321f56e16f92a$var$didReceiveUpdate = !1, $3ef321f56e16f92a$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $3ef321f56e16f92a$var$pushTreeId(workInProgress, $3ef321f56e16f92a$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $3ef321f56e16f92a$var$shouldConstruct(lazyComponent) ? (current = $3ef321f56e16f92a$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $3ef321f56e16f92a$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $3ef321f56e16f92a$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $3ef321f56e16f92a$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $3ef321f56e16f92a$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $3ef321f56e16f92a$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $3ef321f56e16f92a$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $3ef321f56e16f92a$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $3ef321f56e16f92a$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $3ef321f56e16f92a$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $3ef321f56e16f92a$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $3ef321f56e16f92a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $3ef321f56e16f92a$var$cloneUpdateQueue(current, workInProgress);
                $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, nextProps);
                nextProps !== init.cache && $3ef321f56e16f92a$var$propagateContextChanges(workInProgress, [
                    $3ef321f56e16f92a$var$CacheContext
                ], renderLanes, !0);
                $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $3ef321f56e16f92a$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $3ef321f56e16f92a$var$createCapturedValueAtFiber(Error($3ef321f56e16f92a$var$formatProdErrorMessage(424)), workInProgress);
                        $3ef321f56e16f92a$var$queueHydrationError(lazyComponent);
                        workInProgress = $3ef321f56e16f92a$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$isHydrating = !0, $3ef321f56e16f92a$var$hydrationErrors = null, $3ef321f56e16f92a$var$rootOrSingletonContext = !0, renderLanes = $3ef321f56e16f92a$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $3ef321f56e16f92a$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $3ef321f56e16f92a$var$markRef(current, workInProgress), null === current ? (renderLanes = $3ef321f56e16f92a$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $3ef321f56e16f92a$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer($3ef321f56e16f92a$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress, lazyComponent[$3ef321f56e16f92a$var$internalPropsKey] = current, $3ef321f56e16f92a$var$setInitialProperties(lazyComponent, renderLanes, current), $3ef321f56e16f92a$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $3ef321f56e16f92a$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $3ef321f56e16f92a$var$pushHostContext(workInProgress), null === current && $3ef321f56e16f92a$var$isHydrating && (lazyComponent = workInProgress.stateNode = $3ef321f56e16f92a$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $3ef321f56e16f92a$var$rootInstanceStackCursor.current), $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$rootOrSingletonContext = !0, $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $3ef321f56e16f92a$var$isHydrating ? $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $3ef321f56e16f92a$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $3ef321f56e16f92a$var$isHydrating) {
                if (init = lazyComponent = $3ef321f56e16f92a$var$nextHydratableInstance) lazyComponent = $3ef321f56e16f92a$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $3ef321f56e16f92a$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(lazyComponent.firstChild), $3ef321f56e16f92a$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress);
            }
            $3ef321f56e16f92a$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $3ef321f56e16f92a$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $3ef321f56e16f92a$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $3ef321f56e16f92a$var$renderWithHooks(current, workInProgress, $3ef321f56e16f92a$var$TransitionAwareHostComponent, null, null, renderLanes), $3ef321f56e16f92a$var$HostTransitionContext._currentValue = init);
            $3ef321f56e16f92a$var$markRef(current, workInProgress);
            $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $3ef321f56e16f92a$var$isHydrating) {
                if (current = renderLanes = $3ef321f56e16f92a$var$nextHydratableInstance) renderLanes = $3ef321f56e16f92a$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $3ef321f56e16f92a$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $3ef321f56e16f92a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $3ef321f56e16f92a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $3ef321f56e16f92a$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $3ef321f56e16f92a$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $3ef321f56e16f92a$var$prepareToReadContext(workInProgress), init = $3ef321f56e16f92a$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $3ef321f56e16f92a$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $3ef321f56e16f92a$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $3ef321f56e16f92a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $3ef321f56e16f92a$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $3ef321f56e16f92a$var$prepareToReadContext(workInProgress), lazyComponent = $3ef321f56e16f92a$var$readContext($3ef321f56e16f92a$var$CacheContext), null === current ? (init = $3ef321f56e16f92a$var$peekCacheFromPool(), null === init && (init = $3ef321f56e16f92a$var$workInProgressRoot, nextProps = $3ef321f56e16f92a$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $3ef321f56e16f92a$var$initializeUpdateQueue(workInProgress), $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($3ef321f56e16f92a$var$cloneUpdateQueue(current, workInProgress), $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, null, null, renderLanes), $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $3ef321f56e16f92a$var$propagateContextChanges(workInProgress, [
                $3ef321f56e16f92a$var$CacheContext
            ], renderLanes, !0))), $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $3ef321f56e16f92a$var$valueCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$currentlyRenderingFiber = null, $3ef321f56e16f92a$var$lastContextDependency = null;
function $3ef321f56e16f92a$var$pushProvider(providerFiber, context, nextValue) {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $3ef321f56e16f92a$var$popProvider(context) {
    context._currentValue = $3ef321f56e16f92a$var$valueCursor.current;
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$valueCursor);
}
function $3ef321f56e16f92a$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $3ef321f56e16f92a$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $3ef321f56e16f92a$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $3ef321f56e16f92a$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $3ef321f56e16f92a$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $3ef321f56e16f92a$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($3ef321f56e16f92a$var$HostTransitionContext) : current = [
                $3ef321f56e16f92a$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $3ef321f56e16f92a$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $3ef321f56e16f92a$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$3ef321f56e16f92a$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $3ef321f56e16f92a$var$prepareToReadContext(workInProgress) {
    $3ef321f56e16f92a$var$currentlyRenderingFiber = workInProgress;
    $3ef321f56e16f92a$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $3ef321f56e16f92a$var$readContext(context) {
    return $3ef321f56e16f92a$var$readContextForConsumer($3ef321f56e16f92a$var$currentlyRenderingFiber, context);
}
function $3ef321f56e16f92a$var$readContextDuringReconciliation(consumer, context) {
    null === $3ef321f56e16f92a$var$currentlyRenderingFiber && $3ef321f56e16f92a$var$prepareToReadContext(consumer);
    return $3ef321f56e16f92a$var$readContextForConsumer(consumer, context);
}
function $3ef321f56e16f92a$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $3ef321f56e16f92a$var$lastContextDependency) {
        if (null === consumer) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(308));
        $3ef321f56e16f92a$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$lastContextDependency.next = context;
    return value;
}
var $3ef321f56e16f92a$var$hasForceUpdate = !1;
function $3ef321f56e16f92a$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $3ef321f56e16f92a$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $3ef321f56e16f92a$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3ef321f56e16f92a$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($3ef321f56e16f92a$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $3ef321f56e16f92a$var$getRootForUpdatedFiber(fiber);
        $3ef321f56e16f92a$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $3ef321f56e16f92a$var$getRootForUpdatedFiber(fiber);
}
function $3ef321f56e16f92a$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $3ef321f56e16f92a$var$markRootEntangled(root, lane);
    }
}
function $3ef321f56e16f92a$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $3ef321f56e16f92a$var$didReadFromEntangledAsyncAction = !1;
function $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($3ef321f56e16f92a$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $3ef321f56e16f92a$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $3ef321f56e16f92a$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $3ef321f56e16f92a$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $3ef321f56e16f92a$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $3ef321f56e16f92a$var$currentEntangledLane && ($3ef321f56e16f92a$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $3ef321f56e16f92a$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $3ef321f56e16f92a$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $3ef321f56e16f92a$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $3ef321f56e16f92a$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$3ef321f56e16f92a$var$callCallback(callbacks[updateQueue], context);
}
function $3ef321f56e16f92a$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $3ef321f56e16f92a$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $3ef321f56e16f92a$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $3ef321f56e16f92a$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $3ef321f56e16f92a$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $3ef321f56e16f92a$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $3ef321f56e16f92a$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $3ef321f56e16f92a$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $3ef321f56e16f92a$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$3ef321f56e16f92a$var$internalPropsKey] = newProps;
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $3ef321f56e16f92a$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $3ef321f56e16f92a$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $3ef321f56e16f92a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $3ef321f56e16f92a$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($3ef321f56e16f92a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$3ef321f56e16f92a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $3ef321f56e16f92a$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($3ef321f56e16f92a$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$3ef321f56e16f92a$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = !1, $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = !1, $3ef321f56e16f92a$var$needsFormReset = !1, $3ef321f56e16f92a$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $3ef321f56e16f92a$var$nextEffect = null, $3ef321f56e16f92a$var$shouldFireAfterActiveInstanceBlur = !1;
function $3ef321f56e16f92a$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $3ef321f56e16f92a$var$eventsEnabled = $3ef321f56e16f92a$var$_enabled;
    root = $3ef321f56e16f92a$var$getActiveElementDeep(root);
    if ($3ef321f56e16f92a$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $3ef321f56e16f92a$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $3ef321f56e16f92a$var$_enabled = !1;
    for($3ef321f56e16f92a$var$nextEffect = firstChild; null !== $3ef321f56e16f92a$var$nextEffect;)if (firstChild = $3ef321f56e16f92a$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $3ef321f56e16f92a$var$nextEffect = root;
    else for(; null !== $3ef321f56e16f92a$var$nextEffect;){
        firstChild = $3ef321f56e16f92a$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $3ef321f56e16f92a$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $3ef321f56e16f92a$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $3ef321f56e16f92a$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $3ef321f56e16f92a$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $3ef321f56e16f92a$var$nextEffect = root;
            break;
        }
        $3ef321f56e16f92a$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $3ef321f56e16f92a$var$shouldFireAfterActiveInstanceBlur;
    $3ef321f56e16f92a$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $3ef321f56e16f92a$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $3ef321f56e16f92a$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $3ef321f56e16f92a$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $3ef321f56e16f92a$var$commitClassCallbacks(finishedWork);
            flags & 512 && $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $3ef321f56e16f92a$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $3ef321f56e16f92a$var$commitHostMount(finishedWork);
            flags & 512 && $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $3ef321f56e16f92a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $3ef321f56e16f92a$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $3ef321f56e16f92a$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $3ef321f56e16f92a$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $3ef321f56e16f92a$var$offscreenSubtreeWasHidden;
                $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = prevProps;
                ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return) : $3ef321f56e16f92a$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $3ef321f56e16f92a$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $3ef321f56e16f92a$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $3ef321f56e16f92a$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $3ef321f56e16f92a$var$hostParent = null, $3ef321f56e16f92a$var$hostParentIsContainer = !1;
function $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$3ef321f56e16f92a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $3ef321f56e16f92a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($3ef321f56e16f92a$var$injectedHook && "function" === typeof $3ef321f56e16f92a$var$injectedHook.onCommitFiberUnmount) try {
        $3ef321f56e16f92a$var$injectedHook.onCommitFiberUnmount($3ef321f56e16f92a$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $3ef321f56e16f92a$var$hostParent, prevHostParentIsContainer = $3ef321f56e16f92a$var$hostParentIsContainer;
            $3ef321f56e16f92a$var$hostParent = deletedFiber.stateNode;
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $3ef321f56e16f92a$var$detachDeletedInstance(deletedFiber);
            $3ef321f56e16f92a$var$hostParent = prevHostParent;
            $3ef321f56e16f92a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $3ef321f56e16f92a$var$hostParent;
            var prevHostParentIsContainer$119 = $3ef321f56e16f92a$var$hostParentIsContainer;
            $3ef321f56e16f92a$var$hostParent = null;
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $3ef321f56e16f92a$var$hostParent = prevHostParentIsContainer;
            $3ef321f56e16f92a$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $3ef321f56e16f92a$var$hostParent) {
                if ($3ef321f56e16f92a$var$hostParentIsContainer) try {
                    finishedRoot = $3ef321f56e16f92a$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $3ef321f56e16f92a$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $3ef321f56e16f92a$var$hostParent && ($3ef321f56e16f92a$var$hostParentIsContainer ? (nearestMountedAncestor = $3ef321f56e16f92a$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $3ef321f56e16f92a$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $3ef321f56e16f92a$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $3ef321f56e16f92a$var$retryIfBlockedOn(nearestMountedAncestor)) : $3ef321f56e16f92a$var$clearSuspenseBoundary($3ef321f56e16f92a$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $3ef321f56e16f92a$var$hostParent;
            prevHostParentIsContainer = $3ef321f56e16f92a$var$hostParentIsContainer;
            $3ef321f56e16f92a$var$hostParent = deletedFiber.stateNode.containerInfo;
            $3ef321f56e16f92a$var$hostParentIsContainer = !0;
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $3ef321f56e16f92a$var$hostParent = prevHostParent;
            $3ef321f56e16f92a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || ($3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $3ef321f56e16f92a$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = (prevHostParent = $3ef321f56e16f92a$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $3ef321f56e16f92a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $3ef321f56e16f92a$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $3ef321f56e16f92a$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $3ef321f56e16f92a$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $3ef321f56e16f92a$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $3ef321f56e16f92a$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $3ef321f56e16f92a$var$hostParent = parent.stateNode;
                    $3ef321f56e16f92a$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $3ef321f56e16f92a$var$hostParent = parent.stateNode.containerInfo;
                    $3ef321f56e16f92a$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $3ef321f56e16f92a$var$hostParent = parent.stateNode.containerInfo;
                    $3ef321f56e16f92a$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $3ef321f56e16f92a$var$hostParent) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(160));
        $3ef321f56e16f92a$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $3ef321f56e16f92a$var$hostParent = null;
        $3ef321f56e16f92a$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $3ef321f56e16f92a$var$currentHoistableRoot = null;
function $3ef321f56e16f92a$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($3ef321f56e16f92a$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $3ef321f56e16f92a$var$commitHookEffectListMount(3, finishedWork), $3ef321f56e16f92a$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden || null === current || $3ef321f56e16f92a$var$safelyDetachRef(current, current.return));
            flags & 64 && $3ef321f56e16f92a$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $3ef321f56e16f92a$var$currentHoistableRoot;
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden || null === current || $3ef321f56e16f92a$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$3ef321f56e16f92a$var$internalHoistableMarker] || currentResource[$3ef321f56e16f92a$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $3ef321f56e16f92a$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$3ef321f56e16f92a$var$internalInstanceKey] = finishedWork;
                                        $3ef321f56e16f92a$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $3ef321f56e16f92a$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $3ef321f56e16f92a$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $3ef321f56e16f92a$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $3ef321f56e16f92a$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$3ef321f56e16f92a$var$internalInstanceKey] = finishedWork;
                                $3ef321f56e16f92a$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $3ef321f56e16f92a$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $3ef321f56e16f92a$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $3ef321f56e16f92a$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $3ef321f56e16f92a$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $3ef321f56e16f92a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$3ef321f56e16f92a$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $3ef321f56e16f92a$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$3ef321f56e16f92a$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$3ef321f56e16f92a$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden || null === current || $3ef321f56e16f92a$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $3ef321f56e16f92a$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $3ef321f56e16f92a$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($3ef321f56e16f92a$var$needsFormReset = !0);
            break;
        case 6:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $3ef321f56e16f92a$var$tagCaches = null;
            hoistableRoot = $3ef321f56e16f92a$var$currentHoistableRoot;
            $3ef321f56e16f92a$var$currentHoistableRoot = $3ef321f56e16f92a$var$getHoistableRoot(root.containerInfo);
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$currentHoistableRoot = hoistableRoot;
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $3ef321f56e16f92a$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $3ef321f56e16f92a$var$needsFormReset && ($3ef321f56e16f92a$var$needsFormReset = !1, $3ef321f56e16f92a$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $3ef321f56e16f92a$var$currentHoistableRoot;
            $3ef321f56e16f92a$var$currentHoistableRoot = $3ef321f56e16f92a$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            $3ef321f56e16f92a$var$currentHoistableRoot = flags;
            break;
        case 12:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($3ef321f56e16f92a$var$globalMostRecentFallbackTime = $3ef321f56e16f92a$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden || null === current || $3ef321f56e16f92a$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $3ef321f56e16f92a$var$offscreenSubtreeIsHidden;
            type = $3ef321f56e16f92a$var$offscreenSubtreeWasHidden;
            $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = nodeName || node;
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = type || nextNode;
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = type;
            $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = nodeName;
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $3ef321f56e16f92a$var$offscreenSubtreeIsHidden || $3ef321f56e16f92a$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $3ef321f56e16f92a$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $3ef321f56e16f92a$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork), $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
    }
}
function $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($3ef321f56e16f92a$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $3ef321f56e16f92a$var$getHostSibling(finishedWork);
                        $3ef321f56e16f92a$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($3ef321f56e16f92a$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $3ef321f56e16f92a$var$getHostSibling(finishedWork);
                        $3ef321f56e16f92a$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $3ef321f56e16f92a$var$getHostSibling(finishedWork);
                        $3ef321f56e16f92a$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $3ef321f56e16f92a$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $3ef321f56e16f92a$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $3ef321f56e16f92a$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $3ef321f56e16f92a$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $3ef321f56e16f92a$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $3ef321f56e16f92a$var$safelyDetachRef(finishedWork, finishedWork.return);
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $3ef321f56e16f92a$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $3ef321f56e16f92a$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$3ef321f56e16f92a$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $3ef321f56e16f92a$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $3ef321f56e16f92a$var$commitClassCallbacks(finishedWork);
                $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $3ef321f56e16f92a$var$commitHostMount(finishedWork);
                $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $3ef321f56e16f92a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $3ef321f56e16f92a$var$releaseCache(previousCache));
}
function $3ef321f56e16f92a$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $3ef321f56e16f92a$var$releaseCache(current));
}
function $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $3ef321f56e16f92a$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $3ef321f56e16f92a$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $3ef321f56e16f92a$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $3ef321f56e16f92a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $3ef321f56e16f92a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $3ef321f56e16f92a$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $3ef321f56e16f92a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $3ef321f56e16f92a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $3ef321f56e16f92a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $3ef321f56e16f92a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $3ef321f56e16f92a$var$suspenseyCommitFlag = 8192;
function $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $3ef321f56e16f92a$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $3ef321f56e16f92a$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $3ef321f56e16f92a$var$suspenseyCommitFlag && null !== fiber.memoizedState && $3ef321f56e16f92a$var$suspendResource($3ef321f56e16f92a$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $3ef321f56e16f92a$var$currentHoistableRoot;
            $3ef321f56e16f92a$var$currentHoistableRoot = $3ef321f56e16f92a$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $3ef321f56e16f92a$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $3ef321f56e16f92a$var$suspenseyCommitFlag, $3ef321f56e16f92a$var$suspenseyCommitFlag = 16777216, $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber), $3ef321f56e16f92a$var$suspenseyCommitFlag = previousHoistableRoot) : $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $3ef321f56e16f92a$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $3ef321f56e16f92a$var$nextEffect = childToDelete;
            $3ef321f56e16f92a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $3ef321f56e16f92a$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $3ef321f56e16f92a$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $3ef321f56e16f92a$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $3ef321f56e16f92a$var$nextEffect = childToDelete;
            $3ef321f56e16f92a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $3ef321f56e16f92a$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $3ef321f56e16f92a$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $3ef321f56e16f92a$var$nextEffect;){
        var fiber = $3ef321f56e16f92a$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $3ef321f56e16f92a$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $3ef321f56e16f92a$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $3ef321f56e16f92a$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $3ef321f56e16f92a$var$nextEffect;){
            cache = $3ef321f56e16f92a$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $3ef321f56e16f92a$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $3ef321f56e16f92a$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $3ef321f56e16f92a$var$nextEffect = sibling;
                break a;
            }
            $3ef321f56e16f92a$var$nextEffect = returnFiber;
        }
    }
}
function $3ef321f56e16f92a$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3ef321f56e16f92a$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $3ef321f56e16f92a$var$FiberNode(tag, pendingProps, key, mode);
}
function $3ef321f56e16f92a$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $3ef321f56e16f92a$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $3ef321f56e16f92a$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $3ef321f56e16f92a$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $3ef321f56e16f92a$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $3ef321f56e16f92a$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $3ef321f56e16f92a$var$isHostHoistableType(type, pendingProps, $3ef321f56e16f92a$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE:
            return $3ef321f56e16f92a$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $3ef321f56e16f92a$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $3ef321f56e16f92a$var$REACT_PROFILER_TYPE:
            return type = $3ef321f56e16f92a$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $3ef321f56e16f92a$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $3ef321f56e16f92a$var$REACT_SUSPENSE_TYPE:
            return type = $3ef321f56e16f92a$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $3ef321f56e16f92a$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $3ef321f56e16f92a$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $3ef321f56e16f92a$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $3ef321f56e16f92a$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $3ef321f56e16f92a$var$REACT_OFFSCREEN_TYPE:
            return $3ef321f56e16f92a$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $3ef321f56e16f92a$var$REACT_PROVIDER_TYPE:
                case $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $3ef321f56e16f92a$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $3ef321f56e16f92a$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $3ef321f56e16f92a$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($3ef321f56e16f92a$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $3ef321f56e16f92a$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $3ef321f56e16f92a$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $3ef321f56e16f92a$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $3ef321f56e16f92a$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $3ef321f56e16f92a$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $3ef321f56e16f92a$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $3ef321f56e16f92a$var$createFiberFromText(content, mode, lanes) {
    content = $3ef321f56e16f92a$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $3ef321f56e16f92a$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $3ef321f56e16f92a$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $3ef321f56e16f92a$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $3ef321f56e16f92a$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$3ef321f56e16f92a$var$preloadResource(resource)) {
        resource = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 4194176) === $3ef321f56e16f92a$var$workInProgressRootRenderLanes ? null !== $3ef321f56e16f92a$var$shellBoundary : ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 62914560) !== $3ef321f56e16f92a$var$workInProgressRootRenderLanes && 0 === ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 536870912) || resource !== $3ef321f56e16f92a$var$shellBoundary)) throw $3ef321f56e16f92a$var$suspendedThenable = $3ef321f56e16f92a$var$noopSuspenseyCommitThenable, $3ef321f56e16f92a$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $3ef321f56e16f92a$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $3ef321f56e16f92a$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$3ef321f56e16f92a$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $3ef321f56e16f92a$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $3ef321f56e16f92a$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $3ef321f56e16f92a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 1:
            return $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext);
            $3ef321f56e16f92a$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $3ef321f56e16f92a$var$popHydrationState(workInProgress) ? $3ef321f56e16f92a$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $3ef321f56e16f92a$var$hydrationErrors && ($3ef321f56e16f92a$var$queueRecoverableErrors($3ef321f56e16f92a$var$hydrationErrors), $3ef321f56e16f92a$var$hydrationErrors = null));
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($3ef321f56e16f92a$var$markUpdate(workInProgress), null !== renderLanes ? ($3ef321f56e16f92a$var$bubbleProperties(workInProgress), $3ef321f56e16f92a$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($3ef321f56e16f92a$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($3ef321f56e16f92a$var$markUpdate(workInProgress), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), $3ef321f56e16f92a$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($3ef321f56e16f92a$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $3ef321f56e16f92a$var$popHostContext(workInProgress);
            renderLanes = $3ef321f56e16f92a$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(166));
                    $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $3ef321f56e16f92a$var$contextStackCursor.current;
                $3ef321f56e16f92a$var$popHydrationState(workInProgress) ? $3ef321f56e16f92a$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $3ef321f56e16f92a$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $3ef321f56e16f92a$var$markUpdate(workInProgress));
            }
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $3ef321f56e16f92a$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(166));
                    $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $3ef321f56e16f92a$var$contextStackCursor.current;
                if ($3ef321f56e16f92a$var$popHydrationState(workInProgress)) $3ef321f56e16f92a$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer($3ef321f56e16f92a$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress;
                    current[$3ef321f56e16f92a$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($3ef321f56e16f92a$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $3ef321f56e16f92a$var$markUpdate(workInProgress);
                }
            }
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(166));
                current = $3ef321f56e16f92a$var$rootInstanceStackCursor.current;
                if ($3ef321f56e16f92a$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $3ef321f56e16f92a$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $3ef321f56e16f92a$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress);
                } else current = $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $3ef321f56e16f92a$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(317));
                        type[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress;
                    } else $3ef321f56e16f92a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $3ef321f56e16f92a$var$hydrationErrors && ($3ef321f56e16f92a$var$queueRecoverableErrors($3ef321f56e16f92a$var$hydrationErrors), $3ef321f56e16f92a$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $3ef321f56e16f92a$var$popHostContainer(), null === current && $3ef321f56e16f92a$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 10:
            return $3ef321f56e16f92a$var$popProvider(workInProgress.type), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 19:
            $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $3ef321f56e16f92a$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $3ef321f56e16f92a$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $3ef321f56e16f92a$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $3ef321f56e16f92a$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$3ef321f56e16f92a$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $3ef321f56e16f92a$var$now() > $3ef321f56e16f92a$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $3ef321f56e16f92a$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $3ef321f56e16f92a$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, current), $3ef321f56e16f92a$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$3ef321f56e16f92a$var$isHydrating) return $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
                    } else 2 * $3ef321f56e16f92a$var$now() - type.renderingStartTime > $3ef321f56e16f92a$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $3ef321f56e16f92a$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $3ef321f56e16f92a$var$now(), workInProgress.sibling = null, current = $3ef321f56e16f92a$var$suspenseStackCursor.current, $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress), $3ef321f56e16f92a$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($3ef321f56e16f92a$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $3ef321f56e16f92a$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $3ef321f56e16f92a$var$unwindWork(current, workInProgress) {
    $3ef321f56e16f92a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext), $3ef321f56e16f92a$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $3ef321f56e16f92a$var$popHostContext(workInProgress), null;
        case 13:
            $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(340));
                $3ef321f56e16f92a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseStackCursor), null;
        case 4:
            return $3ef321f56e16f92a$var$popHostContainer(), null;
        case 10:
            return $3ef321f56e16f92a$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress), $3ef321f56e16f92a$var$popHiddenContext(), null !== current && $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $3ef321f56e16f92a$var$unwindInterruptedWork(current, interruptedWork) {
    $3ef321f56e16f92a$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext);
            $3ef321f56e16f92a$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $3ef321f56e16f92a$var$popHostContext(interruptedWork);
            break;
        case 4:
            $3ef321f56e16f92a$var$popHostContainer();
            break;
        case 13:
            $3ef321f56e16f92a$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseStackCursor);
            break;
        case 10:
            $3ef321f56e16f92a$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $3ef321f56e16f92a$var$popSuspenseHandler(interruptedWork);
            $3ef321f56e16f92a$var$popHiddenContext();
            null !== current && $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$resumedCache);
            break;
        case 24:
            $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext);
    }
}
var $3ef321f56e16f92a$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $3ef321f56e16f92a$var$readContext($3ef321f56e16f92a$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $3ef321f56e16f92a$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $3ef321f56e16f92a$var$executionContext = 0, $3ef321f56e16f92a$var$workInProgressRoot = null, $3ef321f56e16f92a$var$workInProgress = null, $3ef321f56e16f92a$var$workInProgressRootRenderLanes = 0, $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0, $3ef321f56e16f92a$var$workInProgressThrownValue = null, $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings = !1, $3ef321f56e16f92a$var$workInProgressRootIsPrerendering = !1, $3ef321f56e16f92a$var$workInProgressRootDidAttachPingListener = !1, $3ef321f56e16f92a$var$entangledRenderLanes = 0, $3ef321f56e16f92a$var$workInProgressRootExitStatus = 0, $3ef321f56e16f92a$var$workInProgressRootSkippedLanes = 0, $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes = 0, $3ef321f56e16f92a$var$workInProgressRootPingedLanes = 0, $3ef321f56e16f92a$var$workInProgressDeferredLane = 0, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes = 0, $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors = null, $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = null, $3ef321f56e16f92a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $3ef321f56e16f92a$var$globalMostRecentFallbackTime = 0, $3ef321f56e16f92a$var$workInProgressRootRenderTargetTime = Infinity, $3ef321f56e16f92a$var$workInProgressTransitions = null, $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed = null, $3ef321f56e16f92a$var$rootDoesHavePassiveEffects = !1, $3ef321f56e16f92a$var$rootWithPendingPassiveEffects = null, $3ef321f56e16f92a$var$pendingPassiveEffectsLanes = 0, $3ef321f56e16f92a$var$pendingPassiveEffectsRemainingLanes = 0, $3ef321f56e16f92a$var$pendingPassiveTransitions = null, $3ef321f56e16f92a$var$nestedUpdateCount = 0, $3ef321f56e16f92a$var$rootWithNestedUpdates = null;
function $3ef321f56e16f92a$var$requestUpdateLane() {
    if (0 !== ($3ef321f56e16f92a$var$executionContext & 2) && 0 !== $3ef321f56e16f92a$var$workInProgressRootRenderLanes) return $3ef321f56e16f92a$var$workInProgressRootRenderLanes & -$3ef321f56e16f92a$var$workInProgressRootRenderLanes;
    if (null !== $3ef321f56e16f92a$var$ReactSharedInternals.T) {
        var actionScopeLane = $3ef321f56e16f92a$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $3ef321f56e16f92a$var$requestTransitionLane();
    }
    return $3ef321f56e16f92a$var$resolveUpdatePriority();
}
function $3ef321f56e16f92a$var$requestDeferredLane() {
    0 === $3ef321f56e16f92a$var$workInProgressDeferredLane && ($3ef321f56e16f92a$var$workInProgressDeferredLane = 0 === ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 536870912) || $3ef321f56e16f92a$var$isHydrating ? $3ef321f56e16f92a$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $3ef321f56e16f92a$var$workInProgressDeferredLane;
}
function $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $3ef321f56e16f92a$var$workInProgressRoot && 2 === $3ef321f56e16f92a$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $3ef321f56e16f92a$var$prepareFreshStack(root, 0), $3ef321f56e16f92a$var$markRootSuspended(root, $3ef321f56e16f92a$var$workInProgressRootRenderLanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !1);
    $3ef321f56e16f92a$var$markRootUpdated$1(root, lane);
    if (0 === ($3ef321f56e16f92a$var$executionContext & 2) || root !== $3ef321f56e16f92a$var$workInProgressRoot) root === $3ef321f56e16f92a$var$workInProgressRoot && (0 === ($3ef321f56e16f92a$var$executionContext & 2) && ($3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $3ef321f56e16f92a$var$workInProgressRootExitStatus && $3ef321f56e16f92a$var$markRootSuspended(root, $3ef321f56e16f92a$var$workInProgressRootRenderLanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !1)), $3ef321f56e16f92a$var$ensureRootIsScheduled(root);
}
function $3ef321f56e16f92a$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($3ef321f56e16f92a$var$executionContext & 6)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $3ef321f56e16f92a$var$renderRootConcurrent(root$jscomp$0, lanes) : $3ef321f56e16f92a$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $3ef321f56e16f92a$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $3ef321f56e16f92a$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $3ef321f56e16f92a$var$markRootSuspended(root$jscomp$0, lanes, 0, !$3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$3ef321f56e16f92a$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $3ef321f56e16f92a$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($3ef321f56e16f92a$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $3ef321f56e16f92a$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($3ef321f56e16f92a$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors;
                            $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $3ef321f56e16f92a$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $3ef321f56e16f92a$var$prepareFreshStack(root$jscomp$0, 0);
                $3ef321f56e16f92a$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $3ef321f56e16f92a$var$markRootSuspended(shouldTimeSlice, lanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !$3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $3ef321f56e16f92a$var$globalMostRecentFallbackTime + 300 - $3ef321f56e16f92a$var$now(), 10 < renderWasConcurrent)) {
                    $3ef321f56e16f92a$var$markRootSuspended(shouldTimeSlice, lanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !$3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $3ef321f56e16f92a$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $3ef321f56e16f92a$var$scheduleTimeout($3ef321f56e16f92a$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors, $3ef321f56e16f92a$var$workInProgressTransitions, $3ef321f56e16f92a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes, $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $3ef321f56e16f92a$var$commitRootWhenReady(shouldTimeSlice, forceSync, $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors, $3ef321f56e16f92a$var$workInProgressTransitions, $3ef321f56e16f92a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes, $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $3ef321f56e16f92a$var$ensureRootIsScheduled(root$jscomp$0);
}
function $3ef321f56e16f92a$var$queueRecoverableErrors(errors) {
    null === $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors ? $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = errors : $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors.push.apply($3ef321f56e16f92a$var$workInProgressRootRecoverableErrors, errors);
}
function $3ef321f56e16f92a$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($3ef321f56e16f92a$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $3ef321f56e16f92a$var$noop
        }, $3ef321f56e16f92a$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $3ef321f56e16f92a$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($3ef321f56e16f92a$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $3ef321f56e16f92a$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $3ef321f56e16f92a$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $3ef321f56e16f92a$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$3ef321f56e16f92a$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $3ef321f56e16f92a$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$3ef321f56e16f92a$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $3ef321f56e16f92a$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $3ef321f56e16f92a$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $3ef321f56e16f92a$var$flushSyncWork$1() {
    return 0 === ($3ef321f56e16f92a$var$executionContext & 6) ? ($3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $3ef321f56e16f92a$var$resetWorkInProgressStack() {
    if (null !== $3ef321f56e16f92a$var$workInProgress) {
        if (0 === $3ef321f56e16f92a$var$workInProgressSuspendedReason) var interruptedWork = $3ef321f56e16f92a$var$workInProgress.return;
        else interruptedWork = $3ef321f56e16f92a$var$workInProgress, $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$currentlyRenderingFiber = null, $3ef321f56e16f92a$var$resetHooksOnUnwind(interruptedWork), $3ef321f56e16f92a$var$thenableState$1 = null, $3ef321f56e16f92a$var$thenableIndexCounter$1 = 0, interruptedWork = $3ef321f56e16f92a$var$workInProgress;
        for(; null !== interruptedWork;)$3ef321f56e16f92a$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $3ef321f56e16f92a$var$workInProgress = null;
    }
}
function $3ef321f56e16f92a$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $3ef321f56e16f92a$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $3ef321f56e16f92a$var$resetWorkInProgressStack();
    $3ef321f56e16f92a$var$workInProgressRoot = root;
    $3ef321f56e16f92a$var$workInProgress = timeoutHandle = $3ef321f56e16f92a$var$createWorkInProgress(root.current, null);
    $3ef321f56e16f92a$var$workInProgressRootRenderLanes = lanes;
    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
    $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $3ef321f56e16f92a$var$workInProgressRootIsPrerendering = $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root, lanes);
    $3ef321f56e16f92a$var$workInProgressRootDidAttachPingListener = !1;
    $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes = $3ef321f56e16f92a$var$workInProgressDeferredLane = $3ef321f56e16f92a$var$workInProgressRootPingedLanes = $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes = $3ef321f56e16f92a$var$workInProgressRootSkippedLanes = $3ef321f56e16f92a$var$workInProgressRootExitStatus = 0;
    $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors = null;
    $3ef321f56e16f92a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $3ef321f56e16f92a$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $3ef321f56e16f92a$var$entangledRenderLanes = lanes;
    $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $3ef321f56e16f92a$var$handleThrow(root, thrownValue) {
    $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = $3ef321f56e16f92a$var$ContextOnlyDispatcher;
    thrownValue === $3ef321f56e16f92a$var$SuspenseException ? (thrownValue = $3ef321f56e16f92a$var$getSuspendedThenable(), $3ef321f56e16f92a$var$workInProgressSuspendedReason = 3) : thrownValue === $3ef321f56e16f92a$var$SuspenseyCommitException ? (thrownValue = $3ef321f56e16f92a$var$getSuspendedThenable(), $3ef321f56e16f92a$var$workInProgressSuspendedReason = 4) : $3ef321f56e16f92a$var$workInProgressSuspendedReason = thrownValue === $3ef321f56e16f92a$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $3ef321f56e16f92a$var$workInProgressThrownValue = thrownValue;
    null === $3ef321f56e16f92a$var$workInProgress && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 1, $3ef321f56e16f92a$var$logUncaughtError(root, $3ef321f56e16f92a$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $3ef321f56e16f92a$var$pushDispatcher() {
    var prevDispatcher = $3ef321f56e16f92a$var$ReactSharedInternals.H;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = $3ef321f56e16f92a$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $3ef321f56e16f92a$var$ContextOnlyDispatcher : prevDispatcher;
}
function $3ef321f56e16f92a$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $3ef321f56e16f92a$var$ReactSharedInternals.A;
    $3ef321f56e16f92a$var$ReactSharedInternals.A = $3ef321f56e16f92a$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible() {
    $3ef321f56e16f92a$var$workInProgressRootExitStatus = 4;
    $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings || ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 4194176) !== $3ef321f56e16f92a$var$workInProgressRootRenderLanes && null !== $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current || ($3ef321f56e16f92a$var$workInProgressRootIsPrerendering = !0);
    0 === ($3ef321f56e16f92a$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $3ef321f56e16f92a$var$workInProgressRoot || $3ef321f56e16f92a$var$markRootSuspended($3ef321f56e16f92a$var$workInProgressRoot, $3ef321f56e16f92a$var$workInProgressRootRenderLanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !1);
}
function $3ef321f56e16f92a$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $3ef321f56e16f92a$var$executionContext;
    $3ef321f56e16f92a$var$executionContext |= 2;
    var prevDispatcher = $3ef321f56e16f92a$var$pushDispatcher(), prevAsyncDispatcher = $3ef321f56e16f92a$var$pushAsyncDispatcher();
    if ($3ef321f56e16f92a$var$workInProgressRoot !== root || $3ef321f56e16f92a$var$workInProgressRootRenderLanes !== lanes) $3ef321f56e16f92a$var$workInProgressTransitions = null, $3ef321f56e16f92a$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $3ef321f56e16f92a$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $3ef321f56e16f92a$var$workInProgressSuspendedReason && null !== $3ef321f56e16f92a$var$workInProgress) {
            var unitOfWork = $3ef321f56e16f92a$var$workInProgress, thrownValue = $3ef321f56e16f92a$var$workInProgressThrownValue;
            switch($3ef321f56e16f92a$var$workInProgressSuspendedReason){
                case 8:
                    $3ef321f56e16f92a$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $3ef321f56e16f92a$var$workInProgressSuspendedReason;
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                    $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $3ef321f56e16f92a$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $3ef321f56e16f92a$var$workInProgressSuspendedReason, $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0, $3ef321f56e16f92a$var$workInProgressThrownValue = null, $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $3ef321f56e16f92a$var$workLoopSync();
        exitStatus = $3ef321f56e16f92a$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $3ef321f56e16f92a$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$currentlyRenderingFiber = null;
    $3ef321f56e16f92a$var$executionContext = prevExecutionContext;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = prevDispatcher;
    $3ef321f56e16f92a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $3ef321f56e16f92a$var$workInProgress && ($3ef321f56e16f92a$var$workInProgressRoot = null, $3ef321f56e16f92a$var$workInProgressRootRenderLanes = 0, $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $3ef321f56e16f92a$var$workLoopSync() {
    for(; null !== $3ef321f56e16f92a$var$workInProgress;)$3ef321f56e16f92a$var$performUnitOfWork($3ef321f56e16f92a$var$workInProgress);
}
function $3ef321f56e16f92a$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $3ef321f56e16f92a$var$executionContext;
    $3ef321f56e16f92a$var$executionContext |= 2;
    var prevDispatcher = $3ef321f56e16f92a$var$pushDispatcher(), prevAsyncDispatcher = $3ef321f56e16f92a$var$pushAsyncDispatcher();
    $3ef321f56e16f92a$var$workInProgressRoot !== root || $3ef321f56e16f92a$var$workInProgressRootRenderLanes !== lanes ? ($3ef321f56e16f92a$var$workInProgressTransitions = null, $3ef321f56e16f92a$var$workInProgressRootRenderTargetTime = $3ef321f56e16f92a$var$now() + 500, $3ef321f56e16f92a$var$prepareFreshStack(root, lanes)) : $3ef321f56e16f92a$var$workInProgressRootIsPrerendering = $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $3ef321f56e16f92a$var$workInProgressSuspendedReason && null !== $3ef321f56e16f92a$var$workInProgress) {
            lanes = $3ef321f56e16f92a$var$workInProgress;
            var thrownValue = $3ef321f56e16f92a$var$workInProgressThrownValue;
            b: switch($3ef321f56e16f92a$var$workInProgressSuspendedReason){
                case 1:
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                    $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($3ef321f56e16f92a$var$isThenableResolved(thrownValue)) {
                        $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                        $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                        $3ef321f56e16f92a$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $3ef321f56e16f92a$var$workInProgressSuspendedReason && $3ef321f56e16f92a$var$workInProgressRoot === root && ($3ef321f56e16f92a$var$workInProgressSuspendedReason = 7);
                        $3ef321f56e16f92a$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $3ef321f56e16f92a$var$isThenableResolved(thrownValue) ? ($3ef321f56e16f92a$var$workInProgressSuspendedReason = 0, $3ef321f56e16f92a$var$workInProgressThrownValue = null, $3ef321f56e16f92a$var$replaySuspendedUnitOfWork(lanes)) : ($3ef321f56e16f92a$var$workInProgressSuspendedReason = 0, $3ef321f56e16f92a$var$workInProgressThrownValue = null, $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($3ef321f56e16f92a$var$workInProgress.tag){
                        case 26:
                            resource = $3ef321f56e16f92a$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $3ef321f56e16f92a$var$workInProgress;
                            if (resource ? $3ef321f56e16f92a$var$preloadResource(resource) : 1) {
                                $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                                $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $3ef321f56e16f92a$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($3ef321f56e16f92a$var$workInProgress = returnFiber, $3ef321f56e16f92a$var$completeUnitOfWork(returnFiber)) : $3ef321f56e16f92a$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                    $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                    $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $3ef321f56e16f92a$var$resetWorkInProgressStack();
                    $3ef321f56e16f92a$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(462));
            }
        }
        $3ef321f56e16f92a$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $3ef321f56e16f92a$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$currentlyRenderingFiber = null;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = prevDispatcher;
    $3ef321f56e16f92a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $3ef321f56e16f92a$var$executionContext = prevExecutionContext;
    if (null !== $3ef321f56e16f92a$var$workInProgress) return 0;
    $3ef321f56e16f92a$var$workInProgressRoot = null;
    $3ef321f56e16f92a$var$workInProgressRootRenderLanes = 0;
    $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates();
    return $3ef321f56e16f92a$var$workInProgressRootExitStatus;
}
function $3ef321f56e16f92a$var$workLoopConcurrent() {
    for(; null !== $3ef321f56e16f92a$var$workInProgress && !$3ef321f56e16f92a$var$shouldYield();)$3ef321f56e16f92a$var$performUnitOfWork($3ef321f56e16f92a$var$workInProgress);
}
function $3ef321f56e16f92a$var$performUnitOfWork(unitOfWork) {
    var next = $3ef321f56e16f92a$var$beginWork(unitOfWork.alternate, unitOfWork, $3ef321f56e16f92a$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $3ef321f56e16f92a$var$completeUnitOfWork(unitOfWork) : $3ef321f56e16f92a$var$workInProgress = next;
}
function $3ef321f56e16f92a$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $3ef321f56e16f92a$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $3ef321f56e16f92a$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $3ef321f56e16f92a$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $3ef321f56e16f92a$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $3ef321f56e16f92a$var$resetHooksOnUnwind(next);
        default:
            $3ef321f56e16f92a$var$unwindInterruptedWork(current, next), next = $3ef321f56e16f92a$var$workInProgress = $3ef321f56e16f92a$var$resetWorkInProgress(next, $3ef321f56e16f92a$var$entangledRenderLanes), next = $3ef321f56e16f92a$var$beginWork(current, next, $3ef321f56e16f92a$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $3ef321f56e16f92a$var$completeUnitOfWork(unitOfWork) : $3ef321f56e16f92a$var$workInProgress = next;
}
function $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$currentlyRenderingFiber = null;
    $3ef321f56e16f92a$var$resetHooksOnUnwind(unitOfWork);
    $3ef321f56e16f92a$var$thenableState$1 = null;
    $3ef321f56e16f92a$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($3ef321f56e16f92a$var$throwException(root, returnFiber, unitOfWork, thrownValue, $3ef321f56e16f92a$var$workInProgressRootRenderLanes)) {
            $3ef321f56e16f92a$var$workInProgressRootExitStatus = 1;
            $3ef321f56e16f92a$var$logUncaughtError(root, $3ef321f56e16f92a$var$createCapturedValueAtFiber(thrownValue, root.current));
            $3ef321f56e16f92a$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $3ef321f56e16f92a$var$workInProgress = returnFiber, error;
        $3ef321f56e16f92a$var$workInProgressRootExitStatus = 1;
        $3ef321f56e16f92a$var$logUncaughtError(root, $3ef321f56e16f92a$var$createCapturedValueAtFiber(thrownValue, root.current));
        $3ef321f56e16f92a$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($3ef321f56e16f92a$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($3ef321f56e16f92a$var$workInProgressRootIsPrerendering || 0 !== ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $3ef321f56e16f92a$var$unwindUnitOfWork(unitOfWork, root);
    } else $3ef321f56e16f92a$var$completeUnitOfWork(unitOfWork);
}
function $3ef321f56e16f92a$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $3ef321f56e16f92a$var$unwindUnitOfWork(completedWork, $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $3ef321f56e16f92a$var$completeWork(completedWork.alternate, completedWork, $3ef321f56e16f92a$var$entangledRenderLanes);
        if (null !== next) {
            $3ef321f56e16f92a$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $3ef321f56e16f92a$var$workInProgress = completedWork;
            return;
        }
        $3ef321f56e16f92a$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 5);
}
function $3ef321f56e16f92a$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $3ef321f56e16f92a$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $3ef321f56e16f92a$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $3ef321f56e16f92a$var$workInProgress = unitOfWork;
            return;
        }
        $3ef321f56e16f92a$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $3ef321f56e16f92a$var$workInProgressRootExitStatus = 6;
    $3ef321f56e16f92a$var$workInProgress = null;
}
function $3ef321f56e16f92a$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T, previousUpdateLanePriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    try {
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 2, $3ef321f56e16f92a$var$ReactSharedInternals.T = null, $3ef321f56e16f92a$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition, $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $3ef321f56e16f92a$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $3ef321f56e16f92a$var$flushPassiveEffects();
    while (null !== $3ef321f56e16f92a$var$rootWithPendingPassiveEffects);
    if (0 !== ($3ef321f56e16f92a$var$executionContext & 6)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $3ef321f56e16f92a$var$concurrentlyUpdatedLanes;
    $3ef321f56e16f92a$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $3ef321f56e16f92a$var$workInProgressRoot && ($3ef321f56e16f92a$var$workInProgress = $3ef321f56e16f92a$var$workInProgressRoot = null, $3ef321f56e16f92a$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $3ef321f56e16f92a$var$rootDoesHavePassiveEffects || ($3ef321f56e16f92a$var$rootDoesHavePassiveEffects = !0, $3ef321f56e16f92a$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $3ef321f56e16f92a$var$pendingPassiveTransitions = transitions, $3ef321f56e16f92a$var$scheduleCallback$1($3ef321f56e16f92a$var$NormalPriority$1, function() {
        $3ef321f56e16f92a$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $3ef321f56e16f92a$var$ReactSharedInternals.T, $3ef321f56e16f92a$var$ReactSharedInternals.T = null, spawnedLane = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p, $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 2, updatedLanes = $3ef321f56e16f92a$var$executionContext, $3ef321f56e16f92a$var$executionContext |= 4, $3ef321f56e16f92a$var$commitBeforeMutationEffects(root, finishedWork), $3ef321f56e16f92a$var$commitMutationEffectsOnFiber(finishedWork, root), $3ef321f56e16f92a$var$restoreSelection($3ef321f56e16f92a$var$selectionInformation, root.containerInfo), $3ef321f56e16f92a$var$_enabled = !!$3ef321f56e16f92a$var$eventsEnabled, $3ef321f56e16f92a$var$selectionInformation = $3ef321f56e16f92a$var$eventsEnabled = null, root.current = finishedWork, $3ef321f56e16f92a$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $3ef321f56e16f92a$var$requestPaint(), $3ef321f56e16f92a$var$executionContext = updatedLanes, $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = spawnedLane, $3ef321f56e16f92a$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $3ef321f56e16f92a$var$rootDoesHavePassiveEffects ? ($3ef321f56e16f92a$var$rootDoesHavePassiveEffects = !1, $3ef321f56e16f92a$var$rootWithPendingPassiveEffects = root, $3ef321f56e16f92a$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $3ef321f56e16f92a$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $3ef321f56e16f92a$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $3ef321f56e16f92a$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($3ef321f56e16f92a$var$pendingPassiveEffectsLanes & 3) && $3ef321f56e16f92a$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $3ef321f56e16f92a$var$rootWithNestedUpdates ? $3ef321f56e16f92a$var$nestedUpdateCount++ : ($3ef321f56e16f92a$var$nestedUpdateCount = 0, $3ef321f56e16f92a$var$rootWithNestedUpdates = root) : $3ef321f56e16f92a$var$nestedUpdateCount = 0;
    $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $3ef321f56e16f92a$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $3ef321f56e16f92a$var$releaseCache(remainingLanes)));
}
function $3ef321f56e16f92a$var$flushPassiveEffects() {
    if (null !== $3ef321f56e16f92a$var$rootWithPendingPassiveEffects) {
        var root$170 = $3ef321f56e16f92a$var$rootWithPendingPassiveEffects, remainingLanes = $3ef321f56e16f92a$var$pendingPassiveEffectsRemainingLanes;
        $3ef321f56e16f92a$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $3ef321f56e16f92a$var$lanesToEventPriority($3ef321f56e16f92a$var$pendingPassiveEffectsLanes), prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T, previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
        try {
            $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
            if (null === $3ef321f56e16f92a$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $3ef321f56e16f92a$var$pendingPassiveTransitions;
                $3ef321f56e16f92a$var$pendingPassiveTransitions = null;
                var root = $3ef321f56e16f92a$var$rootWithPendingPassiveEffects, lanes = $3ef321f56e16f92a$var$pendingPassiveEffectsLanes;
                $3ef321f56e16f92a$var$rootWithPendingPassiveEffects = null;
                $3ef321f56e16f92a$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($3ef321f56e16f92a$var$executionContext & 6)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(331));
                var prevExecutionContext = $3ef321f56e16f92a$var$executionContext;
                $3ef321f56e16f92a$var$executionContext |= 4;
                $3ef321f56e16f92a$var$commitPassiveUnmountOnFiber(root.current);
                $3ef321f56e16f92a$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $3ef321f56e16f92a$var$executionContext = prevExecutionContext;
                $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($3ef321f56e16f92a$var$injectedHook && "function" === typeof $3ef321f56e16f92a$var$injectedHook.onPostCommitFiberRoot) try {
                    $3ef321f56e16f92a$var$injectedHook.onPostCommitFiberRoot($3ef321f56e16f92a$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition, $3ef321f56e16f92a$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $3ef321f56e16f92a$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $3ef321f56e16f92a$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $3ef321f56e16f92a$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $3ef321f56e16f92a$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($3ef321f56e16f92a$var$markRootUpdated$1(rootFiber, 2), $3ef321f56e16f92a$var$ensureRootIsScheduled(rootFiber));
}
function $3ef321f56e16f92a$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $3ef321f56e16f92a$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $3ef321f56e16f92a$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed || !$3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $3ef321f56e16f92a$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $3ef321f56e16f92a$var$createClassErrorUpdate(2);
                instance = $3ef321f56e16f92a$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($3ef321f56e16f92a$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $3ef321f56e16f92a$var$markRootUpdated$1(instance, 2), $3ef321f56e16f92a$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $3ef321f56e16f92a$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $3ef321f56e16f92a$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($3ef321f56e16f92a$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $3ef321f56e16f92a$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $3ef321f56e16f92a$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $3ef321f56e16f92a$var$workInProgressRoot === root && ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $3ef321f56e16f92a$var$workInProgressRootExitStatus || 3 === $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 62914560) === $3ef321f56e16f92a$var$workInProgressRootRenderLanes && 300 > $3ef321f56e16f92a$var$now() - $3ef321f56e16f92a$var$globalMostRecentFallbackTime ? 0 === ($3ef321f56e16f92a$var$executionContext & 2) && $3ef321f56e16f92a$var$prepareFreshStack(root, 0) : $3ef321f56e16f92a$var$workInProgressRootPingedLanes |= pingedLanes, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes === $3ef321f56e16f92a$var$workInProgressRootRenderLanes && ($3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes = 0));
    $3ef321f56e16f92a$var$ensureRootIsScheduled(root);
}
function $3ef321f56e16f92a$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $3ef321f56e16f92a$var$claimNextRetryLane());
    boundaryFiber = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($3ef321f56e16f92a$var$markRootUpdated$1(boundaryFiber, retryLane), $3ef321f56e16f92a$var$ensureRootIsScheduled(boundaryFiber));
}
function $3ef321f56e16f92a$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $3ef321f56e16f92a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $3ef321f56e16f92a$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $3ef321f56e16f92a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $3ef321f56e16f92a$var$scheduleCallback$1(priorityLevel, callback) {
    return $3ef321f56e16f92a$var$scheduleCallback$3(priorityLevel, callback);
}
var $3ef321f56e16f92a$var$firstScheduledRoot = null, $3ef321f56e16f92a$var$lastScheduledRoot = null, $3ef321f56e16f92a$var$didScheduleMicrotask = !1, $3ef321f56e16f92a$var$mightHavePendingSyncWork = !1, $3ef321f56e16f92a$var$isFlushingWork = !1, $3ef321f56e16f92a$var$currentEventTransitionLane = 0;
function $3ef321f56e16f92a$var$ensureRootIsScheduled(root) {
    root !== $3ef321f56e16f92a$var$lastScheduledRoot && null === root.next && (null === $3ef321f56e16f92a$var$lastScheduledRoot ? $3ef321f56e16f92a$var$firstScheduledRoot = $3ef321f56e16f92a$var$lastScheduledRoot = root : $3ef321f56e16f92a$var$lastScheduledRoot = $3ef321f56e16f92a$var$lastScheduledRoot.next = root);
    $3ef321f56e16f92a$var$mightHavePendingSyncWork = !0;
    $3ef321f56e16f92a$var$didScheduleMicrotask || ($3ef321f56e16f92a$var$didScheduleMicrotask = !0, $3ef321f56e16f92a$var$scheduleImmediateTask($3ef321f56e16f92a$var$processRootScheduleInMicrotask));
}
function $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$3ef321f56e16f92a$var$isFlushingWork && $3ef321f56e16f92a$var$mightHavePendingSyncWork) {
        $3ef321f56e16f92a$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $3ef321f56e16f92a$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $3ef321f56e16f92a$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $3ef321f56e16f92a$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $3ef321f56e16f92a$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $3ef321f56e16f92a$var$getNextLanes(root$172, root$172 === $3ef321f56e16f92a$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $3ef321f56e16f92a$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $3ef321f56e16f92a$var$isFlushingWork = !1;
    }
}
function $3ef321f56e16f92a$var$processRootScheduleInMicrotask() {
    $3ef321f56e16f92a$var$mightHavePendingSyncWork = $3ef321f56e16f92a$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $3ef321f56e16f92a$var$currentEventTransitionLane && ($3ef321f56e16f92a$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $3ef321f56e16f92a$var$currentEventTransitionLane), $3ef321f56e16f92a$var$currentEventTransitionLane = 0);
    for(var currentTime = $3ef321f56e16f92a$var$now(), prev = null, root = $3ef321f56e16f92a$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $3ef321f56e16f92a$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $3ef321f56e16f92a$var$firstScheduledRoot = next : prev.next = next, null === next && ($3ef321f56e16f92a$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $3ef321f56e16f92a$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $3ef321f56e16f92a$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $3ef321f56e16f92a$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $3ef321f56e16f92a$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $3ef321f56e16f92a$var$workInProgressRoot;
    suspendedLanes = $3ef321f56e16f92a$var$workInProgressRootRenderLanes;
    suspendedLanes = $3ef321f56e16f92a$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $3ef321f56e16f92a$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $3ef321f56e16f92a$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $3ef321f56e16f92a$var$cancelCallback$1(pingedLanes);
        switch($3ef321f56e16f92a$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $3ef321f56e16f92a$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $3ef321f56e16f92a$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $3ef321f56e16f92a$var$IdlePriority;
                break;
            default:
                suspendedLanes = $3ef321f56e16f92a$var$NormalPriority$1;
        }
        pingedLanes = $3ef321f56e16f92a$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $3ef321f56e16f92a$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $3ef321f56e16f92a$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $3ef321f56e16f92a$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($3ef321f56e16f92a$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $3ef321f56e16f92a$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $3ef321f56e16f92a$var$getNextLanes(root, root === $3ef321f56e16f92a$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $3ef321f56e16f92a$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $3ef321f56e16f92a$var$scheduleTaskForRootDuringMicrotask(root, $3ef321f56e16f92a$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $3ef321f56e16f92a$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $3ef321f56e16f92a$var$performSyncWorkOnRoot(root, lanes) {
    if ($3ef321f56e16f92a$var$flushPassiveEffects()) return null;
    $3ef321f56e16f92a$var$performWorkOnRoot(root, lanes, !0);
}
function $3ef321f56e16f92a$var$scheduleImmediateTask(cb) {
    $3ef321f56e16f92a$var$scheduleMicrotask(function() {
        0 !== ($3ef321f56e16f92a$var$executionContext & 6) ? $3ef321f56e16f92a$var$scheduleCallback$3($3ef321f56e16f92a$var$ImmediatePriority, cb) : cb();
    });
}
function $3ef321f56e16f92a$var$requestTransitionLane() {
    0 === $3ef321f56e16f92a$var$currentEventTransitionLane && ($3ef321f56e16f92a$var$currentEventTransitionLane = $3ef321f56e16f92a$var$claimNextTransitionLane());
    return $3ef321f56e16f92a$var$currentEventTransitionLane;
}
function $3ef321f56e16f92a$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $3ef321f56e16f92a$var$sanitizeURL("" + actionProp);
}
function $3ef321f56e16f92a$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $3ef321f56e16f92a$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $3ef321f56e16f92a$var$coerceFormActionProp((nativeEventTarget[$3ef321f56e16f92a$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$3ef321f56e16f92a$var$internalPropsKey] || null) ? $3ef321f56e16f92a$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $3ef321f56e16f92a$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $3ef321f56e16f92a$var$currentEventTransitionLane) {
                                var formData = submitter ? $3ef321f56e16f92a$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $3ef321f56e16f92a$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $3ef321f56e16f92a$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $3ef321f56e16f92a$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $3ef321f56e16f92a$var$i$jscomp$inline_1439 = 0; $3ef321f56e16f92a$var$i$jscomp$inline_1439 < $3ef321f56e16f92a$var$simpleEventPluginEvents.length; $3ef321f56e16f92a$var$i$jscomp$inline_1439++){
    var $3ef321f56e16f92a$var$eventName$jscomp$inline_1440 = $3ef321f56e16f92a$var$simpleEventPluginEvents[$3ef321f56e16f92a$var$i$jscomp$inline_1439], $3ef321f56e16f92a$var$domEventName$jscomp$inline_1441 = $3ef321f56e16f92a$var$eventName$jscomp$inline_1440.toLowerCase(), $3ef321f56e16f92a$var$capitalizedEvent$jscomp$inline_1442 = $3ef321f56e16f92a$var$eventName$jscomp$inline_1440[0].toUpperCase() + $3ef321f56e16f92a$var$eventName$jscomp$inline_1440.slice(1);
    $3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$domEventName$jscomp$inline_1441, "on" + $3ef321f56e16f92a$var$capitalizedEvent$jscomp$inline_1442);
}
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$ANIMATION_END, "onAnimationEnd");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$ANIMATION_ITERATION, "onAnimationIteration");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$ANIMATION_START, "onAnimationStart");
$3ef321f56e16f92a$var$registerSimpleEvent("dblclick", "onDoubleClick");
$3ef321f56e16f92a$var$registerSimpleEvent("focusin", "onFocus");
$3ef321f56e16f92a$var$registerSimpleEvent("focusout", "onBlur");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$TRANSITION_RUN, "onTransitionRun");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$TRANSITION_START, "onTransitionStart");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$TRANSITION_CANCEL, "onTransitionCancel");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$TRANSITION_END, "onTransitionEnd");
$3ef321f56e16f92a$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3ef321f56e16f92a$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3ef321f56e16f92a$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3ef321f56e16f92a$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3ef321f56e16f92a$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3ef321f56e16f92a$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($3ef321f56e16f92a$var$mediaEventTypes));
function $3ef321f56e16f92a$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $3ef321f56e16f92a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $3ef321f56e16f92a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $3ef321f56e16f92a$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$3ef321f56e16f92a$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$3ef321f56e16f92a$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($3ef321f56e16f92a$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $3ef321f56e16f92a$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $3ef321f56e16f92a$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $3ef321f56e16f92a$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $3ef321f56e16f92a$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$3ef321f56e16f92a$var$listeningMarker]) {
        rootContainerElement[$3ef321f56e16f92a$var$listeningMarker] = !0;
        $3ef321f56e16f92a$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($3ef321f56e16f92a$var$nonDelegatedEvents.has(domEventName) || $3ef321f56e16f92a$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $3ef321f56e16f92a$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$3ef321f56e16f92a$var$listeningMarker] || (ownerDocument[$3ef321f56e16f92a$var$listeningMarker] = !0, $3ef321f56e16f92a$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $3ef321f56e16f92a$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($3ef321f56e16f92a$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $3ef321f56e16f92a$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $3ef321f56e16f92a$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $3ef321f56e16f92a$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$3ef321f56e16f92a$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $3ef321f56e16f92a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $3ef321f56e16f92a$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $3ef321f56e16f92a$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $3ef321f56e16f92a$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $3ef321f56e16f92a$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $3ef321f56e16f92a$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticTouchEvent;
                        break;
                    case $3ef321f56e16f92a$var$ANIMATION_END:
                    case $3ef321f56e16f92a$var$ANIMATION_ITERATION:
                    case $3ef321f56e16f92a$var$ANIMATION_START:
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticAnimationEvent;
                        break;
                    case $3ef321f56e16f92a$var$TRANSITION_END:
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $3ef321f56e16f92a$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($3ef321f56e16f92a$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $3ef321f56e16f92a$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($3ef321f56e16f92a$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$3ef321f56e16f92a$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $3ef321f56e16f92a$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $3ef321f56e16f92a$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $3ef321f56e16f92a$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $3ef321f56e16f92a$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $3ef321f56e16f92a$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $3ef321f56e16f92a$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $3ef321f56e16f92a$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $3ef321f56e16f92a$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $3ef321f56e16f92a$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $3ef321f56e16f92a$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $3ef321f56e16f92a$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $3ef321f56e16f92a$var$getParent(inCapturePhase);
                                reactEventName = $3ef321f56e16f92a$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $3ef321f56e16f92a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $3ef321f56e16f92a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $3ef321f56e16f92a$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForChangeEvent;
                else if ($3ef321f56e16f92a$var$isTextInputElement(reactName)) {
                    if ($3ef321f56e16f92a$var$isInputEventSupported) getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $3ef321f56e16f92a$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $3ef321f56e16f92a$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForChangeEvent) : getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $3ef321f56e16f92a$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $3ef321f56e16f92a$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $3ef321f56e16f92a$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($3ef321f56e16f92a$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $3ef321f56e16f92a$var$activeElement = handleEventFunc, $3ef321f56e16f92a$var$activeElementInst = targetInst, $3ef321f56e16f92a$var$lastSelection = null;
                    break;
                case "focusout":
                    $3ef321f56e16f92a$var$lastSelection = $3ef321f56e16f92a$var$activeElementInst = $3ef321f56e16f92a$var$activeElement = null;
                    break;
                case "mousedown":
                    $3ef321f56e16f92a$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3ef321f56e16f92a$var$mouseDown = !1;
                    $3ef321f56e16f92a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($3ef321f56e16f92a$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $3ef321f56e16f92a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($3ef321f56e16f92a$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $3ef321f56e16f92a$var$isComposing ? $3ef321f56e16f92a$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($3ef321f56e16f92a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($3ef321f56e16f92a$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $3ef321f56e16f92a$var$isComposing && (fallbackData = $3ef321f56e16f92a$var$getData()) : ($3ef321f56e16f92a$var$root = nativeEventTarget, $3ef321f56e16f92a$var$startText = "value" in $3ef321f56e16f92a$var$root ? $3ef321f56e16f92a$var$root.value : $3ef321f56e16f92a$var$root.textContent, $3ef321f56e16f92a$var$isComposing = !0)), handleEventFunc = $3ef321f56e16f92a$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $3ef321f56e16f92a$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $3ef321f56e16f92a$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $3ef321f56e16f92a$var$canUseTextInputEvent ? $3ef321f56e16f92a$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $3ef321f56e16f92a$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $3ef321f56e16f92a$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $3ef321f56e16f92a$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $3ef321f56e16f92a$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $3ef321f56e16f92a$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $3ef321f56e16f92a$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $3ef321f56e16f92a$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $3ef321f56e16f92a$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($3ef321f56e16f92a$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $3ef321f56e16f92a$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($3ef321f56e16f92a$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $3ef321f56e16f92a$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $3ef321f56e16f92a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $3ef321f56e16f92a$var$getListener(target, registrationName), null != stateNode && listeners.unshift($3ef321f56e16f92a$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $3ef321f56e16f92a$var$getListener(target, registrationName), null != stateNode && listeners.push($3ef321f56e16f92a$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $3ef321f56e16f92a$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $3ef321f56e16f92a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $3ef321f56e16f92a$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($3ef321f56e16f92a$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($3ef321f56e16f92a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $3ef321f56e16f92a$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $3ef321f56e16f92a$var$normalizeMarkupForTextOrAttribute(clientText);
    return $3ef321f56e16f92a$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $3ef321f56e16f92a$var$noop$1() {}
function $3ef321f56e16f92a$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $3ef321f56e16f92a$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $3ef321f56e16f92a$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $3ef321f56e16f92a$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $3ef321f56e16f92a$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $3ef321f56e16f92a$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $3ef321f56e16f92a$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $3ef321f56e16f92a$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $3ef321f56e16f92a$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $3ef321f56e16f92a$var$setProp(domElement, tag, "name", props.name, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($3ef321f56e16f92a$var$setProp(domElement, tag, "encType", props.encType, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "method", props.method, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $3ef321f56e16f92a$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $3ef321f56e16f92a$var$noop$1);
            break;
        case "onScroll":
            null != value && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $3ef321f56e16f92a$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", domElement);
            $3ef321f56e16f92a$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $3ef321f56e16f92a$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $3ef321f56e16f92a$var$aliases.get(key) || key, $3ef321f56e16f92a$var$setValueForAttribute(domElement, key, value);
    }
}
function $3ef321f56e16f92a$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $3ef321f56e16f92a$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $3ef321f56e16f92a$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $3ef321f56e16f92a$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $3ef321f56e16f92a$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$3ef321f56e16f92a$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$3ef321f56e16f92a$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $3ef321f56e16f92a$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $3ef321f56e16f92a$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                    default:
                        $3ef321f56e16f92a$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $3ef321f56e16f92a$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $3ef321f56e16f92a$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $3ef321f56e16f92a$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $3ef321f56e16f92a$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $3ef321f56e16f92a$var$track(domElement);
            return;
        case "select":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $3ef321f56e16f92a$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $3ef321f56e16f92a$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(91));
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $3ef321f56e16f92a$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $3ef321f56e16f92a$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("cancel", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $3ef321f56e16f92a$var$mediaEventTypes.length; hasSrc++)$3ef321f56e16f92a$var$listenToNonDelegatedEvent($3ef321f56e16f92a$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", domElement), $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($3ef321f56e16f92a$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $3ef321f56e16f92a$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $3ef321f56e16f92a$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $3ef321f56e16f92a$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $3ef321f56e16f92a$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $3ef321f56e16f92a$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $3ef321f56e16f92a$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $3ef321f56e16f92a$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $3ef321f56e16f92a$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $3ef321f56e16f92a$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $3ef321f56e16f92a$var$updateOptions(domElement, !!lastProps, tag, !0) : $3ef321f56e16f92a$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $3ef321f56e16f92a$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $3ef321f56e16f92a$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $3ef321f56e16f92a$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($3ef321f56e16f92a$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $3ef321f56e16f92a$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $3ef321f56e16f92a$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $3ef321f56e16f92a$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $3ef321f56e16f92a$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $3ef321f56e16f92a$var$eventsEnabled = null, $3ef321f56e16f92a$var$selectionInformation = null;
function $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $3ef321f56e16f92a$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $3ef321f56e16f92a$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $3ef321f56e16f92a$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $3ef321f56e16f92a$var$currentPopstateTransitionEvent = null;
function $3ef321f56e16f92a$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $3ef321f56e16f92a$var$currentPopstateTransitionEvent) return !1;
        $3ef321f56e16f92a$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $3ef321f56e16f92a$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $3ef321f56e16f92a$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $3ef321f56e16f92a$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $3ef321f56e16f92a$var$localPromise = "function" === typeof Promise ? Promise : void 0, $3ef321f56e16f92a$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3ef321f56e16f92a$var$localPromise ? function(callback) {
    return $3ef321f56e16f92a$var$localPromise.resolve(null).then(callback).catch($3ef321f56e16f92a$var$handleErrorInNextTick);
} : $3ef321f56e16f92a$var$scheduleTimeout;
function $3ef321f56e16f92a$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $3ef321f56e16f92a$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $3ef321f56e16f92a$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $3ef321f56e16f92a$var$retryIfBlockedOn(suspenseInstance);
}
function $3ef321f56e16f92a$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $3ef321f56e16f92a$var$clearContainerSparingly(node);
                $3ef321f56e16f92a$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $3ef321f56e16f92a$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$3ef321f56e16f92a$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $3ef321f56e16f92a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $3ef321f56e16f92a$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $3ef321f56e16f92a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $3ef321f56e16f92a$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $3ef321f56e16f92a$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $3ef321f56e16f92a$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(451));
    }
}
var $3ef321f56e16f92a$var$preloadPropsMap = new Map(), $3ef321f56e16f92a$var$preconnectsSet = new Set();
function $3ef321f56e16f92a$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $3ef321f56e16f92a$var$previousDispatcher = $3ef321f56e16f92a$var$ReactDOMSharedInternals.d;
$3ef321f56e16f92a$var$ReactDOMSharedInternals.d = {
    f: $3ef321f56e16f92a$var$flushSyncWork,
    r: $3ef321f56e16f92a$var$requestFormReset,
    D: $3ef321f56e16f92a$var$prefetchDNS,
    C: $3ef321f56e16f92a$var$preconnect,
    L: $3ef321f56e16f92a$var$preload,
    m: $3ef321f56e16f92a$var$preloadModule,
    X: $3ef321f56e16f92a$var$preinitScript,
    S: $3ef321f56e16f92a$var$preinitStyle,
    M: $3ef321f56e16f92a$var$preinitModuleScript
};
function $3ef321f56e16f92a$var$flushSyncWork() {
    var previousWasRendering = $3ef321f56e16f92a$var$previousDispatcher.f(), wasRendering = $3ef321f56e16f92a$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $3ef321f56e16f92a$var$requestFormReset(form) {
    var formInst = $3ef321f56e16f92a$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $3ef321f56e16f92a$var$requestFormReset$1(formInst) : $3ef321f56e16f92a$var$previousDispatcher.r(form);
}
var $3ef321f56e16f92a$var$globalDocument = "undefined" === typeof document ? null : document;
function $3ef321f56e16f92a$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $3ef321f56e16f92a$var$preconnectsSet.has(limitedEscapedHref) || ($3ef321f56e16f92a$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $3ef321f56e16f92a$var$setInitialProperties(href, "link", rel), $3ef321f56e16f92a$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $3ef321f56e16f92a$var$prefetchDNS(href) {
    $3ef321f56e16f92a$var$previousDispatcher.D(href);
    $3ef321f56e16f92a$var$preconnectAs("dns-prefetch", href, null);
}
function $3ef321f56e16f92a$var$preconnect(href, crossOrigin) {
    $3ef321f56e16f92a$var$previousDispatcher.C(href, crossOrigin);
    $3ef321f56e16f92a$var$preconnectAs("preconnect", href, crossOrigin);
}
function $3ef321f56e16f92a$var$preload(href, as, options) {
    $3ef321f56e16f92a$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $3ef321f56e16f92a$var$getStyleKey(href);
                break;
            case "script":
                key = $3ef321f56e16f92a$var$getScriptKey(href);
        }
        $3ef321f56e16f92a$var$preloadPropsMap.has(key) || (href = $3ef321f56e16f92a$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $3ef321f56e16f92a$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $3ef321f56e16f92a$var$setInitialProperties(as, "link", href), $3ef321f56e16f92a$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $3ef321f56e16f92a$var$preloadModule(href, options) {
    $3ef321f56e16f92a$var$previousDispatcher.m(href, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $3ef321f56e16f92a$var$getScriptKey(href);
        }
        if (!$3ef321f56e16f92a$var$preloadPropsMap.has(key) && (href = $3ef321f56e16f92a$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $3ef321f56e16f92a$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $3ef321f56e16f92a$var$setInitialProperties(as, "link", href);
            $3ef321f56e16f92a$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $3ef321f56e16f92a$var$preinitStyle(href, precedence, options) {
    $3ef321f56e16f92a$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $3ef321f56e16f92a$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $3ef321f56e16f92a$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $3ef321f56e16f92a$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $3ef321f56e16f92a$var$preloadPropsMap.get(key)) && $3ef321f56e16f92a$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $3ef321f56e16f92a$var$markNodeAsHoistable(link);
                $3ef321f56e16f92a$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $3ef321f56e16f92a$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $3ef321f56e16f92a$var$preinitScript(src, options) {
    $3ef321f56e16f92a$var$previousDispatcher.X(src, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $3ef321f56e16f92a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $3ef321f56e16f92a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(key)), resource || (src = $3ef321f56e16f92a$var$assign({
            src: src,
            async: !0
        }, options), (options = $3ef321f56e16f92a$var$preloadPropsMap.get(key)) && $3ef321f56e16f92a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $3ef321f56e16f92a$var$markNodeAsHoistable(resource), $3ef321f56e16f92a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $3ef321f56e16f92a$var$preinitModuleScript(src, options) {
    $3ef321f56e16f92a$var$previousDispatcher.M(src, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $3ef321f56e16f92a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $3ef321f56e16f92a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(key)), resource || (src = $3ef321f56e16f92a$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $3ef321f56e16f92a$var$preloadPropsMap.get(key)) && $3ef321f56e16f92a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $3ef321f56e16f92a$var$markNodeAsHoistable(resource), $3ef321f56e16f92a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $3ef321f56e16f92a$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $3ef321f56e16f92a$var$rootInstanceStackCursor.current) ? $3ef321f56e16f92a$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $3ef321f56e16f92a$var$getStyleKey(pendingProps.href), pendingProps = $3ef321f56e16f92a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $3ef321f56e16f92a$var$getStyleKey(pendingProps.href);
                var styles$242 = $3ef321f56e16f92a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $3ef321f56e16f92a$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $3ef321f56e16f92a$var$preloadPropsMap.set(type, pendingProps), styles$242 || $3ef321f56e16f92a$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $3ef321f56e16f92a$var$getScriptKey(pendingProps), pendingProps = $3ef321f56e16f92a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(444, type));
    }
}
function $3ef321f56e16f92a$var$getStyleKey(href) {
    return 'href="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $3ef321f56e16f92a$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $3ef321f56e16f92a$var$stylesheetPropsFromRawProps(rawProps) {
    return $3ef321f56e16f92a$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $3ef321f56e16f92a$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $3ef321f56e16f92a$var$setInitialProperties(key, "link", preloadProps), $3ef321f56e16f92a$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $3ef321f56e16f92a$var$getScriptKey(src) {
    return '[src="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $3ef321f56e16f92a$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $3ef321f56e16f92a$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $3ef321f56e16f92a$var$markNodeAsHoistable(instance), instance;
            var styleProps = $3ef321f56e16f92a$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $3ef321f56e16f92a$var$markNodeAsHoistable(instance);
            $3ef321f56e16f92a$var$setInitialProperties(instance, "style", styleProps);
            $3ef321f56e16f92a$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $3ef321f56e16f92a$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $3ef321f56e16f92a$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $3ef321f56e16f92a$var$stylesheetPropsFromRawProps(props);
            (styleProps = $3ef321f56e16f92a$var$preloadPropsMap.get(styleProps)) && $3ef321f56e16f92a$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $3ef321f56e16f92a$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $3ef321f56e16f92a$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $3ef321f56e16f92a$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $3ef321f56e16f92a$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $3ef321f56e16f92a$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $3ef321f56e16f92a$var$preloadPropsMap.get(instance$248)) instance = $3ef321f56e16f92a$var$assign({}, props), $3ef321f56e16f92a$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $3ef321f56e16f92a$var$markNodeAsHoistable(styleProps);
            $3ef321f56e16f92a$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $3ef321f56e16f92a$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $3ef321f56e16f92a$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $3ef321f56e16f92a$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $3ef321f56e16f92a$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $3ef321f56e16f92a$var$tagCaches = null;
function $3ef321f56e16f92a$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $3ef321f56e16f92a$var$tagCaches) {
        var cache = new Map();
        var caches = $3ef321f56e16f92a$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $3ef321f56e16f92a$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$3ef321f56e16f92a$var$internalHoistableMarker] || node[$3ef321f56e16f92a$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $3ef321f56e16f92a$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $3ef321f56e16f92a$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $3ef321f56e16f92a$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $3ef321f56e16f92a$var$suspendedState = null;
function $3ef321f56e16f92a$var$noop() {}
function $3ef321f56e16f92a$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $3ef321f56e16f92a$var$suspendedState) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(475));
    var state = $3ef321f56e16f92a$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $3ef321f56e16f92a$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $3ef321f56e16f92a$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $3ef321f56e16f92a$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $3ef321f56e16f92a$var$stylesheetPropsFromRawProps(props);
            (key = $3ef321f56e16f92a$var$preloadPropsMap.get(key)) && $3ef321f56e16f92a$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $3ef321f56e16f92a$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $3ef321f56e16f92a$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $3ef321f56e16f92a$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $3ef321f56e16f92a$var$waitForCommitToBeReady() {
    if (null === $3ef321f56e16f92a$var$suspendedState) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(475));
    var state = $3ef321f56e16f92a$var$suspendedState;
    state.stylesheets && 0 === state.count && $3ef321f56e16f92a$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $3ef321f56e16f92a$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $3ef321f56e16f92a$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $3ef321f56e16f92a$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $3ef321f56e16f92a$var$precedencesByRoot = null;
function $3ef321f56e16f92a$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $3ef321f56e16f92a$var$precedencesByRoot = new Map(), resources.forEach($3ef321f56e16f92a$var$insertStylesheetIntoRoot, state), $3ef321f56e16f92a$var$precedencesByRoot = null, $3ef321f56e16f92a$var$onUnsuspend.call(state));
}
function $3ef321f56e16f92a$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $3ef321f56e16f92a$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $3ef321f56e16f92a$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $3ef321f56e16f92a$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $3ef321f56e16f92a$var$HostTransitionContext = {
    $$typeof: $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $3ef321f56e16f92a$var$sharedNotPendingObject,
    _currentValue2: $3ef321f56e16f92a$var$sharedNotPendingObject,
    _threadCount: 0
};
function $3ef321f56e16f92a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $3ef321f56e16f92a$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3ef321f56e16f92a$var$createLaneMap(0);
    this.hiddenUpdates = $3ef321f56e16f92a$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $3ef321f56e16f92a$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $3ef321f56e16f92a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $3ef321f56e16f92a$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $3ef321f56e16f92a$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $3ef321f56e16f92a$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $3ef321f56e16f92a$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $3ef321f56e16f92a$var$emptyContextObject;
    parentComponent = $3ef321f56e16f92a$var$emptyContextObject;
    return parentComponent;
}
function $3ef321f56e16f92a$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $3ef321f56e16f92a$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $3ef321f56e16f92a$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $3ef321f56e16f92a$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(element, rootFiber, lane), $3ef321f56e16f92a$var$entangleTransitions(element, rootFiber, lane));
}
function $3ef321f56e16f92a$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $3ef321f56e16f92a$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $3ef321f56e16f92a$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $3ef321f56e16f92a$var$markRetryLaneImpl(fiber, retryLane);
}
function $3ef321f56e16f92a$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $3ef321f56e16f92a$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $3ef321f56e16f92a$var$_enabled = !0;
function $3ef321f56e16f92a$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T;
    $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
    var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    try {
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 2, $3ef321f56e16f92a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $3ef321f56e16f92a$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T;
    $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
    var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    try {
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 8, $3ef321f56e16f92a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $3ef321f56e16f92a$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($3ef321f56e16f92a$var$_enabled) {
        var blockedOn = $3ef321f56e16f92a$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $3ef321f56e16f92a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $3ef321f56e16f92a$var$return_targetInst, targetContainer), $3ef321f56e16f92a$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($3ef321f56e16f92a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($3ef321f56e16f92a$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $3ef321f56e16f92a$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $3ef321f56e16f92a$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $3ef321f56e16f92a$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $3ef321f56e16f92a$var$ensureRootIsScheduled(fiber);
                                0 === ($3ef321f56e16f92a$var$executionContext & 6) && ($3ef321f56e16f92a$var$workInProgressRootRenderTargetTime = $3ef321f56e16f92a$var$now() + 500, $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, 2), $3ef321f56e16f92a$var$flushSyncWork$1(), $3ef321f56e16f92a$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $3ef321f56e16f92a$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $3ef321f56e16f92a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $3ef321f56e16f92a$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $3ef321f56e16f92a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $3ef321f56e16f92a$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $3ef321f56e16f92a$var$getEventTarget(nativeEvent);
    return $3ef321f56e16f92a$var$findInstanceBlockingTarget(nativeEvent);
}
var $3ef321f56e16f92a$var$return_targetInst = null;
function $3ef321f56e16f92a$var$findInstanceBlockingTarget(targetNode) {
    $3ef321f56e16f92a$var$return_targetInst = null;
    targetNode = $3ef321f56e16f92a$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $3ef321f56e16f92a$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $3ef321f56e16f92a$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $3ef321f56e16f92a$var$return_targetInst = targetNode;
    return null;
}
function $3ef321f56e16f92a$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($3ef321f56e16f92a$var$getCurrentPriorityLevel()){
                case $3ef321f56e16f92a$var$ImmediatePriority:
                    return 2;
                case $3ef321f56e16f92a$var$UserBlockingPriority:
                    return 8;
                case $3ef321f56e16f92a$var$NormalPriority$1:
                case $3ef321f56e16f92a$var$LowPriority:
                    return 32;
                case $3ef321f56e16f92a$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $3ef321f56e16f92a$var$hasScheduledReplayAttempt = !1, $3ef321f56e16f92a$var$queuedFocus = null, $3ef321f56e16f92a$var$queuedDrag = null, $3ef321f56e16f92a$var$queuedMouse = null, $3ef321f56e16f92a$var$queuedPointers = new Map(), $3ef321f56e16f92a$var$queuedPointerCaptures = new Map(), $3ef321f56e16f92a$var$queuedExplicitHydrationTargets = [], $3ef321f56e16f92a$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $3ef321f56e16f92a$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $3ef321f56e16f92a$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $3ef321f56e16f92a$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $3ef321f56e16f92a$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $3ef321f56e16f92a$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3ef321f56e16f92a$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $3ef321f56e16f92a$var$getInstanceFromNode(blockedOn), null !== blockedOn && $3ef321f56e16f92a$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $3ef321f56e16f92a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $3ef321f56e16f92a$var$queuedFocus = $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $3ef321f56e16f92a$var$queuedDrag = $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $3ef321f56e16f92a$var$queuedMouse = $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $3ef321f56e16f92a$var$queuedPointers.set(pointerId, $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $3ef321f56e16f92a$var$queuedPointerCaptures.set(pointerId, $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $3ef321f56e16f92a$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $3ef321f56e16f92a$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $3ef321f56e16f92a$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $3ef321f56e16f92a$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $3ef321f56e16f92a$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $3ef321f56e16f92a$var$requestUpdateLane(), root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $3ef321f56e16f92a$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $3ef321f56e16f92a$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $3ef321f56e16f92a$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $3ef321f56e16f92a$var$currentReplayingEvent = null;
        } else return targetContainers = $3ef321f56e16f92a$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $3ef321f56e16f92a$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $3ef321f56e16f92a$var$replayUnblockedEvents() {
    $3ef321f56e16f92a$var$hasScheduledReplayAttempt = !1;
    null !== $3ef321f56e16f92a$var$queuedFocus && $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent($3ef321f56e16f92a$var$queuedFocus) && ($3ef321f56e16f92a$var$queuedFocus = null);
    null !== $3ef321f56e16f92a$var$queuedDrag && $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent($3ef321f56e16f92a$var$queuedDrag) && ($3ef321f56e16f92a$var$queuedDrag = null);
    null !== $3ef321f56e16f92a$var$queuedMouse && $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent($3ef321f56e16f92a$var$queuedMouse) && ($3ef321f56e16f92a$var$queuedMouse = null);
    $3ef321f56e16f92a$var$queuedPointers.forEach($3ef321f56e16f92a$var$attemptReplayContinuousQueuedEventInMap);
    $3ef321f56e16f92a$var$queuedPointerCaptures.forEach($3ef321f56e16f92a$var$attemptReplayContinuousQueuedEventInMap);
}
function $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $3ef321f56e16f92a$var$hasScheduledReplayAttempt || ($3ef321f56e16f92a$var$hasScheduledReplayAttempt = !0, $1c3ne.unstable_scheduleCallback($1c3ne.unstable_NormalPriority, $3ef321f56e16f92a$var$replayUnblockedEvents)));
}
var $3ef321f56e16f92a$var$lastScheduledReplayQueue = null;
function $3ef321f56e16f92a$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $3ef321f56e16f92a$var$lastScheduledReplayQueue !== formReplayingQueue && ($3ef321f56e16f92a$var$lastScheduledReplayQueue = formReplayingQueue, $1c3ne.unstable_scheduleCallback($1c3ne.unstable_NormalPriority, function() {
        $3ef321f56e16f92a$var$lastScheduledReplayQueue === formReplayingQueue && ($3ef321f56e16f92a$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $3ef321f56e16f92a$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $3ef321f56e16f92a$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $3ef321f56e16f92a$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $3ef321f56e16f92a$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $3ef321f56e16f92a$var$queuedFocus && $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked($3ef321f56e16f92a$var$queuedFocus, unblocked);
    null !== $3ef321f56e16f92a$var$queuedDrag && $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked($3ef321f56e16f92a$var$queuedDrag, unblocked);
    null !== $3ef321f56e16f92a$var$queuedMouse && $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked($3ef321f56e16f92a$var$queuedMouse, unblocked);
    $3ef321f56e16f92a$var$queuedPointers.forEach(unblock);
    $3ef321f56e16f92a$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $3ef321f56e16f92a$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.length && (i = $3ef321f56e16f92a$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$3ef321f56e16f92a$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$3ef321f56e16f92a$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $3ef321f56e16f92a$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$3ef321f56e16f92a$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $3ef321f56e16f92a$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $3ef321f56e16f92a$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $3ef321f56e16f92a$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$3ef321f56e16f92a$var$ReactDOMHydrationRoot.prototype.render = $3ef321f56e16f92a$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(409));
    var current = root.current, lane = $3ef321f56e16f92a$var$requestUpdateLane();
    $3ef321f56e16f92a$var$updateContainerImpl(current, lane, children, root, null, null);
};
$3ef321f56e16f92a$var$ReactDOMHydrationRoot.prototype.unmount = $3ef321f56e16f92a$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $3ef321f56e16f92a$var$flushPassiveEffects();
        $3ef321f56e16f92a$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $3ef321f56e16f92a$var$flushSyncWork$1();
        container[$3ef321f56e16f92a$var$internalContainerInstanceKey] = null;
    }
};
function $3ef321f56e16f92a$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$3ef321f56e16f92a$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $3ef321f56e16f92a$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $3ef321f56e16f92a$var$queuedExplicitHydrationTargets[i].priority; i++);
        $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $3ef321f56e16f92a$var$attemptExplicitHydrationTarget(target);
    }
};
var $3ef321f56e16f92a$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $4Iuzv.version;
if ("19.0.0" !== $3ef321f56e16f92a$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(527, $3ef321f56e16f92a$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$3ef321f56e16f92a$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $3ef321f56e16f92a$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $3ef321f56e16f92a$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $3ef321f56e16f92a$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $3ef321f56e16f92a$var$ReactSharedInternals,
    findFiberByHostInstance: $3ef321f56e16f92a$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3ef321f56e16f92a$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3ef321f56e16f92a$var$hook$jscomp$inline_2166.isDisabled && $3ef321f56e16f92a$var$hook$jscomp$inline_2166.supportsFiber) try {
        $3ef321f56e16f92a$var$rendererID = $3ef321f56e16f92a$var$hook$jscomp$inline_2166.inject($3ef321f56e16f92a$var$internals$jscomp$inline_2165), $3ef321f56e16f92a$var$injectedHook = $3ef321f56e16f92a$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$3ef321f56e16f92a$export$882461b6382ed46c = function(container, options) {
    if (!$3ef321f56e16f92a$var$isValidContainer(container)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $3ef321f56e16f92a$var$defaultOnUncaughtError, onCaughtError = $3ef321f56e16f92a$var$defaultOnCaughtError, onRecoverableError = $3ef321f56e16f92a$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $3ef321f56e16f92a$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$3ef321f56e16f92a$var$internalContainerInstanceKey] = options.current;
    $3ef321f56e16f92a$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $3ef321f56e16f92a$var$ReactDOMRoot(options);
};
$3ef321f56e16f92a$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$3ef321f56e16f92a$var$isValidContainer(container)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $3ef321f56e16f92a$var$defaultOnUncaughtError, onCaughtError = $3ef321f56e16f92a$var$defaultOnCaughtError, onRecoverableError = $3ef321f56e16f92a$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $3ef321f56e16f92a$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $3ef321f56e16f92a$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $3ef321f56e16f92a$var$requestUpdateLane();
    identifierPrefix = $3ef321f56e16f92a$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $3ef321f56e16f92a$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $3ef321f56e16f92a$var$markRootUpdated$1(initialChildren, isStrictMode);
    $3ef321f56e16f92a$var$ensureRootIsScheduled(initialChildren);
    container[$3ef321f56e16f92a$var$internalContainerInstanceKey] = initialChildren.current;
    $3ef321f56e16f92a$var$listenToAllSupportedEvents(container);
    return new $3ef321f56e16f92a$var$ReactDOMHydrationRoot(initialChildren);
};
$3ef321f56e16f92a$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("1c3ne", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fHP5D"));

});
parcelRegister("fHP5D", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b6f28089b6d6561b$export$c4744153514ff05d; }, function (v) { return $b6f28089b6d6561b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b6f28089b6d6561b$export$3e506c1ccc9cc1a7; }, function (v) { return $b6f28089b6d6561b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b6f28089b6d6561b$export$e26fe2ed2fa76875; }, function (v) { return $b6f28089b6d6561b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b6f28089b6d6561b$export$502329bbf4b505b1; }, function (v) { return $b6f28089b6d6561b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b6f28089b6d6561b$export$6e3807111c4874c4; }, function (v) { return $b6f28089b6d6561b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b6f28089b6d6561b$export$c27134553091fb3a; }, function (v) { return $b6f28089b6d6561b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b6f28089b6d6561b$export$33ee1acdc04fd2a2; }, function (v) { return $b6f28089b6d6561b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b6f28089b6d6561b$export$b00a404bbd5edef2; }, function (v) { return $b6f28089b6d6561b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $b6f28089b6d6561b$export$8352ce38b91d0c62; }, function (v) { return $b6f28089b6d6561b$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b6f28089b6d6561b$export$d66a1c1c77bd778b; }, function (v) { return $b6f28089b6d6561b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b6f28089b6d6561b$export$d3dfb8e4810cb555; }, function (v) { return $b6f28089b6d6561b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $b6f28089b6d6561b$export$839f9183b0465a69; }, function (v) { return $b6f28089b6d6561b$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b6f28089b6d6561b$export$72fdf0e06517287b; }, function (v) { return $b6f28089b6d6561b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $b6f28089b6d6561b$export$4b844e58a3e414b4; }, function (v) { return $b6f28089b6d6561b$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b6f28089b6d6561b$export$816d2913ae6b83b1; }, function (v) { return $b6f28089b6d6561b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b6f28089b6d6561b$export$61bcfe829111a1d0; }, function (v) { return $b6f28089b6d6561b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b6f28089b6d6561b$export$7ee8c9beb337bc3f; }, function (v) { return $b6f28089b6d6561b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b6f28089b6d6561b$export$b5836b71941fa3ed; }, function (v) { return $b6f28089b6d6561b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b6f28089b6d6561b$export$cf845f2c119da08a; }, function (v) { return $b6f28089b6d6561b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b6f28089b6d6561b$export$c4744153514ff05d;
var $b6f28089b6d6561b$export$3e506c1ccc9cc1a7;
var $b6f28089b6d6561b$export$e26fe2ed2fa76875;
var $b6f28089b6d6561b$export$502329bbf4b505b1;
var $b6f28089b6d6561b$export$6e3807111c4874c4;
var $b6f28089b6d6561b$export$c27134553091fb3a;
var $b6f28089b6d6561b$export$33ee1acdc04fd2a2;
var $b6f28089b6d6561b$export$b00a404bbd5edef2;
var $b6f28089b6d6561b$export$8352ce38b91d0c62;
var $b6f28089b6d6561b$export$d66a1c1c77bd778b;
var $b6f28089b6d6561b$export$d3dfb8e4810cb555;
var $b6f28089b6d6561b$export$839f9183b0465a69;
var $b6f28089b6d6561b$export$72fdf0e06517287b;
var $b6f28089b6d6561b$export$4b844e58a3e414b4;
var $b6f28089b6d6561b$export$816d2913ae6b83b1;
var $b6f28089b6d6561b$export$61bcfe829111a1d0;
var $b6f28089b6d6561b$export$7ee8c9beb337bc3f;
var $b6f28089b6d6561b$export$b5836b71941fa3ed;
var $b6f28089b6d6561b$export$cf845f2c119da08a;
"use strict";
function $b6f28089b6d6561b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $b6f28089b6d6561b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $b6f28089b6d6561b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $b6f28089b6d6561b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $b6f28089b6d6561b$var$compare(left, last)) rightIndex < length && 0 > $b6f28089b6d6561b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $b6f28089b6d6561b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $b6f28089b6d6561b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$b6f28089b6d6561b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b6f28089b6d6561b$var$localPerformance = performance;
    $b6f28089b6d6561b$export$c4744153514ff05d = function() {
        return $b6f28089b6d6561b$var$localPerformance.now();
    };
} else {
    var $b6f28089b6d6561b$var$localDate = Date, $b6f28089b6d6561b$var$initialTime = $b6f28089b6d6561b$var$localDate.now();
    $b6f28089b6d6561b$export$c4744153514ff05d = function() {
        return $b6f28089b6d6561b$var$localDate.now() - $b6f28089b6d6561b$var$initialTime;
    };
}
var $b6f28089b6d6561b$var$taskQueue = [], $b6f28089b6d6561b$var$timerQueue = [], $b6f28089b6d6561b$var$taskIdCounter = 1, $b6f28089b6d6561b$var$currentTask = null, $b6f28089b6d6561b$var$currentPriorityLevel = 3, $b6f28089b6d6561b$var$isPerformingWork = !1, $b6f28089b6d6561b$var$isHostCallbackScheduled = !1, $b6f28089b6d6561b$var$isHostTimeoutScheduled = !1, $b6f28089b6d6561b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $b6f28089b6d6561b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $b6f28089b6d6561b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $b6f28089b6d6561b$var$advanceTimers(currentTime) {
    for(var timer = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $b6f28089b6d6561b$var$pop($b6f28089b6d6561b$var$timerQueue);
        else if (timer.startTime <= currentTime) $b6f28089b6d6561b$var$pop($b6f28089b6d6561b$var$timerQueue), timer.sortIndex = timer.expirationTime, $b6f28089b6d6561b$var$push($b6f28089b6d6561b$var$taskQueue, timer);
        else break;
        timer = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue);
    }
}
function $b6f28089b6d6561b$var$handleTimeout(currentTime) {
    $b6f28089b6d6561b$var$isHostTimeoutScheduled = !1;
    $b6f28089b6d6561b$var$advanceTimers(currentTime);
    if (!$b6f28089b6d6561b$var$isHostCallbackScheduled) {
        if (null !== $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue)) $b6f28089b6d6561b$var$isHostCallbackScheduled = !0, $b6f28089b6d6561b$var$requestHostCallback();
        else {
            var firstTimer = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue);
            null !== firstTimer && $b6f28089b6d6561b$var$requestHostTimeout($b6f28089b6d6561b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $b6f28089b6d6561b$var$isMessageLoopRunning = !1, $b6f28089b6d6561b$var$taskTimeoutID = -1, $b6f28089b6d6561b$var$frameInterval = 5, $b6f28089b6d6561b$var$startTime = -1;
function $b6f28089b6d6561b$var$shouldYieldToHost() {
    return $b6f28089b6d6561b$export$c4744153514ff05d() - $b6f28089b6d6561b$var$startTime < $b6f28089b6d6561b$var$frameInterval ? !1 : !0;
}
function $b6f28089b6d6561b$var$performWorkUntilDeadline() {
    if ($b6f28089b6d6561b$var$isMessageLoopRunning) {
        var currentTime = $b6f28089b6d6561b$export$c4744153514ff05d();
        $b6f28089b6d6561b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $b6f28089b6d6561b$var$isHostCallbackScheduled = !1;
                $b6f28089b6d6561b$var$isHostTimeoutScheduled && ($b6f28089b6d6561b$var$isHostTimeoutScheduled = !1, $b6f28089b6d6561b$var$localClearTimeout($b6f28089b6d6561b$var$taskTimeoutID), $b6f28089b6d6561b$var$taskTimeoutID = -1);
                $b6f28089b6d6561b$var$isPerformingWork = !0;
                var previousPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
                try {
                    b: {
                        $b6f28089b6d6561b$var$advanceTimers(currentTime);
                        for($b6f28089b6d6561b$var$currentTask = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue); null !== $b6f28089b6d6561b$var$currentTask && !($b6f28089b6d6561b$var$currentTask.expirationTime > currentTime && $b6f28089b6d6561b$var$shouldYieldToHost());){
                            var callback = $b6f28089b6d6561b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $b6f28089b6d6561b$var$currentTask.callback = null;
                                $b6f28089b6d6561b$var$currentPriorityLevel = $b6f28089b6d6561b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($b6f28089b6d6561b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $b6f28089b6d6561b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $b6f28089b6d6561b$var$currentTask.callback = continuationCallback;
                                    $b6f28089b6d6561b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $b6f28089b6d6561b$var$currentTask === $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue) && $b6f28089b6d6561b$var$pop($b6f28089b6d6561b$var$taskQueue);
                                $b6f28089b6d6561b$var$advanceTimers(currentTime);
                            } else $b6f28089b6d6561b$var$pop($b6f28089b6d6561b$var$taskQueue);
                            $b6f28089b6d6561b$var$currentTask = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue);
                        }
                        if (null !== $b6f28089b6d6561b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue);
                            null !== firstTimer && $b6f28089b6d6561b$var$requestHostTimeout($b6f28089b6d6561b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $b6f28089b6d6561b$var$currentTask = null, $b6f28089b6d6561b$var$currentPriorityLevel = previousPriorityLevel, $b6f28089b6d6561b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline() : $b6f28089b6d6561b$var$isMessageLoopRunning = !1;
        }
    }
}
var $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $b6f28089b6d6561b$var$localSetImmediate) $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline = function() {
    $b6f28089b6d6561b$var$localSetImmediate($b6f28089b6d6561b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b6f28089b6d6561b$var$channel = new MessageChannel(), $b6f28089b6d6561b$var$port = $b6f28089b6d6561b$var$channel.port2;
    $b6f28089b6d6561b$var$channel.port1.onmessage = $b6f28089b6d6561b$var$performWorkUntilDeadline;
    $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline = function() {
        $b6f28089b6d6561b$var$port.postMessage(null);
    };
} else $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline = function() {
    $b6f28089b6d6561b$var$localSetTimeout($b6f28089b6d6561b$var$performWorkUntilDeadline, 0);
};
function $b6f28089b6d6561b$var$requestHostCallback() {
    $b6f28089b6d6561b$var$isMessageLoopRunning || ($b6f28089b6d6561b$var$isMessageLoopRunning = !0, $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline());
}
function $b6f28089b6d6561b$var$requestHostTimeout(callback, ms) {
    $b6f28089b6d6561b$var$taskTimeoutID = $b6f28089b6d6561b$var$localSetTimeout(function() {
        callback($b6f28089b6d6561b$export$c4744153514ff05d());
    }, ms);
}
$b6f28089b6d6561b$export$3e506c1ccc9cc1a7 = 5;
$b6f28089b6d6561b$export$e26fe2ed2fa76875 = 1;
$b6f28089b6d6561b$export$502329bbf4b505b1 = 4;
$b6f28089b6d6561b$export$6e3807111c4874c4 = 3;
$b6f28089b6d6561b$export$c27134553091fb3a = null;
$b6f28089b6d6561b$export$33ee1acdc04fd2a2 = 2;
$b6f28089b6d6561b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$b6f28089b6d6561b$export$8352ce38b91d0c62 = function() {
    $b6f28089b6d6561b$var$isHostCallbackScheduled || $b6f28089b6d6561b$var$isPerformingWork || ($b6f28089b6d6561b$var$isHostCallbackScheduled = !0, $b6f28089b6d6561b$var$requestHostCallback());
};
$b6f28089b6d6561b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b6f28089b6d6561b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$b6f28089b6d6561b$export$d3dfb8e4810cb555 = function() {
    return $b6f28089b6d6561b$var$currentPriorityLevel;
};
$b6f28089b6d6561b$export$839f9183b0465a69 = function() {
    return $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue);
};
$b6f28089b6d6561b$export$72fdf0e06517287b = function(eventHandler) {
    switch($b6f28089b6d6561b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
    $b6f28089b6d6561b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $b6f28089b6d6561b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$b6f28089b6d6561b$export$4b844e58a3e414b4 = function() {};
$b6f28089b6d6561b$export$816d2913ae6b83b1 = function() {};
$b6f28089b6d6561b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
    $b6f28089b6d6561b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $b6f28089b6d6561b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$b6f28089b6d6561b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $b6f28089b6d6561b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $b6f28089b6d6561b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $b6f28089b6d6561b$var$push($b6f28089b6d6561b$var$timerQueue, priorityLevel), null === $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue) && priorityLevel === $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue) && ($b6f28089b6d6561b$var$isHostTimeoutScheduled ? ($b6f28089b6d6561b$var$localClearTimeout($b6f28089b6d6561b$var$taskTimeoutID), $b6f28089b6d6561b$var$taskTimeoutID = -1) : $b6f28089b6d6561b$var$isHostTimeoutScheduled = !0, $b6f28089b6d6561b$var$requestHostTimeout($b6f28089b6d6561b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $b6f28089b6d6561b$var$push($b6f28089b6d6561b$var$taskQueue, priorityLevel), $b6f28089b6d6561b$var$isHostCallbackScheduled || $b6f28089b6d6561b$var$isPerformingWork || ($b6f28089b6d6561b$var$isHostCallbackScheduled = !0, $b6f28089b6d6561b$var$requestHostCallback()));
    return priorityLevel;
};
$b6f28089b6d6561b$export$b5836b71941fa3ed = $b6f28089b6d6561b$var$shouldYieldToHost;
$b6f28089b6d6561b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
        $b6f28089b6d6561b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $b6f28089b6d6561b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("4Iuzv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("GDJFN"));

});

parcelRegister("hSThT", function(module, exports) {
'use strict';
function $d0525dc7624af49b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d0525dc7624af49b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d0525dc7624af49b$var$checkDCE();

module.exports = (parcelRequire("1ZiSy"));

});
parcelRegister("1ZiSy", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $172a21ee876390cc$export$69ce8ef3fe5cead0; }, function (v) { return $172a21ee876390cc$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $172a21ee876390cc$export$d39a5bbd09211389; }, function (v) { return $172a21ee876390cc$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $172a21ee876390cc$export$cd75ccfd720a3cd4; }, function (v) { return $172a21ee876390cc$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $172a21ee876390cc$export$a0816fa17a9e79be; }, function (v) { return $172a21ee876390cc$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $172a21ee876390cc$export$7292efcadded39f3; }, function (v) { return $172a21ee876390cc$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $172a21ee876390cc$export$da407abadb9b8f86; }, function (v) { return $172a21ee876390cc$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $172a21ee876390cc$export$314cfea32580671c; }, function (v) { return $172a21ee876390cc$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $172a21ee876390cc$export$513ccb98c53b8039; }, function (v) { return $172a21ee876390cc$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $172a21ee876390cc$export$dbca993bc2d264a; }, function (v) { return $172a21ee876390cc$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $172a21ee876390cc$export$4797a8006f0655d0; }, function (v) { return $172a21ee876390cc$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $172a21ee876390cc$export$c78a37762a8d58e1; }, function (v) { return $172a21ee876390cc$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $172a21ee876390cc$export$606f11b2eb45ecc6; }, function (v) { return $172a21ee876390cc$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $172a21ee876390cc$export$f7e8a0bf92324b1e; }, function (v) { return $172a21ee876390cc$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $172a21ee876390cc$export$83d89fbfd8236492; }, function (v) { return $172a21ee876390cc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $172a21ee876390cc$export$69ce8ef3fe5cead0;
var $172a21ee876390cc$export$d39a5bbd09211389;
var $172a21ee876390cc$export$cd75ccfd720a3cd4;
var $172a21ee876390cc$export$a0816fa17a9e79be;
var $172a21ee876390cc$export$7292efcadded39f3;
var $172a21ee876390cc$export$da407abadb9b8f86;
var $172a21ee876390cc$export$314cfea32580671c;
var $172a21ee876390cc$export$513ccb98c53b8039;
var $172a21ee876390cc$export$dbca993bc2d264a;
var $172a21ee876390cc$export$4797a8006f0655d0;
var $172a21ee876390cc$export$c78a37762a8d58e1;
var $172a21ee876390cc$export$606f11b2eb45ecc6;
var $172a21ee876390cc$export$f7e8a0bf92324b1e;
var $172a21ee876390cc$export$83d89fbfd8236492;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
function $172a21ee876390cc$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $172a21ee876390cc$var$noop() {}
var $172a21ee876390cc$var$Internals = {
    d: {
        f: $172a21ee876390cc$var$noop,
        r: function() {
            throw Error($172a21ee876390cc$var$formatProdErrorMessage(522));
        },
        D: $172a21ee876390cc$var$noop,
        C: $172a21ee876390cc$var$noop,
        L: $172a21ee876390cc$var$noop,
        m: $172a21ee876390cc$var$noop,
        X: $172a21ee876390cc$var$noop,
        S: $172a21ee876390cc$var$noop,
        M: $172a21ee876390cc$var$noop
    },
    p: 0,
    findDOMNode: null
}, $172a21ee876390cc$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $172a21ee876390cc$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $172a21ee876390cc$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $172a21ee876390cc$var$ReactSharedInternals = $4Iuzv.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $172a21ee876390cc$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$172a21ee876390cc$export$69ce8ef3fe5cead0 = $172a21ee876390cc$var$Internals;
$172a21ee876390cc$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($172a21ee876390cc$var$formatProdErrorMessage(299));
    return $172a21ee876390cc$var$createPortal$1(children, container, null, key);
};
$172a21ee876390cc$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $172a21ee876390cc$var$ReactSharedInternals.T, previousUpdatePriority = $172a21ee876390cc$var$Internals.p;
    try {
        if ($172a21ee876390cc$var$ReactSharedInternals.T = null, $172a21ee876390cc$var$Internals.p = 2, fn) return fn();
    } finally{
        $172a21ee876390cc$var$ReactSharedInternals.T = previousTransition, $172a21ee876390cc$var$Internals.p = previousUpdatePriority, $172a21ee876390cc$var$Internals.d.f();
    }
};
$172a21ee876390cc$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $172a21ee876390cc$var$Internals.d.C(href, options));
};
$172a21ee876390cc$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $172a21ee876390cc$var$Internals.d.D(href);
};
$172a21ee876390cc$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $172a21ee876390cc$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $172a21ee876390cc$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $172a21ee876390cc$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$172a21ee876390cc$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $172a21ee876390cc$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $172a21ee876390cc$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $172a21ee876390cc$var$Internals.d.M(href);
    }
};
$172a21ee876390cc$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $172a21ee876390cc$var$getCrossOriginStringAs(as, options.crossOrigin);
        $172a21ee876390cc$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$172a21ee876390cc$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $172a21ee876390cc$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $172a21ee876390cc$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $172a21ee876390cc$var$Internals.d.m(href);
    }
};
$172a21ee876390cc$export$4797a8006f0655d0 = function(form) {
    $172a21ee876390cc$var$Internals.d.r(form);
};
$172a21ee876390cc$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$172a21ee876390cc$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $172a21ee876390cc$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$172a21ee876390cc$export$f7e8a0bf92324b1e = function() {
    return $172a21ee876390cc$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$172a21ee876390cc$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("9PTeM", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $7293b97ba907cc16$export$bf730a2d8bf68b42; }, function (v) { return $7293b97ba907cc16$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7293b97ba907cc16$export$bf730a2d8bf68b42;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
function $7293b97ba907cc16$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $7293b97ba907cc16$var$objectIs = "function" === typeof Object.is ? Object.is : $7293b97ba907cc16$var$is, $7293b97ba907cc16$var$useSyncExternalStore = $4Iuzv.useSyncExternalStore, $7293b97ba907cc16$var$useRef = $4Iuzv.useRef, $7293b97ba907cc16$var$useEffect = $4Iuzv.useEffect, $7293b97ba907cc16$var$useMemo = $4Iuzv.useMemo, $7293b97ba907cc16$var$useDebugValue = $4Iuzv.useDebugValue;
$7293b97ba907cc16$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $7293b97ba907cc16$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $7293b97ba907cc16$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($7293b97ba907cc16$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $7293b97ba907cc16$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $7293b97ba907cc16$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $7293b97ba907cc16$var$useDebugValue(value);
    return value;
};

});

parcelRegister("cnbGx", function(module, exports) {

var $dIRJU = parcelRequire("dIRJU");
module.exports = $dIRJU("eaaPg").then(()=>parcelRequire('7kZKn'));

});
parcelRegister("dIRJU", function(module, exports) {
"use strict";

function $9fd911f5bde9abf3$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("giU2u")).resolve(id));
}
module.exports = $9fd911f5bde9abf3$var$load;

});


var $2d44fd9acaacd39d$exports = {};

(parcelRequire("giU2u")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"a5vLB\",\"index.9755d54e.js\",\"8gMF1\",\"logo.0dc3ac12.svg\",\"eaaPg\",\"Grocery.c3a682df.js\"]"));


var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");
var $21fa618cfc67d6ae$exports = {};
'use strict';
function $21fa618cfc67d6ae$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($21fa618cfc67d6ae$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$21fa618cfc67d6ae$var$checkDCE();

$21fa618cfc67d6ae$exports = (parcelRequire("5p4Xp"));



var $5aRSq = parcelRequire("5aRSq");
var $b9478d29dd81d128$exports = {};
$b9478d29dd81d128$exports = new URL("logo.0dc3ac12.svg", import.meta.url).toString();


const $1449da937569f1f7$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $1449da937569f1f7$export$8878ead86ed0da0b = (0, (/*@__PURE__*/$parcel$interopDefault($b9478d29dd81d128$exports)));
const $1449da937569f1f7$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.99740&lng=79.00110&restaurantId=";



var $4Iuzv = parcelRequire("4Iuzv");
/**
 * react-router v7.1.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts

var $4Iuzv = parcelRequire("4Iuzv");
var $42195ed59b233082$exports = {};
"use strict";
Object.defineProperty($42195ed59b233082$exports, "__esModule", {
    value: true
});
$42195ed59b233082$exports.encode = $42195ed59b233082$exports.decode = void 0;
var $fd6023700ae04164$exports = {};
"use strict";
Object.defineProperty($fd6023700ae04164$exports, "__esModule", {
    value: true
});
$fd6023700ae04164$exports.flatten = void 0;
var $64e771ce88c8987b$exports = {};
"use strict";
Object.defineProperty($64e771ce88c8987b$exports, "__esModule", {
    value: true
});
$64e771ce88c8987b$exports.createLineSplittingTransform = $64e771ce88c8987b$exports.Deferred = $64e771ce88c8987b$exports.TYPE_PREVIOUS_RESOLVED = $64e771ce88c8987b$exports.TYPE_URL = $64e771ce88c8987b$exports.TYPE_SYMBOL = $64e771ce88c8987b$exports.TYPE_SET = $64e771ce88c8987b$exports.TYPE_REGEXP = $64e771ce88c8987b$exports.TYPE_PROMISE = $64e771ce88c8987b$exports.TYPE_NULL_OBJECT = $64e771ce88c8987b$exports.TYPE_MAP = $64e771ce88c8987b$exports.TYPE_ERROR = $64e771ce88c8987b$exports.TYPE_DATE = $64e771ce88c8987b$exports.TYPE_BIGINT = $64e771ce88c8987b$exports.UNDEFINED = $64e771ce88c8987b$exports.POSITIVE_INFINITY = $64e771ce88c8987b$exports.NULL = $64e771ce88c8987b$exports.NEGATIVE_ZERO = $64e771ce88c8987b$exports.NEGATIVE_INFINITY = $64e771ce88c8987b$exports.NAN = $64e771ce88c8987b$exports.HOLE = void 0;
$64e771ce88c8987b$exports.HOLE = -1;
$64e771ce88c8987b$exports.NAN = -2;
$64e771ce88c8987b$exports.NEGATIVE_INFINITY = -3;
$64e771ce88c8987b$exports.NEGATIVE_ZERO = -4;
$64e771ce88c8987b$exports.NULL = -5;
$64e771ce88c8987b$exports.POSITIVE_INFINITY = -6;
$64e771ce88c8987b$exports.UNDEFINED = -7;
$64e771ce88c8987b$exports.TYPE_BIGINT = "B";
$64e771ce88c8987b$exports.TYPE_DATE = "D";
$64e771ce88c8987b$exports.TYPE_ERROR = "E";
$64e771ce88c8987b$exports.TYPE_MAP = "M";
$64e771ce88c8987b$exports.TYPE_NULL_OBJECT = "N";
$64e771ce88c8987b$exports.TYPE_PROMISE = "P";
$64e771ce88c8987b$exports.TYPE_REGEXP = "R";
$64e771ce88c8987b$exports.TYPE_SET = "S";
$64e771ce88c8987b$exports.TYPE_SYMBOL = "Y";
$64e771ce88c8987b$exports.TYPE_URL = "U";
$64e771ce88c8987b$exports.TYPE_PREVIOUS_RESOLVED = "Z";
class $64e771ce88c8987b$var$Deferred {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
$64e771ce88c8987b$exports.Deferred = $64e771ce88c8987b$var$Deferred;
function $64e771ce88c8987b$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            // The last part might be a partial line, so keep it for the next chunk.
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            // If there's any leftover data, enqueue it before closing.
            if (leftover) controller.enqueue(leftover);
        }
    });
}
$64e771ce88c8987b$exports.createLineSplittingTransform = $64e771ce88c8987b$var$createLineSplittingTransform;


function $fd6023700ae04164$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === undefined) return $64e771ce88c8987b$exports.UNDEFINED;
    if (input === null) return $64e771ce88c8987b$exports.NULL;
    if (Number.isNaN(input)) return $64e771ce88c8987b$exports.NAN;
    if (input === Number.POSITIVE_INFINITY) return $64e771ce88c8987b$exports.POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $64e771ce88c8987b$exports.NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $64e771ce88c8987b$exports.NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $fd6023700ae04164$var$stringify.call(this, input, index);
    return index;
}
$fd6023700ae04164$exports.flatten = $fd6023700ae04164$var$flatten;
function $fd6023700ae04164$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$fd6023700ae04164$var$flatten.call(this, k)}":${$fd6023700ae04164$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$64e771ce88c8987b$exports.TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$64e771ce88c8987b$exports.TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$64e771ce88c8987b$exports.NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$fd6023700ae04164$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? $fd6023700ae04164$var$flatten.call(this, input[i]) : $64e771ce88c8987b$exports.HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) str[index] = `["${$64e771ce88c8987b$exports.TYPE_DATE}",${input.getTime()}]`;
                        else if (input instanceof URL) str[index] = `["${$64e771ce88c8987b$exports.TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$64e771ce88c8987b$exports.TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$64e771ce88c8987b$exports.TYPE_SET}",${[
                                ...input
                            ].map((val)=>$fd6023700ae04164$var$flatten.call(this, val)).join(",")}]`;
                            else str[index] = `["${$64e771ce88c8987b$exports.TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$64e771ce88c8987b$exports.TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    $fd6023700ae04164$var$flatten.call(this, k),
                                    $fd6023700ae04164$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index] = `["${$64e771ce88c8987b$exports.TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$64e771ce88c8987b$exports.TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$64e771ce88c8987b$exports.TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$64e771ce88c8987b$exports.TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($fd6023700ae04164$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$fd6023700ae04164$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>$fd6023700ae04164$var$flatten.call(this, v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $fd6023700ae04164$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $fd6023700ae04164$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $fd6023700ae04164$var$objectProtoNames;
}


var $cb239a4333df7021$exports = {};
"use strict";
Object.defineProperty($cb239a4333df7021$exports, "__esModule", {
    value: true
});
$cb239a4333df7021$exports.unflatten = void 0;

const $cb239a4333df7021$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : undefined;
function $cb239a4333df7021$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $cb239a4333df7021$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $cb239a4333df7021$var$hydrate.call(this, startIndex);
}
$cb239a4333df7021$exports.unflatten = $cb239a4333df7021$var$unflatten;
function $cb239a4333df7021$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case $64e771ce88c8987b$exports.UNDEFINED:
                set(undefined);
                continue;
            case $64e771ce88c8987b$exports.NULL:
                set(null);
                continue;
            case $64e771ce88c8987b$exports.NAN:
                set(NaN);
                continue;
            case $64e771ce88c8987b$exports.POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $64e771ce88c8987b$exports.NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $64e771ce88c8987b$exports.NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $64e771ce88c8987b$exports.TYPE_DATE:
                        set(hydrated[index] = new Date(b));
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_URL:
                        set(hydrated[index] = new URL(b));
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_BIGINT:
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_REGEXP:
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_SYMBOL:
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_SET:
                        const newSet = new Set();
                        hydrated[index] = newSet;
                        for(let i = 1; i < value.length; i++)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_MAP:
                        const map = new Map();
                        hydrated[index] = map;
                        for(let i = 1; i < value.length; i += 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_NULL_OBJECT:
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new $64e771ce88c8987b$exports.Deferred();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $cb239a4333df7021$var$globalObj && $cb239a4333df7021$var$globalObj[errorType] ? new $cb239a4333df7021$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case $64e771ce88c8987b$exports.TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        // Run plugins at the end so we have a chance to resolve primitives
                        // without running into a loop
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $64e771ce88c8987b$exports.HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}



async function $42195ed59b233082$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $64e771ce88c8987b$exports.Deferred();
    const reader = readable.pipeThrough((0, $64e771ce88c8987b$exports.createLineSplittingTransform)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $42195ed59b233082$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $42195ed59b233082$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
$42195ed59b233082$exports.decode = $42195ed59b233082$var$decode;
async function $42195ed59b233082$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $cb239a4333df7021$exports.unflatten.call(this, line)
    };
}
async function $42195ed59b233082$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $64e771ce88c8987b$exports.TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $cb239a4333df7021$exports.unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $64e771ce88c8987b$exports.TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $cb239a4333df7021$exports.unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $42195ed59b233082$var$encode(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $fd6023700ae04164$exports.flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = new WeakSet();
            while(Object.keys(encoder.deferred).length > 0){
                for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                    if (seenPromises.has(deferred)) continue;
                    seenPromises.add(encoder.deferred[Number(deferredId)] = $42195ed59b233082$var$raceSignal(deferred, encoder.signal).then((resolved)=>{
                        const id = $fd6023700ae04164$exports.flatten.call(encoder, resolved);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$64e771ce88c8987b$exports.TYPE_PROMISE}${deferredId}:[["${$64e771ce88c8987b$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$64e771ce88c8987b$exports.TYPE_PROMISE}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$64e771ce88c8987b$exports.TYPE_PROMISE}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }, (reason)=>{
                        if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                        const id = $fd6023700ae04164$exports.flatten.call(encoder, reason);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$64e771ce88c8987b$exports.TYPE_ERROR}${deferredId}:[["${$64e771ce88c8987b$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$64e771ce88c8987b$exports.TYPE_ERROR}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$64e771ce88c8987b$exports.TYPE_ERROR}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }).finally(()=>{
                        delete encoder.deferred[Number(deferredId)];
                    }));
                }
                await Promise.race(Object.values(encoder.deferred));
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
$42195ed59b233082$exports.encode = $42195ed59b233082$var$encode;
function $42195ed59b233082$var$raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    const abort = new Promise((resolve, reject)=>{
        signal.addEventListener("abort", (event)=>{
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(()=>{});
    return Promise.race([
        abort,
        promise
    ]);
}


var $37fe02520b3c1f2c$exports = {};
"use strict";
Object.defineProperty($37fe02520b3c1f2c$exports, "__esModule", {
    value: true
});
$37fe02520b3c1f2c$exports.parse = $37fe02520b3c1f2c$var$parse;
$37fe02520b3c1f2c$exports.serialize = $37fe02520b3c1f2c$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $37fe02520b3c1f2c$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $37fe02520b3c1f2c$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $37fe02520b3c1f2c$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $37fe02520b3c1f2c$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $37fe02520b3c1f2c$var$__toString = Object.prototype.toString;
const $37fe02520b3c1f2c$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $37fe02520b3c1f2c$var$parse(str, options) {
    const obj = new $37fe02520b3c1f2c$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $37fe02520b3c1f2c$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $37fe02520b3c1f2c$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $37fe02520b3c1f2c$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $37fe02520b3c1f2c$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $37fe02520b3c1f2c$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $37fe02520b3c1f2c$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $37fe02520b3c1f2c$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $37fe02520b3c1f2c$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$37fe02520b3c1f2c$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$37fe02520b3c1f2c$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$37fe02520b3c1f2c$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$37fe02520b3c1f2c$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$37fe02520b3c1f2c$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $37fe02520b3c1f2c$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $37fe02520b3c1f2c$var$isDate(val) {
    return $37fe02520b3c1f2c$var$__toString.call(val) === "[object Date]";
}


var $35170a714e1598a5$exports = {};
"use strict";
var $35170a714e1598a5$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $35170a714e1598a5$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $35170a714e1598a5$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($35170a714e1598a5$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $35170a714e1598a5$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $35170a714e1598a5$var$defaultParseOptions, options) : $35170a714e1598a5$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $35170a714e1598a5$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $35170a714e1598a5$var$parse(input, options) {
    options = options ? Object.assign({}, $35170a714e1598a5$var$defaultParseOptions, options) : $35170a714e1598a5$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($35170a714e1598a5$var$isNonEmptyString).map(function(str) {
        return $35170a714e1598a5$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($35170a714e1598a5$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $35170a714e1598a5$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $35170a714e1598a5$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$35170a714e1598a5$exports = $35170a714e1598a5$var$parse;
$35170a714e1598a5$exports.parse = $35170a714e1598a5$var$parse;
$35170a714e1598a5$exports.parseString = $35170a714e1598a5$var$parseString;
$35170a714e1598a5$exports.splitCookiesString = $35170a714e1598a5$var$splitCookiesString;


var $fe9e62b514d376d4$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-K6AXKMTT.mjs"
});
var $fe9e62b514d376d4$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($fe9e62b514d376d4$export$e19cd5f9376f8cee || {});
var $fe9e62b514d376d4$var$PopStateEventType = "popstate";
function $fe9e62b514d376d4$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $fe9e62b514d376d4$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $fe9e62b514d376d4$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $fe9e62b514d376d4$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $fe9e62b514d376d4$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $fe9e62b514d376d4$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $fe9e62b514d376d4$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $fe9e62b514d376d4$export$fe53371bee54353d(to);
    }
    return $fe9e62b514d376d4$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $fe9e62b514d376d4$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $fe9e62b514d376d4$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $fe9e62b514d376d4$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $fe9e62b514d376d4$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $fe9e62b514d376d4$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $fe9e62b514d376d4$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $fe9e62b514d376d4$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $fe9e62b514d376d4$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $fe9e62b514d376d4$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $fe9e62b514d376d4$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $fe9e62b514d376d4$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $fe9e62b514d376d4$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $fe9e62b514d376d4$var$createKey()
    };
    return location;
}
function $fe9e62b514d376d4$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $fe9e62b514d376d4$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $fe9e62b514d376d4$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $fe9e62b514d376d4$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $fe9e62b514d376d4$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $fe9e62b514d376d4$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $fe9e62b514d376d4$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        let base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        let href = typeof to === "string" ? to : $fe9e62b514d376d4$export$fe53371bee54353d(to);
        href = href.replace(/ $/, "%20");
        $fe9e62b514d376d4$export$f5708dca728d7177(base, `No window.location.(origin|href) available to create URL for href: ${href}`);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($fe9e62b514d376d4$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($fe9e62b514d376d4$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var $fe9e62b514d376d4$var$immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $fe9e62b514d376d4$var$isIndexRoute(route) {
    return route.index === true;
}
function $fe9e62b514d376d4$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $fe9e62b514d376d4$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $fe9e62b514d376d4$export$f5708dca728d7177(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($fe9e62b514d376d4$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $fe9e62b514d376d4$var$convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function $fe9e62b514d376d4$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $fe9e62b514d376d4$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $fe9e62b514d376d4$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $fe9e62b514d376d4$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $fe9e62b514d376d4$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $fe9e62b514d376d4$var$flattenRoutes(routes);
    $fe9e62b514d376d4$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $fe9e62b514d376d4$var$decodePath(pathname);
        matches = $fe9e62b514d376d4$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $fe9e62b514d376d4$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $fe9e62b514d376d4$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $fe9e62b514d376d4$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $fe9e62b514d376d4$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $fe9e62b514d376d4$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $fe9e62b514d376d4$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $fe9e62b514d376d4$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $fe9e62b514d376d4$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $fe9e62b514d376d4$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $fe9e62b514d376d4$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $fe9e62b514d376d4$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $fe9e62b514d376d4$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $fe9e62b514d376d4$var$paramRe = /^:[\w-]+$/;
var $fe9e62b514d376d4$var$dynamicSegmentValue = 3;
var $fe9e62b514d376d4$var$indexRouteValue = 2;
var $fe9e62b514d376d4$var$emptySegmentValue = 1;
var $fe9e62b514d376d4$var$staticSegmentValue = 10;
var $fe9e62b514d376d4$var$splatPenalty = -2;
var $fe9e62b514d376d4$var$isSplat = (s)=>s === "*";
function $fe9e62b514d376d4$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($fe9e62b514d376d4$var$isSplat)) initialScore += $fe9e62b514d376d4$var$splatPenalty;
    if (index) initialScore += $fe9e62b514d376d4$var$indexRouteValue;
    return segments.filter((s)=>!$fe9e62b514d376d4$var$isSplat(s)).reduce((score, segment)=>score + ($fe9e62b514d376d4$var$paramRe.test(segment) ? $fe9e62b514d376d4$var$dynamicSegmentValue : segment === "" ? $fe9e62b514d376d4$var$emptySegmentValue : $fe9e62b514d376d4$var$staticSegmentValue), initialScore);
}
function $fe9e62b514d376d4$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $fe9e62b514d376d4$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $fe9e62b514d376d4$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $fe9e62b514d376d4$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $fe9e62b514d376d4$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $fe9e62b514d376d4$var$normalizePathname($fe9e62b514d376d4$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $fe9e62b514d376d4$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $fe9e62b514d376d4$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $fe9e62b514d376d4$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $fe9e62b514d376d4$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $fe9e62b514d376d4$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $fe9e62b514d376d4$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $fe9e62b514d376d4$var$compilePath(path, caseSensitive = false, end = true) {
    $fe9e62b514d376d4$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $fe9e62b514d376d4$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $fe9e62b514d376d4$var$warning(false, `The URL path "${value}" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $fe9e62b514d376d4$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $fe9e62b514d376d4$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $fe9e62b514d376d4$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $fe9e62b514d376d4$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $fe9e62b514d376d4$var$normalizeSearch(search),
        hash: $fe9e62b514d376d4$var$normalizeHash(hash)
    };
}
function $fe9e62b514d376d4$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $fe9e62b514d376d4$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $fe9e62b514d376d4$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $fe9e62b514d376d4$var$getResolveToMatches(matches) {
    let pathMatches = $fe9e62b514d376d4$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $fe9e62b514d376d4$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $fe9e62b514d376d4$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $fe9e62b514d376d4$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $fe9e62b514d376d4$var$getInvalidPathError("?", "pathname", "search", to));
        $fe9e62b514d376d4$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $fe9e62b514d376d4$var$getInvalidPathError("#", "pathname", "hash", to));
        $fe9e62b514d376d4$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $fe9e62b514d376d4$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $fe9e62b514d376d4$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $fe9e62b514d376d4$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $fe9e62b514d376d4$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $fe9e62b514d376d4$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $fe9e62b514d376d4$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $fe9e62b514d376d4$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $fe9e62b514d376d4$export$4051a07651545597(data2, init) {
    return new $fe9e62b514d376d4$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $fe9e62b514d376d4$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $fe9e62b514d376d4$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $fe9e62b514d376d4$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $fe9e62b514d376d4$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $fe9e62b514d376d4$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $fe9e62b514d376d4$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $fe9e62b514d376d4$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $fe9e62b514d376d4$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $fe9e62b514d376d4$var$validMutationMethods = new Set($fe9e62b514d376d4$var$validMutationMethodsArr);
var $fe9e62b514d376d4$var$validRequestMethodsArr = [
    "GET",
    ...$fe9e62b514d376d4$var$validMutationMethodsArr
];
var $fe9e62b514d376d4$var$validRequestMethods = new Set($fe9e62b514d376d4$var$validRequestMethodsArr);
var $fe9e62b514d376d4$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $fe9e62b514d376d4$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $fe9e62b514d376d4$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $fe9e62b514d376d4$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $fe9e62b514d376d4$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $fe9e62b514d376d4$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $fe9e62b514d376d4$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $fe9e62b514d376d4$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $fe9e62b514d376d4$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $fe9e62b514d376d4$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties2 = init.mapRouteProperties || $fe9e62b514d376d4$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $fe9e62b514d376d4$var$convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $fe9e62b514d376d4$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $fe9e62b514d376d4$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        let error = $fe9e62b514d376d4$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $fe9e62b514d376d4$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
    } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
    else {
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$fe9e62b514d376d4$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$fe9e62b514d376d4$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $fe9e62b514d376d4$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $fe9e62b514d376d4$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $fe9e62b514d376d4$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $fe9e62b514d376d4$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$fe9e62b514d376d4$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $fe9e62b514d376d4$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $fe9e62b514d376d4$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $fe9e62b514d376d4$export$386d57f03f0b2883));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $fe9e62b514d376d4$var$isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $fe9e62b514d376d4$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $fe9e62b514d376d4$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $fe9e62b514d376d4$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $fe9e62b514d376d4$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $fe9e62b514d376d4$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $fe9e62b514d376d4$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $fe9e62b514d376d4$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $fe9e62b514d376d4$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        if (state.initialized && !isRevalidationRequired && $fe9e62b514d376d4$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $fe9e62b514d376d4$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $fe9e62b514d376d4$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $fe9e62b514d376d4$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $fe9e62b514d376d4$var$isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($fe9e62b514d376d4$var$isErrorResult(result) && $fe9e62b514d376d4$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $fe9e62b514d376d4$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $fe9e62b514d376d4$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$fe9e62b514d376d4$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, isFogOfWar, opts = {}) {
        interruptActiveLoads();
        let navigation = $fe9e62b514d376d4$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fe9e62b514d376d4$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $fe9e62b514d376d4$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $fe9e62b514d376d4$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($fe9e62b514d376d4$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $fe9e62b514d376d4$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($fe9e62b514d376d4$var$isErrorResult(result)) {
            let boundaryMatch = $fe9e62b514d376d4$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $fe9e62b514d376d4$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $fe9e62b514d376d4$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fe9e62b514d376d4$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $fe9e62b514d376d4$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $fe9e62b514d376d4$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$fe9e62b514d376d4$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $fe9e62b514d376d4$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $fe9e62b514d376d4$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $fe9e62b514d376d4$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$fe9e62b514d376d4$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $fe9e62b514d376d4$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $fe9e62b514d376d4$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $fe9e62b514d376d4$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $fe9e62b514d376d4$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $fe9e62b514d376d4$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $fe9e62b514d376d4$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $fe9e62b514d376d4$var$isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $fe9e62b514d376d4$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fe9e62b514d376d4$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fe9e62b514d376d4$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fe9e62b514d376d4$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $fe9e62b514d376d4$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($fe9e62b514d376d4$var$isRedirectResult(actionResult) || $fe9e62b514d376d4$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $fe9e62b514d376d4$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($fe9e62b514d376d4$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $fe9e62b514d376d4$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $fe9e62b514d376d4$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($fe9e62b514d376d4$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $fe9e62b514d376d4$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $fe9e62b514d376d4$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $fe9e62b514d376d4$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $fe9e62b514d376d4$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $fe9e62b514d376d4$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $fe9e62b514d376d4$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect2 = $fe9e62b514d376d4$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $fe9e62b514d376d4$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $fe9e62b514d376d4$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        if (state.fetchers.has(key)) {
            let doneFetcher = $fe9e62b514d376d4$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $fe9e62b514d376d4$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $fe9e62b514d376d4$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fe9e62b514d376d4$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fe9e62b514d376d4$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fe9e62b514d376d4$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $fe9e62b514d376d4$var$getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $fe9e62b514d376d4$var$getDoneFetcher(void 0));
            return;
        }
        if ($fe9e62b514d376d4$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $fe9e62b514d376d4$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($fe9e62b514d376d4$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $fe9e62b514d376d4$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $fe9e62b514d376d4$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $fe9e62b514d376d4$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $fe9e62b514d376d4$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $fe9e62b514d376d4$var$stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $fe9e62b514d376d4$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($fe9e62b514d376d4$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $fe9e62b514d376d4$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $fe9e62b514d376d4$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $fe9e62b514d376d4$var$callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2);
        } catch (e) {
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($fe9e62b514d376d4$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $fe9e62b514d376d4$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $fe9e62b514d376d4$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        let loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state2, $fe9e62b514d376d4$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $fe9e62b514d376d4$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $fe9e62b514d376d4$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $fe9e62b514d376d4$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $fe9e62b514d376d4$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $fe9e62b514d376d4$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $fe9e62b514d376d4$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $fe9e62b514d376d4$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $fe9e62b514d376d4$export$386d57f03f0b2883;
        $fe9e62b514d376d4$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $fe9e62b514d376d4$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $fe9e62b514d376d4$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $fe9e62b514d376d4$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $fe9e62b514d376d4$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$fe9e62b514d376d4$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $fe9e62b514d376d4$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $fe9e62b514d376d4$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $fe9e62b514d376d4$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $fe9e62b514d376d4$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $fe9e62b514d376d4$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $fe9e62b514d376d4$var$convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $fe9e62b514d376d4$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function $fe9e62b514d376d4$var$createStaticHandler(routes, opts) {
    $fe9e62b514d376d4$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $fe9e62b514d376d4$var$defaultMapRouteProperties;
    let dataRoutes = $fe9e62b514d376d4$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $fe9e62b514d376d4$var$createLocation("", $fe9e62b514d376d4$export$fe53371bee54353d(url), null, "default");
        let matches = $fe9e62b514d376d4$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$fe9e62b514d376d4$var$isValidMethod(method) && method !== "HEAD") {
            let error = $fe9e62b514d376d4$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $fe9e62b514d376d4$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $fe9e62b514d376d4$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $fe9e62b514d376d4$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($fe9e62b514d376d4$var$isResponse(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $fe9e62b514d376d4$var$createLocation("", $fe9e62b514d376d4$export$fe53371bee54353d(url), null, "default");
        let matches = $fe9e62b514d376d4$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$fe9e62b514d376d4$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $fe9e62b514d376d4$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $fe9e62b514d376d4$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $fe9e62b514d376d4$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $fe9e62b514d376d4$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $fe9e62b514d376d4$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($fe9e62b514d376d4$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $fe9e62b514d376d4$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($fe9e62b514d376d4$var$isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $fe9e62b514d376d4$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $fe9e62b514d376d4$var$isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($fe9e62b514d376d4$var$isDataStrategyResult(e) && $fe9e62b514d376d4$var$isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($fe9e62b514d376d4$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $fe9e62b514d376d4$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $fe9e62b514d376d4$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($fe9e62b514d376d4$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($fe9e62b514d376d4$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($fe9e62b514d376d4$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fe9e62b514d376d4$var$findNearestBoundary(matches, actionMatch.route.id);
            let context2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...context2,
                statusCode: $fe9e62b514d376d4$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return {
            ...context,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $fe9e62b514d376d4$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $fe9e62b514d376d4$var$isErrorResult(pendingActionResult[1]) ? $fe9e62b514d376d4$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $fe9e62b514d376d4$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $fe9e62b514d376d4$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let context = $fe9e62b514d376d4$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return {
            ...context,
            matches: matches
        };
    }
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $fe9e62b514d376d4$var$callDataStrategyImpl(dataStrategy || $fe9e62b514d376d4$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($fe9e62b514d376d4$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $fe9e62b514d376d4$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($fe9e62b514d376d4$var$isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $fe9e62b514d376d4$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $fe9e62b514d376d4$var$getStaticContextFromError(routes, context, error) {
    let newContext = {
        ...context,
        statusCode: $fe9e62b514d376d4$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    };
    return newContext;
}
function $fe9e62b514d376d4$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $fe9e62b514d376d4$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $fe9e62b514d376d4$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $fe9e62b514d376d4$var$resolveTo(to ? to : ".", $fe9e62b514d376d4$var$getResolveToMatches(contextualMatches), $fe9e62b514d376d4$var$stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $fe9e62b514d376d4$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $fe9e62b514d376d4$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $fe9e62b514d376d4$export$fe53371bee54353d(path);
}
function $fe9e62b514d376d4$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$fe9e62b514d376d4$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$fe9e62b514d376d4$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $fe9e62b514d376d4$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $fe9e62b514d376d4$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $fe9e62b514d376d4$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$fe9e62b514d376d4$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$fe9e62b514d376d4$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $fe9e62b514d376d4$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $fe9e62b514d376d4$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $fe9e62b514d376d4$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $fe9e62b514d376d4$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $fe9e62b514d376d4$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($fe9e62b514d376d4$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $fe9e62b514d376d4$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $fe9e62b514d376d4$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $fe9e62b514d376d4$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $fe9e62b514d376d4$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary = false) {
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $fe9e62b514d376d4$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $fe9e62b514d376d4$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = $fe9e62b514d376d4$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $fe9e62b514d376d4$var$isErrorResult(pendingActionResult[1])) boundaryMatches = $fe9e62b514d376d4$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return $fe9e62b514d376d4$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if ($fe9e62b514d376d4$var$isNewLoader(state.loaderData, state.matches[index], match)) return true;
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $fe9e62b514d376d4$var$shouldRevalidateLoader(match, {
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $fe9e62b514d376d4$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        });
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = $fe9e62b514d376d4$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $fe9e62b514d376d4$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = $fe9e62b514d376d4$var$shouldRevalidateLoader(fetcherMatch, {
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        });
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $fe9e62b514d376d4$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== void 0;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $fe9e62b514d376d4$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $fe9e62b514d376d4$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $fe9e62b514d376d4$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $fe9e62b514d376d4$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $fe9e62b514d376d4$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$fe9e62b514d376d4$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $fe9e62b514d376d4$var$convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $fe9e62b514d376d4$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$fe9e62b514d376d4$var$isSameRoute(aChild, bChild)));
}
async function $fe9e62b514d376d4$var$loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $fe9e62b514d376d4$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $fe9e62b514d376d4$var$warning(!isPropertyStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
        if (!isPropertyStaticallyDefined && !$fe9e62b514d376d4$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    Object.assign(routeToUpdate, routeUpdates);
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...mapRouteProperties2(routeToUpdate),
        lazy: void 0
    });
}
async function $fe9e62b514d376d4$var$defaultDataStrategy({ matches: matches }) {
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $fe9e62b514d376d4$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $fe9e62b514d376d4$var$loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $fe9e62b514d376d4$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        };
        return {
            ...match,
            shouldLoad: shouldLoad,
            resolve: resolve
        };
    });
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {}
    return results;
}
async function $fe9e62b514d376d4$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (loadRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $fe9e62b514d376d4$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $fe9e62b514d376d4$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $fe9e62b514d376d4$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($fe9e62b514d376d4$var$isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $fe9e62b514d376d4$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($fe9e62b514d376d4$var$isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status
            };
            result = new $fe9e62b514d376d4$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data);
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $fe9e62b514d376d4$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($fe9e62b514d376d4$var$isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $fe9e62b514d376d4$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $fe9e62b514d376d4$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $fe9e62b514d376d4$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $fe9e62b514d376d4$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $fe9e62b514d376d4$var$stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $fe9e62b514d376d4$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($fe9e62b514d376d4$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $fe9e62b514d376d4$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $fe9e62b514d376d4$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $fe9e62b514d376d4$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $fe9e62b514d376d4$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $fe9e62b514d376d4$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $fe9e62b514d376d4$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $fe9e62b514d376d4$export$f5708dca728d7177(!$fe9e62b514d376d4$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($fe9e62b514d376d4$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $fe9e62b514d376d4$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $fe9e62b514d376d4$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $fe9e62b514d376d4$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $fe9e62b514d376d4$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $fe9e62b514d376d4$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $fe9e62b514d376d4$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($fe9e62b514d376d4$var$isErrorResult(result)) {
            let boundaryMatch = $fe9e62b514d376d4$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($fe9e62b514d376d4$var$isRedirectResult(result)) $fe9e62b514d376d4$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $fe9e62b514d376d4$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $fe9e62b514d376d4$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $fe9e62b514d376d4$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $fe9e62b514d376d4$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $fe9e62b514d376d4$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $fe9e62b514d376d4$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $fe9e62b514d376d4$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $fe9e62b514d376d4$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $fe9e62b514d376d4$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $fe9e62b514d376d4$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($fe9e62b514d376d4$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $fe9e62b514d376d4$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $fe9e62b514d376d4$export$8ccf933b0513f8d0(path) : path;
    return $fe9e62b514d376d4$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $fe9e62b514d376d4$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $fe9e62b514d376d4$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $fe9e62b514d376d4$var$isRedirectDataStrategyResult(result) {
    return $fe9e62b514d376d4$var$isResponse(result.result) && $fe9e62b514d376d4$var$redirectStatusCodes.has(result.result.status);
}
function $fe9e62b514d376d4$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $fe9e62b514d376d4$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $fe9e62b514d376d4$var$isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $fe9e62b514d376d4$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $fe9e62b514d376d4$var$isRedirectStatusCode(statusCode) {
    return $fe9e62b514d376d4$var$redirectStatusCodes.has(statusCode);
}
function $fe9e62b514d376d4$var$isRedirectResponse(result) {
    return $fe9e62b514d376d4$var$isResponse(result) && $fe9e62b514d376d4$var$isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function $fe9e62b514d376d4$var$isValidMethod(method) {
    return $fe9e62b514d376d4$var$validRequestMethods.has(method.toUpperCase());
}
function $fe9e62b514d376d4$var$isMutationMethod(method) {
    return $fe9e62b514d376d4$var$validMutationMethods.has(method.toUpperCase());
}
function $fe9e62b514d376d4$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $fe9e62b514d376d4$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $fe9e62b514d376d4$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $fe9e62b514d376d4$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $fe9e62b514d376d4$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $fe9e62b514d376d4$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $fe9e62b514d376d4$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $fe9e62b514d376d4$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $fe9e62b514d376d4$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $fe9e62b514d376d4$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $fe9e62b514d376d4$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $fe9e62b514d376d4$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($fe9e62b514d376d4$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $fe9e62b514d376d4$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($fe9e62b514d376d4$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $fe9e62b514d376d4$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $fe9e62b514d376d4$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $fe9e62b514d376d4$export$2eeee58951ff3c1c = $4Iuzv.createContext(null);
$fe9e62b514d376d4$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $fe9e62b514d376d4$export$315e3ffb01f217 = $4Iuzv.createContext(null);
$fe9e62b514d376d4$export$315e3ffb01f217.displayName = "DataRouterState";
var $fe9e62b514d376d4$export$3681f408decb40d1 = $4Iuzv.createContext({
    isTransitioning: false
});
$fe9e62b514d376d4$export$3681f408decb40d1.displayName = "ViewTransition";
var $fe9e62b514d376d4$export$cb3f1df1bef00a39 = $4Iuzv.createContext(/* @__PURE__ */ new Map());
$fe9e62b514d376d4$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $fe9e62b514d376d4$var$AwaitContext = $4Iuzv.createContext(null);
$fe9e62b514d376d4$var$AwaitContext.displayName = "Await";
var $fe9e62b514d376d4$export$3044ab7fdabeaee6 = $4Iuzv.createContext(null);
$fe9e62b514d376d4$export$3044ab7fdabeaee6.displayName = "Navigation";
var $fe9e62b514d376d4$export$e6a44b110a0c44d3 = $4Iuzv.createContext(null);
$fe9e62b514d376d4$export$e6a44b110a0c44d3.displayName = "Location";
var $fe9e62b514d376d4$export$aac280ed165a4397 = $4Iuzv.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$fe9e62b514d376d4$export$aac280ed165a4397.displayName = "Route";
var $fe9e62b514d376d4$var$RouteErrorContext = $4Iuzv.createContext(null);
$fe9e62b514d376d4$var$RouteErrorContext.displayName = "RouteError";
var $fe9e62b514d376d4$var$ENABLE_DEV_WARNINGS = true;
function $fe9e62b514d376d4$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $fe9e62b514d376d4$export$f5708dca728d7177($fe9e62b514d376d4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator2 } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $fe9e62b514d376d4$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $fe9e62b514d376d4$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $fe9e62b514d376d4$export$9c954a9d03d32f4a() {
    return $4Iuzv.useContext($fe9e62b514d376d4$export$e6a44b110a0c44d3) != null;
}
function $fe9e62b514d376d4$export$45d76561a5302f2b() {
    $fe9e62b514d376d4$export$f5708dca728d7177($fe9e62b514d376d4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $4Iuzv.useContext($fe9e62b514d376d4$export$e6a44b110a0c44d3).location;
}
function $fe9e62b514d376d4$export$1b3f31771c5d07c() {
    return $4Iuzv.useContext($fe9e62b514d376d4$export$e6a44b110a0c44d3).navigationType;
}
function $fe9e62b514d376d4$export$6c330e8992e8a295(pattern) {
    $fe9e62b514d376d4$export$f5708dca728d7177($fe9e62b514d376d4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $fe9e62b514d376d4$export$45d76561a5302f2b();
    return $4Iuzv.useMemo(()=>$fe9e62b514d376d4$export$81336c211d5ff295(pattern, $fe9e62b514d376d4$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $fe9e62b514d376d4$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $fe9e62b514d376d4$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6).static;
    if (!isStatic) $4Iuzv.useLayoutEffect(cb);
}
function $fe9e62b514d376d4$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    return isDataRoute ? $fe9e62b514d376d4$var$useNavigateStable() : $fe9e62b514d376d4$var$useNavigateUnstable();
}
function $fe9e62b514d376d4$var$useNavigateUnstable() {
    $fe9e62b514d376d4$export$f5708dca728d7177($fe9e62b514d376d4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $4Iuzv.useContext($fe9e62b514d376d4$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator2 } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let { matches: matches } = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($fe9e62b514d376d4$var$getResolveToMatches(matches));
    let activeRef = $4Iuzv.useRef(false);
    $fe9e62b514d376d4$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback((to, options = {})=>{
        $fe9e62b514d376d4$var$warning(activeRef.current, $fe9e62b514d376d4$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        let path = $fe9e62b514d376d4$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $fe9e62b514d376d4$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $fe9e62b514d376d4$var$OutletContext = $4Iuzv.createContext(null);
function $fe9e62b514d376d4$export$4138103a3ae699cc() {
    return $4Iuzv.useContext($fe9e62b514d376d4$var$OutletContext);
}
function $fe9e62b514d376d4$export$a3be3530d8e40d0b(context) {
    let outlet = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $fe9e62b514d376d4$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $fe9e62b514d376d4$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($fe9e62b514d376d4$var$getResolveToMatches(matches));
    return $4Iuzv.useMemo(()=>$fe9e62b514d376d4$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $fe9e62b514d376d4$export$5d3fca4a98652595(routes, locationArg) {
    return $fe9e62b514d376d4$var$useRoutesImpl(routes, locationArg);
}
function $fe9e62b514d376d4$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $fe9e62b514d376d4$export$f5708dca728d7177($fe9e62b514d376d4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator2 } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($fe9e62b514d376d4$var$ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        $fe9e62b514d376d4$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $fe9e62b514d376d4$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $fe9e62b514d376d4$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $fe9e62b514d376d4$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($fe9e62b514d376d4$var$ENABLE_DEV_WARNINGS) {
        $fe9e62b514d376d4$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $fe9e62b514d376d4$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $fe9e62b514d376d4$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $fe9e62b514d376d4$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $fe9e62b514d376d4$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $fe9e62b514d376d4$var$DefaultErrorComponent() {
    let error = $fe9e62b514d376d4$export$ed527bf60f6e05f2();
    let message = $fe9e62b514d376d4$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($fe9e62b514d376d4$var$ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ $4Iuzv.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $4Iuzv.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $4Iuzv.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $4Iuzv.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $4Iuzv.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $fe9e62b514d376d4$var$defaultErrorElement = /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$DefaultErrorComponent, null);
var $fe9e62b514d376d4$var$RenderErrorBoundary = class extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $fe9e62b514d376d4$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $4Iuzv.useContext($fe9e62b514d376d4$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $fe9e62b514d376d4$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $fe9e62b514d376d4$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $fe9e62b514d376d4$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $fe9e62b514d376d4$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $4Iuzv.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $fe9e62b514d376d4$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $fe9e62b514d376d4$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext($fe9e62b514d376d4$export$2eeee58951ff3c1c);
    $fe9e62b514d376d4$export$f5708dca728d7177(ctx, $fe9e62b514d376d4$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $fe9e62b514d376d4$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext($fe9e62b514d376d4$export$315e3ffb01f217);
    $fe9e62b514d376d4$export$f5708dca728d7177(state, $fe9e62b514d376d4$var$getDataRouterConsoleError(hookName));
    return state;
}
function $fe9e62b514d376d4$var$useRouteContext(hookName) {
    let route = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    $fe9e62b514d376d4$export$f5708dca728d7177(route, $fe9e62b514d376d4$var$getDataRouterConsoleError(hookName));
    return route;
}
function $fe9e62b514d376d4$var$useCurrentRouteId(hookName) {
    let route = $fe9e62b514d376d4$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $fe9e62b514d376d4$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $fe9e62b514d376d4$var$useRouteId() {
    return $fe9e62b514d376d4$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $fe9e62b514d376d4$export$d0fd4b7106de2769() {
    let state = $fe9e62b514d376d4$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $fe9e62b514d376d4$export$600dc272ed516c15() {
    let dataRouterContext = $fe9e62b514d376d4$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $fe9e62b514d376d4$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return $4Iuzv.useMemo(()=>({
            async revalidate () {
                await dataRouterContext.router.revalidate();
            },
            state: state.revalidation
        }), [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function $fe9e62b514d376d4$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $fe9e62b514d376d4$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $4Iuzv.useMemo(()=>matches.map((m)=>$fe9e62b514d376d4$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $fe9e62b514d376d4$export$1448a5050d252c4d() {
    let state = $fe9e62b514d376d4$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $fe9e62b514d376d4$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $fe9e62b514d376d4$export$fd5d37484eab868d(routeId) {
    let state = $fe9e62b514d376d4$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $fe9e62b514d376d4$export$fdc00f3f26066d5e() {
    let state = $fe9e62b514d376d4$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $fe9e62b514d376d4$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $fe9e62b514d376d4$export$ed527bf60f6e05f2() {
    let error = $4Iuzv.useContext($fe9e62b514d376d4$var$RouteErrorContext);
    let state = $fe9e62b514d376d4$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $fe9e62b514d376d4$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $fe9e62b514d376d4$export$78a72ddb39bdd145() {
    let value = $4Iuzv.useContext($fe9e62b514d376d4$var$AwaitContext);
    return value?._data;
}
function $fe9e62b514d376d4$export$17f53340677d5831() {
    let value = $4Iuzv.useContext($fe9e62b514d376d4$var$AwaitContext);
    return value?._error;
}
var $fe9e62b514d376d4$var$blockerId = 0;
function $fe9e62b514d376d4$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $fe9e62b514d376d4$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $fe9e62b514d376d4$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $4Iuzv.useState("");
    let blockerFunction = $4Iuzv.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $fe9e62b514d376d4$var$stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $fe9e62b514d376d4$var$stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $4Iuzv.useEffect(()=>{
        let key = String(++$fe9e62b514d376d4$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $4Iuzv.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $fe9e62b514d376d4$export$386d57f03f0b2883;
}
function $fe9e62b514d376d4$var$useNavigateStable() {
    let { router: router } = $fe9e62b514d376d4$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $fe9e62b514d376d4$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $4Iuzv.useRef(false);
    $fe9e62b514d376d4$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(async (to, options = {})=>{
        $fe9e62b514d376d4$var$warning(activeRef.current, $fe9e62b514d376d4$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $fe9e62b514d376d4$var$alreadyWarned = {};
function $fe9e62b514d376d4$var$warningOnce(key, cond, message) {
    if (!cond && !$fe9e62b514d376d4$var$alreadyWarned[key]) {
        $fe9e62b514d376d4$var$alreadyWarned[key] = true;
        $fe9e62b514d376d4$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $fe9e62b514d376d4$var$alreadyWarned2 = {};
function $fe9e62b514d376d4$var$warnOnce(condition, message) {
    if (!condition && !$fe9e62b514d376d4$var$alreadyWarned2[message]) {
        $fe9e62b514d376d4$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $fe9e62b514d376d4$var$ENABLE_DEV_WARNINGS2 = true;
function $fe9e62b514d376d4$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($fe9e62b514d376d4$var$ENABLE_DEV_WARNINGS2) {
            if (route.element) $fe9e62b514d376d4$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $4Iuzv.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($fe9e62b514d376d4$var$ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) $fe9e62b514d376d4$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $4Iuzv.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($fe9e62b514d376d4$var$ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) $fe9e62b514d376d4$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $4Iuzv.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function $fe9e62b514d376d4$export$f30f7e456d254e83(routes, opts) {
    return $fe9e62b514d376d4$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $fe9e62b514d376d4$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: $fe9e62b514d376d4$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $fe9e62b514d376d4$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $fe9e62b514d376d4$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $4Iuzv.useState(router.state);
    let [pendingState, setPendingState] = $4Iuzv.useState();
    let [vtContext, setVtContext] = $4Iuzv.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4Iuzv.useState();
    let [transition, setTransition] = $4Iuzv.useState();
    let [interruption, setInterruption] = $4Iuzv.useState();
    let fetcherData = $4Iuzv.useRef(/* @__PURE__ */ new Map());
    let setState = $4Iuzv.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        $fe9e62b514d376d4$var$warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $fe9e62b514d376d4$var$warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $4Iuzv.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $4Iuzv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4Iuzv.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fe9e62b514d376d4$var$Deferred());
    }, [
        vtContext
    ]);
    $4Iuzv.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $4Iuzv.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $4Iuzv.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $4Iuzv.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator2 = $4Iuzv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4Iuzv.useMemo(()=>({
            router: router,
            navigator: navigator2,
            static: false,
            basename: basename
        }), [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $fe9e62b514d376d4$var$MemoizedDataRoutes = $4Iuzv.memo($fe9e62b514d376d4$var$DataRoutes);
function $fe9e62b514d376d4$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $fe9e62b514d376d4$var$useRoutesImpl(routes, void 0, state, future);
}
function $fe9e62b514d376d4$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = $fe9e62b514d376d4$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $4Iuzv.useCallback((newState)=>{
        $4Iuzv.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $fe9e62b514d376d4$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $fe9e62b514d376d4$export$f5708dca728d7177($fe9e62b514d376d4$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    $fe9e62b514d376d4$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let navigate = $fe9e62b514d376d4$export$9770f232ac06a008();
    let path = $fe9e62b514d376d4$var$resolveTo(to, $fe9e62b514d376d4$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4Iuzv.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $fe9e62b514d376d4$export$910ae8079b2c2852(props) {
    return $fe9e62b514d376d4$export$a3be3530d8e40d0b(props.context);
}
function $fe9e62b514d376d4$export$e7b0ac011bb776c6(_props) {
    $fe9e62b514d376d4$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $fe9e62b514d376d4$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator2, static: staticProp = false }) {
    $fe9e62b514d376d4$export$f5708dca728d7177(!$fe9e62b514d376d4$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4Iuzv.useMemo(()=>({
            basename: basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $fe9e62b514d376d4$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4Iuzv.useMemo(()=>{
        let trailingPathname = $fe9e62b514d376d4$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $fe9e62b514d376d4$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $fe9e62b514d376d4$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $fe9e62b514d376d4$export$5d3fca4a98652595($fe9e62b514d376d4$export$16da398f5434bdec(children), location);
}
function $fe9e62b514d376d4$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$ResolveAwait, null, children));
}
var $fe9e62b514d376d4$var$AwaitErrorBoundary = class extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $fe9e62b514d376d4$var$ResolveAwait({ children: children }) {
    let data2 = $fe9e62b514d376d4$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, toRender);
}
function $fe9e62b514d376d4$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $4Iuzv.Children.forEach(children, (element, index)=>{
        if (!$4Iuzv.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4Iuzv.Fragment) {
            routes.push.apply(routes, $fe9e62b514d376d4$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $fe9e62b514d376d4$export$f5708dca728d7177(element.type === $fe9e62b514d376d4$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $fe9e62b514d376d4$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $fe9e62b514d376d4$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $fe9e62b514d376d4$export$9b5b6d122dea0c88 = $fe9e62b514d376d4$export$16da398f5434bdec;
function $fe9e62b514d376d4$export$daf73786167a7f72(matches) {
    return $fe9e62b514d376d4$var$_renderMatches(matches);
}
// lib/dom/dom.ts
var $fe9e62b514d376d4$var$defaultMethod = "get";
var $fe9e62b514d376d4$var$defaultEncType = "application/x-www-form-urlencoded";
function $fe9e62b514d376d4$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fe9e62b514d376d4$var$isButtonElement(object) {
    return $fe9e62b514d376d4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fe9e62b514d376d4$var$isFormElement(object) {
    return $fe9e62b514d376d4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fe9e62b514d376d4$var$isInputElement(object) {
    return $fe9e62b514d376d4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fe9e62b514d376d4$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fe9e62b514d376d4$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fe9e62b514d376d4$var$isModifiedEvent(event);
}
function $fe9e62b514d376d4$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fe9e62b514d376d4$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $fe9e62b514d376d4$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $fe9e62b514d376d4$var$_formDataSupportsSubmitter = null;
function $fe9e62b514d376d4$var$isFormDataSubmitterSupported() {
    if ($fe9e62b514d376d4$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fe9e62b514d376d4$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fe9e62b514d376d4$var$_formDataSupportsSubmitter = true;
    }
    return $fe9e62b514d376d4$var$_formDataSupportsSubmitter;
}
var $fe9e62b514d376d4$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fe9e62b514d376d4$var$getFormEncType(encType) {
    if (encType != null && !$fe9e62b514d376d4$var$supportedFormEncTypes.has(encType)) {
        $fe9e62b514d376d4$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$fe9e62b514d376d4$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $fe9e62b514d376d4$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($fe9e62b514d376d4$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $fe9e62b514d376d4$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || $fe9e62b514d376d4$var$defaultMethod;
        encType = $fe9e62b514d376d4$var$getFormEncType(target.getAttribute("enctype")) || $fe9e62b514d376d4$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fe9e62b514d376d4$var$isButtonElement(target) || $fe9e62b514d376d4$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $fe9e62b514d376d4$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fe9e62b514d376d4$var$defaultMethod;
        encType = $fe9e62b514d376d4$var$getFormEncType(target.getAttribute("formenctype")) || $fe9e62b514d376d4$var$getFormEncType(form.getAttribute("enctype")) || $fe9e62b514d376d4$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$fe9e62b514d376d4$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fe9e62b514d376d4$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $fe9e62b514d376d4$var$defaultMethod;
        action = null;
        encType = $fe9e62b514d376d4$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function $fe9e62b514d376d4$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function $fe9e62b514d376d4$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $fe9e62b514d376d4$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $fe9e62b514d376d4$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $fe9e62b514d376d4$var$getCurrentPageModulePreloadHrefs(matches, manifest);
    return $fe9e62b514d376d4$var$dedupeLinkDescriptors(descriptors, preloads);
}
async function $fe9e62b514d376d4$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$fe9e62b514d376d4$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        })));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$fe9e62b514d376d4$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    let matchingLinks = styleLinks.filter((link)=>(!link.media || window.matchMedia(link.media).matches) && !document.querySelector(`link[rel="stylesheet"][href="${link.href}"]`));
    await Promise.all(matchingLinks.map($fe9e62b514d376d4$var$prefetchStyleLink));
}
async function $fe9e62b514d376d4$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $fe9e62b514d376d4$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $fe9e62b514d376d4$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $fe9e62b514d376d4$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $fe9e62b514d376d4$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $fe9e62b514d376d4$var$dedupeLinkDescriptors(links.flat(1).filter($fe9e62b514d376d4$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $fe9e62b514d376d4$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $fe9e62b514d376d4$var$getModuleLinkHrefs(matches, manifestPatch) {
    return $fe9e62b514d376d4$var$dedupeHrefs(matches.map((match)=>{
        let route = manifestPatch.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $fe9e62b514d376d4$var$getCurrentPageModulePreloadHrefs(matches, manifest) {
    return $fe9e62b514d376d4$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $fe9e62b514d376d4$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $fe9e62b514d376d4$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $fe9e62b514d376d4$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$fe9e62b514d376d4$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($fe9e62b514d376d4$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $fe9e62b514d376d4$var$_isPreloadSupported;
function $fe9e62b514d376d4$var$isPreloadSupported() {
    if ($fe9e62b514d376d4$var$_isPreloadSupported !== void 0) return $fe9e62b514d376d4$var$_isPreloadSupported;
    let el = document.createElement("link");
    $fe9e62b514d376d4$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $fe9e62b514d376d4$var$_isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var $fe9e62b514d376d4$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $fe9e62b514d376d4$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $fe9e62b514d376d4$var$escapeHtml(html) {
    return html.replace($fe9e62b514d376d4$var$ESCAPE_REGEX, (match)=>$fe9e62b514d376d4$var$ESCAPE_LOOKUP[match]);
}
function $fe9e62b514d376d4$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/data.ts
async function $fe9e62b514d376d4$var$createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var $fe9e62b514d376d4$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
function $fe9e62b514d376d4$var$StreamTransfer({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $4Iuzv.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$fe9e62b514d376d4$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, scriptTag, /* @__PURE__ */ $4Iuzv.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, scriptTag, /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Suspense, null, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $fe9e62b514d376d4$export$c7c51be9b423c4d6(manifest, routeModules, getRouter) {
    return async ({ request: request, matches: matches, fetcherKey: fetcherKey })=>{
        if (request.method !== "GET") return $fe9e62b514d376d4$var$singleFetchActionStrategy(request, matches);
        if (fetcherKey) return $fe9e62b514d376d4$var$singleFetchLoaderFetcherStrategy(request, matches);
        return $fe9e62b514d376d4$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, getRouter(), request, matches);
    };
}
async function $fe9e62b514d376d4$var$singleFetchActionStrategy(request, matches) {
    let actionMatch = matches.find((m)=>m.shouldLoad);
    $fe9e62b514d376d4$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let url = $fe9e62b514d376d4$var$singleFetchUrl(request.url);
            let init = await $fe9e62b514d376d4$var$createRequestInit(request);
            let { data: data2, status: status } = await $fe9e62b514d376d4$var$fetchAndDecode(url, init);
            actionStatus = status;
            return $fe9e62b514d376d4$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($fe9e62b514d376d4$var$isResponse(result.result) || $fe9e62b514d376d4$export$972111febbeef05b(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $fe9e62b514d376d4$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $fe9e62b514d376d4$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, router, request, matches) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = matches.map(()=>$fe9e62b514d376d4$var$createDeferred2());
    let routesLoadedPromise = Promise.all(routeDfds.map((d)=>d.promise));
    let singleFetchDfd = $fe9e62b514d376d4$var$createDeferred2();
    let url = $fe9e62b514d376d4$var$stripIndexParam($fe9e62b514d376d4$var$singleFetchUrl(request.url));
    let init = await $fe9e62b514d376d4$var$createRequestInit(request);
    let results = {};
    let resolvePromise = Promise.all(matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let manifestRoute = manifest.routes[m.route.id];
            if (!m.shouldLoad) {
                if (!router.state.initialized) return;
                if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && routeModules[m.route.id]?.shouldRevalidate) {
                    foundOptOutRoute = true;
                    return;
                }
            }
            if (manifestRoute && manifestRoute.hasClientLoader) {
                if (manifestRoute.hasLoader) foundOptOutRoute = true;
                try {
                    let result = await $fe9e62b514d376d4$var$fetchSingleLoader(handler, url, init, m.route.id);
                    results[m.route.id] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[m.route.id] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $fe9e62b514d376d4$var$unwrapSingleFetchResults(data2, m.route.id);
                });
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await routesLoadedPromise;
    if ((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({});
    else try {
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        let data2 = await $fe9e62b514d376d4$var$fetchAndDecode(url, init);
        singleFetchDfd.resolve(data2.data);
    } catch (e) {
        singleFetchDfd.reject(e);
    }
    await resolvePromise;
    return results;
}
async function $fe9e62b514d376d4$var$singleFetchLoaderFetcherStrategy(request, matches) {
    let fetcherMatch = matches.find((m)=>m.shouldLoad);
    $fe9e62b514d376d4$var$invariant2(fetcherMatch, "No fetcher match found");
    let result = await fetcherMatch.resolve(async (handler)=>{
        let url = $fe9e62b514d376d4$var$stripIndexParam($fe9e62b514d376d4$var$singleFetchUrl(request.url));
        let init = await $fe9e62b514d376d4$var$createRequestInit(request);
        return $fe9e62b514d376d4$var$fetchSingleLoader(handler, url, init, fetcherMatch.route.id);
    });
    return {
        [fetcherMatch.route.id]: result
    };
}
function $fe9e62b514d376d4$var$fetchSingleLoader(handler, url, init, routeId) {
    return handler(async ()=>{
        let singleLoaderUrl = new URL(url);
        singleLoaderUrl.searchParams.set("_routes", routeId);
        let { data: data2 } = await $fe9e62b514d376d4$var$fetchAndDecode(singleLoaderUrl, init);
        return $fe9e62b514d376d4$var$unwrapSingleFetchResults(data2, routeId);
    });
}
function $fe9e62b514d376d4$var$stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $fe9e62b514d376d4$var$singleFetchUrl(reqUrl) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function $fe9e62b514d376d4$var$fetchAndDecode(url, init) {
    let res = await fetch(url, init);
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $fe9e62b514d376d4$export$f2680fa305b734ca(404, "Not Found", true);
    $fe9e62b514d376d4$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $fe9e62b514d376d4$export$4023ad4ecd4126a2(res.body, window);
        return {
            status: res.status,
            data: decoded.value
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $fe9e62b514d376d4$export$4023ad4ecd4126a2(body, global2) {
    return (0, $42195ed59b233082$exports.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $fe9e62b514d376d4$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$fe9e62b514d376d4$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $fe9e62b514d376d4$var$unwrapSingleFetchResults(results, routeId) {
    let redirect2 = results[$fe9e62b514d376d4$export$60644022b8b46aaa];
    if (redirect2) return $fe9e62b514d376d4$var$unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? $fe9e62b514d376d4$var$unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function $fe9e62b514d376d4$var$unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        let headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        throw $fe9e62b514d376d4$export$89e12c5b50f7529d(result.redirect, {
            status: result.status,
            headers: headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error(`No response found for routeId "${routeId}"`);
}
function $fe9e62b514d376d4$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $fe9e62b514d376d4$export$32e57f52df4b6e34 = class extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $fe9e62b514d376d4$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $4Iuzv.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."
        );
      `
        }
    });
    if ($fe9e62b514d376d4$export$972111febbeef05b(error)) return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $4Iuzv.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $4Iuzv.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $4Iuzv.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $fe9e62b514d376d4$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $fe9e62b514d376d4$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $4Iuzv.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $4Iuzv.createElement("head", null, /* @__PURE__ */ $4Iuzv.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $4Iuzv.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $4Iuzv.createElement("title", null, title)), /* @__PURE__ */ $4Iuzv.createElement("body", null, /* @__PURE__ */ $4Iuzv.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$ff0bf87698939488, null) : null)));
}
function $fe9e62b514d376d4$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ $4Iuzv.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://remix.run/route/hydrate-fallback " +
                "for more information."
              );
            `
        }
    }));
}
// lib/dom/ssr/routes.tsx
function $fe9e62b514d376d4$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $fe9e62b514d376d4$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $fe9e62b514d376d4$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $fe9e62b514d376d4$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$RemixRootDefaultErrorBoundary, {
            error: $fe9e62b514d376d4$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $4Iuzv.createElement(routeModule.Layout, null, /* @__PURE__ */ $4Iuzv.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $4Iuzv.createElement(routeModule.Layout, null, /* @__PURE__ */ $4Iuzv.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $4Iuzv.createElement(routeModule.Layout, null, /* @__PURE__ */ $4Iuzv.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $fe9e62b514d376d4$var$createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $fe9e62b514d376d4$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $fe9e62b514d376d4$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$fe9e62b514d376d4$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $fe9e62b514d376d4$var$createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $fe9e62b514d376d4$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, future, isSpaMode) {
    return $fe9e62b514d376d4$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, "", $fe9e62b514d376d4$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $fe9e62b514d376d4$var$preventInvalidServerHandlerCall(type, route, isSpaMode) {
    if (isSpaMode) {
        let fn2 = type === "action" ? "serverAction()" : "serverLoader()";
        let msg2 = `You cannot call ${fn2} in SPA Mode (routeId: "${route.id}")`;
        console.error(msg2);
        throw new $fe9e62b514d376d4$export$f2680fa305b734ca(400, "Bad Request", new Error(msg2), true);
    }
    let fn = type === "action" ? "serverAction()" : "serverLoader()";
    let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        console.error(msg);
        throw new $fe9e62b514d376d4$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $fe9e62b514d376d4$var$noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $fe9e62b514d376d4$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $fe9e62b514d376d4$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, parentId = "", routesByParentId = $fe9e62b514d376d4$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $fe9e62b514d376d4$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $fe9e62b514d376d4$var$noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $fe9e62b514d376d4$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$fe9e62b514d376d4$var$getRouteComponents(route, routeModule, isSpaMode),
                handle: routeModule.handle,
                shouldRevalidate: $fe9e62b514d376d4$var$getShouldRevalidateFunction(routeModule, route.id, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $fe9e62b514d376d4$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) {
                            if (isSpaMode) return null;
                            return fetchServerLoader(singleFetch);
                        }
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            async serverLoader () {
                                $fe9e62b514d376d4$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $fe9e62b514d376d4$export$6ac68922d4e92125(route, routeModule, isSpaMode);
            dataRoute.action = ({ request: request, params: params }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $fe9e62b514d376d4$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $fe9e62b514d376d4$var$noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        async serverAction () {
                            $fe9e62b514d376d4$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) return Promise.resolve(null);
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $fe9e62b514d376d4$var$noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            dataRoute.lazy = async ()=>{
                let mod = await $fe9e62b514d376d4$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                let lazyRoute = {
                    ...mod
                };
                if (mod.clientLoader) {
                    let clientLoader = mod.clientLoader;
                    lazyRoute.loader = (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $fe9e62b514d376d4$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                }
                if (mod.clientAction) {
                    let clientAction = mod.clientAction;
                    lazyRoute.action = (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $fe9e62b514d376d4$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                                return fetchServerAction(singleFetch);
                            }
                        });
                }
                return {
                    ...lazyRoute.loader ? {
                        loader: lazyRoute.loader
                    } : {},
                    ...lazyRoute.action ? {
                        action: lazyRoute.action
                    } : {},
                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                    shouldRevalidate: $fe9e62b514d376d4$var$getShouldRevalidateFunction(lazyRoute, route.id, needsRevalidation),
                    handle: lazyRoute.handle,
                    // No need to wrap these in layout since the root route is never
                    // loaded via route.lazy()
                    Component: lazyRoute.Component,
                    ErrorBoundary: lazyRoute.ErrorBoundary
                };
            };
        }
        let children = $fe9e62b514d376d4$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $fe9e62b514d376d4$var$getShouldRevalidateFunction(route, routeId, needsRevalidation) {
    if (needsRevalidation) return $fe9e62b514d376d4$var$wrapShouldRevalidateForHdr(routeId, route.shouldRevalidate, needsRevalidation);
    if (route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $fe9e62b514d376d4$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $fe9e62b514d376d4$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModule = await $fe9e62b514d376d4$var$loadRouteModule(route, routeModules);
    await $fe9e62b514d376d4$var$prefetchStyleLinks(route, routeModule);
    return {
        Component: $fe9e62b514d376d4$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $fe9e62b514d376d4$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $fe9e62b514d376d4$export$6ac68922d4e92125(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $fe9e62b514d376d4$var$nextPaths = /* @__PURE__ */ new Set();
var $fe9e62b514d376d4$var$discoveredPathsMaxSize = 1e3;
var $fe9e62b514d376d4$var$discoveredPaths = /* @__PURE__ */ new Set();
var $fe9e62b514d376d4$var$URL_LIMIT = 7680;
function $fe9e62b514d376d4$var$isFogOfWarEnabled(isSpaMode) {
    return !isSpaMode;
}
function $fe9e62b514d376d4$var$getPartialManifest(manifest, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $fe9e62b514d376d4$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes
    };
}
function $fe9e62b514d376d4$export$72ab377a1030deb9(manifest, routeModules, isSpaMode, basename) {
    if (!$fe9e62b514d376d4$var$isFogOfWarEnabled(isSpaMode)) return void 0;
    return async ({ path: path, patch: patch })=>{
        if ($fe9e62b514d376d4$var$discoveredPaths.has(path)) return;
        await $fe9e62b514d376d4$var$fetchAndApplyManifestPatches([
            path
        ], manifest, routeModules, isSpaMode, basename, patch);
    };
}
function $fe9e62b514d376d4$export$5ef046b23d96090d(router, manifest, routeModules, isSpaMode) {
    $4Iuzv.useEffect(()=>{
        if (!$fe9e62b514d376d4$var$isFogOfWarEnabled(isSpaMode) || navigator.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let url = new URL(path, window.location.origin);
            if (!$fe9e62b514d376d4$var$discoveredPaths.has(url.pathname)) $fe9e62b514d376d4$var$nextPaths.add(url.pathname);
        }
        async function fetchPatches() {
            let lazyPaths = Array.from($fe9e62b514d376d4$var$nextPaths.keys()).filter((path)=>{
                if ($fe9e62b514d376d4$var$discoveredPaths.has(path)) {
                    $fe9e62b514d376d4$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $fe9e62b514d376d4$var$fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, isSpaMode, router.basename, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        document.body.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>registerElement(el));
        fetchPatches();
        let debouncedFetchPatches = $fe9e62b514d376d4$var$debounce(fetchPatches, 100);
        function isElement(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        }
        let observer = new MutationObserver((records)=>{
            let elements = /* @__PURE__ */ new Set();
            records.forEach((r)=>{
                [
                    r.target,
                    ...r.addedNodes
                ].forEach((node)=>{
                    if (!isElement(node)) return;
                    if (node.tagName === "A" && node.getAttribute("data-discover")) elements.add(node);
                    else if (node.tagName === "FORM" && node.getAttribute("data-discover")) elements.add(node);
                    if (node.tagName !== "A") node.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>elements.add(el));
                });
            });
            elements.forEach((el)=>registerElement(el));
            debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
async function $fe9e62b514d376d4$var$fetchAndApplyManifestPatches(paths, manifest, routeModules, isSpaMode, basename, patchRoutes) {
    let manifestPath = `${basename != null ? basename : "/"}/__manifest`.replace(/\/+/g, "/");
    let url = new URL(manifestPath, window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $fe9e62b514d376d4$var$URL_LIMIT) {
        $fe9e62b514d376d4$var$nextPaths.clear();
        return;
    }
    let res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    else if (res.status >= 400) throw new Error(await res.text());
    let serverPatches = await res.json();
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$fe9e62b514d376d4$var$addToFifoQueue(p, $fe9e62b514d376d4$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $fe9e62b514d376d4$export$af76e85f27ba0229(patches, routeModules, null, isSpaMode, parentId)));
}
function $fe9e62b514d376d4$var$addToFifoQueue(path, queue) {
    if (queue.size >= $fe9e62b514d376d4$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $fe9e62b514d376d4$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $fe9e62b514d376d4$var$useDataRouterContext2() {
    let context = $4Iuzv.useContext($fe9e62b514d376d4$export$2eeee58951ff3c1c);
    $fe9e62b514d376d4$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $fe9e62b514d376d4$var$useDataRouterStateContext() {
    let context = $4Iuzv.useContext($fe9e62b514d376d4$export$315e3ffb01f217);
    $fe9e62b514d376d4$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $fe9e62b514d376d4$export$208d6a3bc3aa62bd = $4Iuzv.createContext(void 0);
$fe9e62b514d376d4$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $fe9e62b514d376d4$var$useFrameworkContext() {
    let context = $4Iuzv.useContext($fe9e62b514d376d4$export$208d6a3bc3aa62bd);
    $fe9e62b514d376d4$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $fe9e62b514d376d4$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $4Iuzv.useContext($fe9e62b514d376d4$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $4Iuzv.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $4Iuzv.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $4Iuzv.useRef(null);
    $4Iuzv.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $4Iuzv.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $fe9e62b514d376d4$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $fe9e62b514d376d4$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $fe9e62b514d376d4$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $fe9e62b514d376d4$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $fe9e62b514d376d4$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $fe9e62b514d376d4$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $fe9e62b514d376d4$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$fe9e62b514d376d4$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function $fe9e62b514d376d4$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $fe9e62b514d376d4$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $fe9e62b514d376d4$var$useDataRouterStateContext();
    let matches = $fe9e62b514d376d4$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $4Iuzv.useMemo(()=>$fe9e62b514d376d4$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, criticalCss ? /* @__PURE__ */ $4Iuzv.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(({ key: key, link: link })=>$fe9e62b514d376d4$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $4Iuzv.createElement("link", {
            key: key,
            ...link
        })));
}
function $fe9e62b514d376d4$export$60dcec93e67386bd({ page: page, ...dataLinkProps }) {
    let { router: router } = $fe9e62b514d376d4$var$useDataRouterContext2();
    let matches = $4Iuzv.useMemo(()=>$fe9e62b514d376d4$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...dataLinkProps
    });
}
function $fe9e62b514d376d4$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $fe9e62b514d376d4$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $4Iuzv.useState([]);
    $4Iuzv.useEffect(()=>{
        let interrupted = false;
        $fe9e62b514d376d4$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $fe9e62b514d376d4$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $fe9e62b514d376d4$var$useFrameworkContext();
    let { loaderData: loaderData, matches: matches } = $fe9e62b514d376d4$var$useDataRouterStateContext();
    let newMatchesForData = $4Iuzv.useMemo(()=>$fe9e62b514d376d4$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $4Iuzv.useMemo(()=>$fe9e62b514d376d4$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $4Iuzv.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $fe9e62b514d376d4$var$singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $4Iuzv.useMemo(()=>$fe9e62b514d376d4$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $fe9e62b514d376d4$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $4Iuzv.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $4Iuzv.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $4Iuzv.createElement("link", {
            key: key,
            ...link
        })));
}
function $fe9e62b514d376d4$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $fe9e62b514d376d4$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $fe9e62b514d376d4$var$useDataRouterStateContext();
    let location = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let _matches = $fe9e62b514d376d4$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$fe9e62b514d376d4$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $4Iuzv.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $4Iuzv.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $4Iuzv.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $4Iuzv.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $4Iuzv.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $fe9e62b514d376d4$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $fe9e62b514d376d4$var$isHydrated = false;
function $fe9e62b514d376d4$export$ff0bf87698939488(props) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta } = $fe9e62b514d376d4$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $fe9e62b514d376d4$var$useDataRouterContext2();
    let { matches: routerMatches } = $fe9e62b514d376d4$var$useDataRouterStateContext();
    let enableFogOfWar = $fe9e62b514d376d4$var$isFogOfWarEnabled(isSpaMode);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $fe9e62b514d376d4$var$getActiveMatches(routerMatches, null, isSpaMode);
    $4Iuzv.useEffect(()=>{
        $fe9e62b514d376d4$var$isHydrated = true;
    }, []);
    let initialScripts = $4Iuzv.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, index)=>`import * as route${index} from ${JSON.stringify(manifest.routes[match.route.id].module)};`).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($fe9e62b514d376d4$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $fe9e62b514d376d4$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $4Iuzv.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $fe9e62b514d376d4$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let routePreloads = matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        return route ? (route.imports || []).concat([
            route.module
        ]) : [];
    }).flat(1);
    let preloads = $fe9e62b514d376d4$var$isHydrated ? [] : manifest.entry.imports.concat(routePreloads);
    return $fe9e62b514d376d4$var$isHydrated ? null : /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ $4Iuzv.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ $4Iuzv.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), $fe9e62b514d376d4$var$dedupe(preloads).map((path)=>/* @__PURE__ */ $4Iuzv.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        })), initialScripts);
}
function $fe9e62b514d376d4$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $fe9e62b514d376d4$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var $fe9e62b514d376d4$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($fe9e62b514d376d4$var$isBrowser) window.__reactRouterVersion = "7.1.1";
} catch (e) {}
function $fe9e62b514d376d4$export$1f3f55432a00e06d(routes, opts) {
    return $fe9e62b514d376d4$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $fe9e62b514d376d4$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $fe9e62b514d376d4$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $fe9e62b514d376d4$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $fe9e62b514d376d4$export$1ba7ed8a3a7b3765(routes, opts) {
    return $fe9e62b514d376d4$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $fe9e62b514d376d4$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $fe9e62b514d376d4$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $fe9e62b514d376d4$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $fe9e62b514d376d4$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $fe9e62b514d376d4$var$deserializeErrors(state.errors)
    };
    return state;
}
function $fe9e62b514d376d4$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $fe9e62b514d376d4$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $fe9e62b514d376d4$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = $fe9e62b514d376d4$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $4Iuzv.useCallback((newState)=>{
        $4Iuzv.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $fe9e62b514d376d4$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = $fe9e62b514d376d4$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $4Iuzv.useCallback((newState)=>{
        $4Iuzv.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $fe9e62b514d376d4$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $4Iuzv.useCallback((newState)=>{
        $4Iuzv.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$fe9e62b514d376d4$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $fe9e62b514d376d4$export$a6c7ac8248d6e38a = $4Iuzv.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($fe9e62b514d376d4$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $fe9e62b514d376d4$var$stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $fe9e62b514d376d4$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $fe9e62b514d376d4$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $fe9e62b514d376d4$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $fe9e62b514d376d4$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $4Iuzv.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $fe9e62b514d376d4$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, link, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$fe9e62b514d376d4$export$a6c7ac8248d6e38a.displayName = "Link";
var $fe9e62b514d376d4$export$b0d92dbee9b5b60d = $4Iuzv.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $fe9e62b514d376d4$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let routerState = $4Iuzv.useContext($fe9e62b514d376d4$export$315e3ffb01f217);
    let { navigator: navigator2, basename: basename } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fe9e62b514d376d4$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $fe9e62b514d376d4$var$stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$fe9e62b514d376d4$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $fe9e62b514d376d4$export$a7fed597f4b8afd8 = $4Iuzv.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $fe9e62b514d376d4$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $fe9e62b514d376d4$export$47c85c6e3a081d3();
    let formAction = $fe9e62b514d376d4$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $4Iuzv.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$fe9e62b514d376d4$export$a7fed597f4b8afd8.displayName = "Form";
function $fe9e62b514d376d4$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $4Iuzv.useContext($fe9e62b514d376d4$export$208d6a3bc3aa62bd);
    let { basename: basename } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let location = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let matches = $fe9e62b514d376d4$export$2378eb7f5ff86053();
    $fe9e62b514d376d4$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $4Iuzv.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $fe9e62b514d376d4$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $4Iuzv.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $fe9e62b514d376d4$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$fe9e62b514d376d4$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $fe9e62b514d376d4$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $fe9e62b514d376d4$var$useDataRouterContext3(hookName) {
    let ctx = $4Iuzv.useContext($fe9e62b514d376d4$export$2eeee58951ff3c1c);
    $fe9e62b514d376d4$export$f5708dca728d7177(ctx, $fe9e62b514d376d4$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $fe9e62b514d376d4$var$useDataRouterState2(hookName) {
    let state = $4Iuzv.useContext($fe9e62b514d376d4$export$315e3ffb01f217);
    $fe9e62b514d376d4$export$f5708dca728d7177(state, $fe9e62b514d376d4$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $fe9e62b514d376d4$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $fe9e62b514d376d4$export$9770f232ac06a008();
    let location = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let path = $fe9e62b514d376d4$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $4Iuzv.useCallback((event)=>{
        if ($fe9e62b514d376d4$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $fe9e62b514d376d4$export$fe53371bee54353d(location) === $fe9e62b514d376d4$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $fe9e62b514d376d4$export$f1a78c17382fe22a(defaultInit) {
    $fe9e62b514d376d4$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $4Iuzv.useRef($fe9e62b514d376d4$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4Iuzv.useRef(false);
    let location = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let searchParams = $4Iuzv.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fe9e62b514d376d4$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $fe9e62b514d376d4$export$9770f232ac06a008();
    let setSearchParams = $4Iuzv.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $fe9e62b514d376d4$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $fe9e62b514d376d4$var$fetcherId = 0;
var $fe9e62b514d376d4$var$getUniqueFetcherId = ()=>`__${String(++$fe9e62b514d376d4$var$fetcherId)}__`;
function $fe9e62b514d376d4$export$47c85c6e3a081d3() {
    let { router: router } = $fe9e62b514d376d4$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let currentRouteId = $fe9e62b514d376d4$var$useRouteId();
    return $4Iuzv.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $fe9e62b514d376d4$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $fe9e62b514d376d4$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $fe9e62b514d376d4$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let routeContext = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    $fe9e62b514d376d4$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$fe9e62b514d376d4$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $fe9e62b514d376d4$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $fe9e62b514d376d4$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $fe9e62b514d376d4$export$fe53371bee54353d(path);
}
function $fe9e62b514d376d4$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $fe9e62b514d376d4$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $fe9e62b514d376d4$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $4Iuzv.useContext($fe9e62b514d376d4$export$cb3f1df1bef00a39);
    let route = $4Iuzv.useContext($fe9e62b514d376d4$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $fe9e62b514d376d4$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $fe9e62b514d376d4$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $fe9e62b514d376d4$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $4Iuzv.useId();
    let [fetcherKey, setFetcherKey] = $4Iuzv.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $4Iuzv.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $4Iuzv.useCallback(async (href, opts)=>{
        $fe9e62b514d376d4$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $fe9e62b514d376d4$export$47c85c6e3a081d3();
    let submit = $4Iuzv.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4Iuzv.useMemo(()=>{
        let FetcherForm2 = $4Iuzv.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $fe9e62b514d376d4$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4Iuzv.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $fe9e62b514d376d4$export$fa996778a3a31087() {
    let state = $fe9e62b514d376d4$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $fe9e62b514d376d4$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fe9e62b514d376d4$var$savedScrollPositions = {};
function $fe9e62b514d376d4$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $fe9e62b514d376d4$var$stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $fe9e62b514d376d4$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $fe9e62b514d376d4$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $fe9e62b514d376d4$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $4Iuzv.useContext($fe9e62b514d376d4$export$3044ab7fdabeaee6);
    let location = $fe9e62b514d376d4$export$45d76561a5302f2b();
    let matches = $fe9e62b514d376d4$export$2378eb7f5ff86053();
    let navigation = $fe9e62b514d376d4$export$d0fd4b7106de2769();
    $4Iuzv.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $fe9e62b514d376d4$var$usePageHide($4Iuzv.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $fe9e62b514d376d4$var$getScrollRestorationKey(location, matches, basename, getKey);
            $fe9e62b514d376d4$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fe9e62b514d376d4$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fe9e62b514d376d4$var$savedScrollPositions));
        } catch (error) {
            $fe9e62b514d376d4$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $4Iuzv.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $fe9e62b514d376d4$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fe9e62b514d376d4$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $4Iuzv.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($fe9e62b514d376d4$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$fe9e62b514d376d4$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $4Iuzv.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $fe9e62b514d376d4$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $fe9e62b514d376d4$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $fe9e62b514d376d4$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $fe9e62b514d376d4$export$b273b3273281a049(when);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $fe9e62b514d376d4$export$e262bd1977bea848(to, opts = {}) {
    let vtContext = $4Iuzv.useContext($fe9e62b514d376d4$export$3681f408decb40d1);
    $fe9e62b514d376d4$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $fe9e62b514d376d4$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $fe9e62b514d376d4$export$e75d2a2d1b3c245b(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $fe9e62b514d376d4$var$stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $fe9e62b514d376d4$var$stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $fe9e62b514d376d4$export$81336c211d5ff295(path.pathname, nextPath) != null || $fe9e62b514d376d4$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $fe9e62b514d376d4$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $fe9e62b514d376d4$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $fe9e62b514d376d4$var$getStatelessNavigator();
    return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $fe9e62b514d376d4$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate = true, nonce: nonce }) {
    $fe9e62b514d376d4$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $fe9e62b514d376d4$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $fe9e62b514d376d4$var$serializeErrors(context.errors)
        };
        let json = $fe9e62b514d376d4$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $4Iuzv.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $fe9e62b514d376d4$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $fe9e62b514d376d4$var$useRoutesImpl(routes, void 0, state, future);
}
function $fe9e62b514d376d4$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($fe9e62b514d376d4$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $fe9e62b514d376d4$var$getStatelessNavigator() {
    return {
        createHref: $fe9e62b514d376d4$var$createHref,
        encodeLocation: $fe9e62b514d376d4$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $fe9e62b514d376d4$export$3336b097a6fbc59a(routes, opts) {
    return $fe9e62b514d376d4$var$createStaticHandler(routes, {
        ...opts,
        mapRouteProperties: $fe9e62b514d376d4$export$9269a41d8c4635e
    });
}
function $fe9e62b514d376d4$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $fe9e62b514d376d4$var$convertRoutesToDataRoutes(routes, $fe9e62b514d376d4$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $fe9e62b514d376d4$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $fe9e62b514d376d4$var$createHref,
        encodeLocation: $fe9e62b514d376d4$var$encodeLocation,
        getFetcher () {
            return $fe9e62b514d376d4$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $fe9e62b514d376d4$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $fe9e62b514d376d4$var$createHref(to) {
    return typeof to === "string" ? to : $fe9e62b514d376d4$export$fe53371bee54353d(to);
}
function $fe9e62b514d376d4$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $fe9e62b514d376d4$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $fe9e62b514d376d4$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $fe9e62b514d376d4$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $fe9e62b514d376d4$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $fe9e62b514d376d4$var$htmlEscape(str) {
    return str.replace($fe9e62b514d376d4$var$ESCAPE_REGEX2, (match)=>$fe9e62b514d376d4$var$ESCAPE_LOOKUP2[match]);
}
function $fe9e62b514d376d4$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = $fe9e62b514d376d4$var$createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && $fe9e62b514d376d4$export$6ac68922d4e92125(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = $fe9e62b514d376d4$export$3dd6171c30258b6f(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$208d6a3bc3aa62bd.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$32e57f52df4b6e34, {
        location: router.state.location
    }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$3d80f15952491985, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Suspense, null, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$var$StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $fe9e62b514d376d4$export$bea31554c7dfd2ad(routes, context = {}) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $4Iuzv.useRef();
        let remixContextRef = $4Iuzv.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                isSpaMode: false
            };
            let patched = $fe9e62b514d376d4$var$processRoutes(// @ts-expect-error loader/action context types don't match :/
            $fe9e62b514d376d4$var$convertRoutesToDataRoutes(routes, (r)=>r), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = $fe9e62b514d376d4$export$f30f7e456d254e83(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$208d6a3bc3aa62bd.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $4Iuzv.createElement($fe9e62b514d376d4$export$323e4fc2fa4753fb, {
            router: routerRef.current
        }));
    };
}
function $fe9e62b514d376d4$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let { loader: loader, action: action } = route;
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? (args)=>action({
                    ...args,
                    context: context
                }) : void 0,
            loader: loader ? (args)=>loader({
                    ...args,
                    context: context
                }) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            module: "build/stub-path-to-module.js"
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || $fe9e62b514d376d4$export$910ae8079b2c2852,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $fe9e62b514d376d4$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $fe9e62b514d376d4$var$encoder = new TextEncoder();
var $fe9e62b514d376d4$var$sign = async (value, secret)=>{
    let data2 = $fe9e62b514d376d4$var$encoder.encode(value);
    let key = await $fe9e62b514d376d4$var$createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $fe9e62b514d376d4$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $fe9e62b514d376d4$var$encoder.encode(value);
    let key = await $fe9e62b514d376d4$var$createKey2(secret, [
        "verify"
    ]);
    let signature = $fe9e62b514d376d4$var$byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var $fe9e62b514d376d4$var$createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", $fe9e62b514d376d4$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $fe9e62b514d376d4$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $fe9e62b514d376d4$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $fe9e62b514d376d4$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $37fe02520b3c1f2c$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $fe9e62b514d376d4$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $37fe02520b3c1f2c$exports.serialize)(name, value === "" ? "" : await $fe9e62b514d376d4$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $fe9e62b514d376d4$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $fe9e62b514d376d4$var$encodeCookieValue(value, secrets) {
    let encoded = $fe9e62b514d376d4$var$encodeData(value);
    if (secrets.length > 0) encoded = await $fe9e62b514d376d4$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $fe9e62b514d376d4$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $fe9e62b514d376d4$var$unsign(value, secret);
            if (unsignedValue !== false) return $fe9e62b514d376d4$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $fe9e62b514d376d4$var$decodeData(value);
}
function $fe9e62b514d376d4$var$encodeData(value) {
    return btoa($fe9e62b514d376d4$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $fe9e62b514d376d4$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($fe9e62b514d376d4$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $fe9e62b514d376d4$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $fe9e62b514d376d4$var$hex(code, 2);
            else result += "%u" + $fe9e62b514d376d4$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $fe9e62b514d376d4$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $fe9e62b514d376d4$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $fe9e62b514d376d4$var$warnOnceAboutExpiresCookie(name, expires) {
    $fe9e62b514d376d4$var$warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $fe9e62b514d376d4$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var $fe9e62b514d376d4$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($fe9e62b514d376d4$export$e7973f87fd96e4f2 || {});
function $fe9e62b514d376d4$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $fe9e62b514d376d4$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $fe9e62b514d376d4$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $fe9e62b514d376d4$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $fe9e62b514d376d4$var$serializeError(error, serverMode) {
    let sanitized = $fe9e62b514d376d4$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $fe9e62b514d376d4$var$serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($fe9e62b514d376d4$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $fe9e62b514d376d4$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $fe9e62b514d376d4$var$matchServerRoutes(routes, pathname, basename) {
    let matches = $fe9e62b514d376d4$export$2708184779ceb39d(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $fe9e62b514d376d4$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $fe9e62b514d376d4$var$stripRoutesParam($fe9e62b514d376d4$var$stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if ($fe9e62b514d376d4$var$isDataWithResponseInit(result) && result.init && result.init.status && $fe9e62b514d376d4$var$isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $fe9e62b514d376d4$var$stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $fe9e62b514d376d4$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $fe9e62b514d376d4$var$invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function $fe9e62b514d376d4$var$groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $fe9e62b514d376d4$var$createRoutes(manifest, parentId = "", routesByParentId = $fe9e62b514d376d4$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $fe9e62b514d376d4$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $fe9e62b514d376d4$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $fe9e62b514d376d4$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                if (args.request.headers.has("X-React-Router-Prerender-Data")) {
                    const preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $fe9e62b514d376d4$var$invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await $fe9e62b514d376d4$export$4023ad4ecd4126a2(stream, $parcel$global);
                    let data2 = decoded.value;
                    $fe9e62b514d376d4$var$invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                    let result = data2[route.id];
                    $fe9e62b514d376d4$var$invariant3("data" in result, "Unable to process prerendered data");
                    return result.data;
                }
                let val = await $fe9e62b514d376d4$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$fe9e62b514d376d4$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $fe9e62b514d376d4$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var $fe9e62b514d376d4$var$ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $fe9e62b514d376d4$var$ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function $fe9e62b514d376d4$var$escapeHtml2(html) {
    return html.replace($fe9e62b514d376d4$var$ESCAPE_REGEX3, (match)=>$fe9e62b514d376d4$var$ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function $fe9e62b514d376d4$var$createServerHandoffString(serverHandoff) {
    return $fe9e62b514d376d4$var$escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var $fe9e62b514d376d4$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $fe9e62b514d376d4$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$fe9e62b514d376d4$var$globalDevServerHooksKey] = devServerHooks;
}
function $fe9e62b514d376d4$var$getDevServerHooks() {
    return globalThis[$fe9e62b514d376d4$var$globalDevServerHooksKey];
}
function $fe9e62b514d376d4$var$getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let route = build.routes[id];
        $fe9e62b514d376d4$var$invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $fe9e62b514d376d4$var$prependCookies(errorHeaders, headers2);
            $fe9e62b514d376d4$var$prependCookies(actionHeaders, headers2);
            $fe9e62b514d376d4$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) $fe9e62b514d376d4$var$prependCookies(errorHeaders, headers);
        $fe9e62b514d376d4$var$prependCookies(actionHeaders, headers);
        $fe9e62b514d376d4$var$prependCookies(loaderHeaders, headers);
        $fe9e62b514d376d4$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function $fe9e62b514d376d4$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $35170a714e1598a5$exports.splitCookiesString)(parentSetCookieString);
        cookies.forEach((cookie)=>{
            childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $fe9e62b514d376d4$var$SINGLE_FETCH_REDIRECT_STATUS = 202;
function $fe9e62b514d376d4$var$getSingleFetchDataStrategy2({ isActionDataRequest: isActionDataRequest, loadRouteIds: loadRouteIds } = {}) {
    return async ({ request: request, matches: matches })=>{
        if (isActionDataRequest && request.method === "GET") return {};
        let matchesToLoad = loadRouteIds ? matches.filter((m)=>loadRouteIds.includes(m.route.id)) : matches;
        let results = await Promise.all(matchesToLoad.map((match)=>match.resolve()));
        return results.reduce((acc, result, i)=>Object.assign(acc, {
                [matchesToLoad[i].route.id]: result
            }), {});
    };
}
async function $fe9e62b514d376d4$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $fe9e62b514d376d4$var$getSingleFetchDataStrategy2({
                isActionDataRequest: true
            })
        });
        if ($fe9e62b514d376d4$var$isResponse(result)) return {
            result: $fe9e62b514d376d4$var$getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: $fe9e62b514d376d4$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $fe9e62b514d376d4$var$getDocumentHeaders(build, context);
        if ($fe9e62b514d376d4$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: $fe9e62b514d376d4$var$getSingleFetchRedirect(context.statusCode, headers, build.basename),
            headers: headers,
            status: $fe9e62b514d376d4$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$fe9e62b514d376d4$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $fe9e62b514d376d4$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        };
    }
}
async function $fe9e62b514d376d4$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let loadRouteIds = new URL(request.url).searchParams.get("_routes")?.split(",") || void 0;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $fe9e62b514d376d4$var$getSingleFetchDataStrategy2({
                loadRouteIds: loadRouteIds
            })
        });
        if ($fe9e62b514d376d4$var$isResponse(result)) return {
            result: {
                [$fe9e62b514d376d4$export$60644022b8b46aaa]: $fe9e62b514d376d4$var$getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: $fe9e62b514d376d4$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $fe9e62b514d376d4$var$getDocumentHeaders(build, context);
        if ($fe9e62b514d376d4$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: {
                [$fe9e62b514d376d4$export$60644022b8b46aaa]: $fe9e62b514d376d4$var$getSingleFetchRedirect(context.statusCode, headers, build.basename)
            },
            headers: headers,
            status: $fe9e62b514d376d4$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$fe9e62b514d376d4$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $fe9e62b514d376d4$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = loadRouteIds ? context.matches.filter((m)=>m.route.loader && loadRouteIds.includes(m.route.id)) : context.matches;
        loadedMatches.forEach((m)=>{
            let { id: id } = m.route;
            if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                error: context.errors[id]
            };
            else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                data: context.loaderData[id]
            };
        });
        return {
            result: results,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                root: {
                    error: error
                }
            },
            headers: new Headers(),
            status: 500
        };
    }
}
function $fe9e62b514d376d4$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = $fe9e62b514d376d4$var$stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $fe9e62b514d376d4$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $42195ed59b233082$exports.encode)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $fe9e62b514d376d4$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof $fe9e62b514d376d4$export$f2680fa305b734ca) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && $fe9e62b514d376d4$export$60644022b8b46aaa in value) return [
                    "SingleFetchRedirect",
                    value[$fe9e62b514d376d4$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $fe9e62b514d376d4$var$derive(build, mode) {
    let routes = $fe9e62b514d376d4$var$createRoutes(build.routes);
    let dataRoutes = $fe9e62b514d376d4$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $fe9e62b514d376d4$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = $fe9e62b514d376d4$var$createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        $fe9e62b514d376d4$export$972111febbeef05b(error) && error.error ? error.error : error);
    });
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var $fe9e62b514d376d4$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, loadContext = {}) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $fe9e62b514d376d4$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = $fe9e62b514d376d4$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let url = new URL(request.url);
        let params = {};
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $fe9e62b514d376d4$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        let manifestUrl = `${_build.basename ?? "/"}/__manifest`.replace(/\/+/g, "/");
        if (url.pathname === manifestUrl) try {
            let res = await $fe9e62b514d376d4$var$handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $fe9e62b514d376d4$var$matchServerRoutes(routes, url.pathname, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = handlerUrl.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
            let singleFetchMatches = $fe9e62b514d376d4$var$matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await $fe9e62b514d376d4$var$handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ($fe9e62b514d376d4$var$isRedirectResponse(response)) {
                    let result = $fe9e62b514d376d4$var$getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [$fe9e62b514d376d4$export$60644022b8b46aaa]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response($fe9e62b514d376d4$var$encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: $fe9e62b514d376d4$var$SINGLE_FETCH_REDIRECT_STATUS,
                        headers: headers
                    });
                }
            }
        } else if (matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $fe9e62b514d376d4$var$handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let criticalCss = mode === "development" /* Development */  ? await $fe9e62b514d376d4$var$getDevServerHooks()?.getCriticalCss?.(_build, url.pathname) : void 0;
            response = await $fe9e62b514d376d4$var$handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function $fe9e62b514d376d4$var$handleManifestRequest(build, routes, url) {
    let patches = {};
    if (url.searchParams.has("p")) {
        for (let path of url.searchParams.getAll("p")){
            let matches = $fe9e62b514d376d4$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $fe9e62b514d376d4$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let { result: result, headers: headers, status: status } = request.method !== "GET" ? await $fe9e62b514d376d4$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $fe9e62b514d376d4$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if (status === 304) return new Response(null, {
        status: 304,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response($fe9e62b514d376d4$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
async function $fe9e62b514d376d4$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    let context;
    try {
        context = await staticHandler.query(request, {
            requestContext: loadContext
        });
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    if ($fe9e62b514d376d4$var$isResponse(context)) return context;
    let headers = $fe9e62b514d376d4$var$getDocumentHeaders(build, context);
    if (context.statusCode === 304) return new Response(null, {
        status: 304,
        headers: headers
    });
    if (context.errors) {
        Object.values(context.errors).forEach((err)=>{
            if (!$fe9e62b514d376d4$export$972111febbeef05b(err) || err.error) handleError(err);
        });
        context.errors = $fe9e62b514d376d4$var$sanitizeErrors(context.errors, serverMode);
    }
    let state = {
        loaderData: context.loaderData,
        actionData: context.actionData,
        errors: $fe9e62b514d376d4$var$serializeErrors2(context.errors, serverMode)
    };
    let entryContext = {
        manifest: build.assets,
        routeModules: $fe9e62b514d376d4$var$createEntryRouteModules(build.routes),
        staticHandlerContext: context,
        criticalCss: criticalCss,
        serverHandoffString: $fe9e62b514d376d4$var$createServerHandoffString({
            basename: build.basename,
            criticalCss: criticalCss,
            future: build.future,
            isSpaMode: build.isSpaMode
        }),
        serverHandoffStream: $fe9e62b514d376d4$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
        renderMeta: {},
        future: build.future,
        isSpaMode: build.isSpaMode,
        serializeError: (err)=>$fe9e62b514d376d4$var$serializeError(err, serverMode)
    };
    let handleDocumentRequestFunction = build.entry.module.default;
    try {
        return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
    } catch (error) {
        handleError(error);
        let errorForSecondRender = error;
        if ($fe9e62b514d376d4$var$isResponse(error)) try {
            let data2 = await $fe9e62b514d376d4$var$unwrapResponse(error);
            errorForSecondRender = new $fe9e62b514d376d4$export$f2680fa305b734ca(error.status, error.statusText, data2);
        } catch (e) {}
        context = $fe9e62b514d376d4$var$getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
        if (context.errors) context.errors = $fe9e62b514d376d4$var$sanitizeErrors(context.errors, serverMode);
        let state2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $fe9e62b514d376d4$var$serializeErrors2(context.errors, serverMode)
        };
        entryContext = {
            ...entryContext,
            staticHandlerContext: context,
            serverHandoffString: $fe9e62b514d376d4$var$createServerHandoffString({
                basename: build.basename,
                future: build.future,
                isSpaMode: build.isSpaMode
            }),
            serverHandoffStream: $fe9e62b514d376d4$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {}
        };
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error2) {
            handleError(error2);
            return $fe9e62b514d376d4$var$returnLastResortErrorResponse(error2, serverMode);
        }
    }
}
async function $fe9e62b514d376d4$var$handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext
        });
        $fe9e62b514d376d4$var$invariant3($fe9e62b514d376d4$var$isResponse(response), "Expected a Response to be returned from resource route handler");
        return response;
    } catch (error) {
        if ($fe9e62b514d376d4$var$isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if ($fe9e62b514d376d4$export$972111febbeef05b(error)) {
            if (error) handleError(error);
            return $fe9e62b514d376d4$var$errorResponseToJson(error, serverMode);
        }
        handleError(error);
        return $fe9e62b514d376d4$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $fe9e62b514d376d4$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($fe9e62b514d376d4$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function $fe9e62b514d376d4$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $fe9e62b514d376d4$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $fe9e62b514d376d4$var$flash(name) {
    return `__flash_${name}__`;
}
var $fe9e62b514d376d4$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($fe9e62b514d376d4$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $fe9e62b514d376d4$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($fe9e62b514d376d4$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $fe9e62b514d376d4$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $fe9e62b514d376d4$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $fe9e62b514d376d4$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $fe9e62b514d376d4$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $fe9e62b514d376d4$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $fe9e62b514d376d4$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $fe9e62b514d376d4$var$warnOnceAboutSigningSessionCookie(cookie) {
    $fe9e62b514d376d4$var$warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $fe9e62b514d376d4$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $fe9e62b514d376d4$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $fe9e62b514d376d4$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $fe9e62b514d376d4$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $fe9e62b514d376d4$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $fe9e62b514d376d4$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $fe9e62b514d376d4$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/dom/ssr/errors.ts
function $fe9e62b514d376d4$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $fe9e62b514d376d4$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}



var $4Iuzv = parcelRequire("4Iuzv");
const $e3dee1ed6350a35d$var$useOnlineStatus = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $4Iuzv.useState)(true);
    (0, $4Iuzv.useEffect)(()=>{
        window.addEventListener("offline", ()=>{
            setOnlineStatus(false);
        });
        window.addEventListener("online", ()=>{
            setOnlineStatus(true);
        });
    }, []);
    //boolean value
    return onlineStatus;
};
var $e3dee1ed6350a35d$export$2e2bcd8739ae039 = $e3dee1ed6350a35d$var$useOnlineStatus;



var $4Iuzv = parcelRequire("4Iuzv");
const $4a71cd73bab5fc14$var$UserContext = /*#__PURE__*/ (0, $4Iuzv.createContext)({
    loggedInUser: "Default User"
});
var $4a71cd73bab5fc14$export$2e2bcd8739ae039 = $4a71cd73bab5fc14$var$UserContext;



var $4Iuzv = parcelRequire("4Iuzv");
var $10715d3f0d22f08b$exports = {};
'use strict';

$10715d3f0d22f08b$exports = (parcelRequire("9PTeM"));


var $25d342665550a083$var$__defProp = Object.defineProperty;
var $25d342665550a083$var$__defProps = Object.defineProperties;
var $25d342665550a083$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $25d342665550a083$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $25d342665550a083$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $25d342665550a083$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $25d342665550a083$var$__defNormalProp = (obj, key, value)=>key in obj ? $25d342665550a083$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $25d342665550a083$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($25d342665550a083$var$__hasOwnProp.call(b, prop)) $25d342665550a083$var$__defNormalProp(a, prop, b[prop]);
    if ($25d342665550a083$var$__getOwnPropSymbols) {
        for (var prop of $25d342665550a083$var$__getOwnPropSymbols(b))if ($25d342665550a083$var$__propIsEnum.call(b, prop)) $25d342665550a083$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $25d342665550a083$var$__spreadProps = (a, b)=>$25d342665550a083$var$__defProps(a, $25d342665550a083$var$__getOwnPropDescs(b));
var $25d342665550a083$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($25d342665550a083$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $25d342665550a083$var$__getOwnPropSymbols) {
        for (var prop of $25d342665550a083$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $25d342665550a083$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $25d342665550a083$var$IS_REACT_19 = /* @__PURE__ */ $4Iuzv.version.startsWith("19");
var $25d342665550a083$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($25d342665550a083$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $25d342665550a083$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $25d342665550a083$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $25d342665550a083$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $25d342665550a083$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $25d342665550a083$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $25d342665550a083$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $25d342665550a083$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $25d342665550a083$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $25d342665550a083$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $25d342665550a083$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $25d342665550a083$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $25d342665550a083$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $25d342665550a083$var$ForwardRef = $25d342665550a083$var$REACT_FORWARD_REF_TYPE;
var $25d342665550a083$var$Memo = $25d342665550a083$var$REACT_MEMO_TYPE;
function $25d342665550a083$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $25d342665550a083$var$REACT_FRAGMENT_TYPE || type === $25d342665550a083$var$REACT_PROFILER_TYPE || type === $25d342665550a083$var$REACT_STRICT_MODE_TYPE || type === $25d342665550a083$var$REACT_SUSPENSE_TYPE || type === $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE || type === $25d342665550a083$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $25d342665550a083$var$REACT_LAZY_TYPE || type.$$typeof === $25d342665550a083$var$REACT_MEMO_TYPE || type.$$typeof === $25d342665550a083$var$REACT_CONTEXT_TYPE || type.$$typeof === $25d342665550a083$var$REACT_CONSUMER_TYPE || type.$$typeof === $25d342665550a083$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $25d342665550a083$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $25d342665550a083$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $25d342665550a083$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $25d342665550a083$var$REACT_FRAGMENT_TYPE:
                    case $25d342665550a083$var$REACT_PROFILER_TYPE:
                    case $25d342665550a083$var$REACT_STRICT_MODE_TYPE:
                    case $25d342665550a083$var$REACT_SUSPENSE_TYPE:
                    case $25d342665550a083$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $25d342665550a083$var$REACT_CONTEXT_TYPE:
                            case $25d342665550a083$var$REACT_FORWARD_REF_TYPE:
                            case $25d342665550a083$var$REACT_LAZY_TYPE:
                            case $25d342665550a083$var$REACT_MEMO_TYPE:
                                return object;
                            case $25d342665550a083$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $25d342665550a083$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $25d342665550a083$var$isContextConsumer(object) {
    return $25d342665550a083$var$IS_REACT_19 ? $25d342665550a083$var$typeOf(object) === $25d342665550a083$var$REACT_CONSUMER_TYPE : $25d342665550a083$var$typeOf(object) === $25d342665550a083$var$REACT_CONTEXT_TYPE;
}
function $25d342665550a083$var$isMemo(object) {
    return $25d342665550a083$var$typeOf(object) === $25d342665550a083$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $25d342665550a083$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $25d342665550a083$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $25d342665550a083$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $25d342665550a083$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $25d342665550a083$var$verify(mapStateToProps, "mapStateToProps");
    $25d342665550a083$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $25d342665550a083$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $25d342665550a083$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $25d342665550a083$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $25d342665550a083$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $25d342665550a083$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $25d342665550a083$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $25d342665550a083$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $25d342665550a083$var$verifyPlainObject(value, displayName, methodName) {
    if (!$25d342665550a083$var$isPlainObject(value)) $25d342665550a083$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $25d342665550a083$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $25d342665550a083$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $25d342665550a083$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $25d342665550a083$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $25d342665550a083$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $25d342665550a083$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $25d342665550a083$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $25d342665550a083$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $25d342665550a083$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $25d342665550a083$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $25d342665550a083$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $25d342665550a083$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $25d342665550a083$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $25d342665550a083$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $25d342665550a083$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $25d342665550a083$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $25d342665550a083$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $25d342665550a083$var$__spreadValues($25d342665550a083$var$__spreadValues($25d342665550a083$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $25d342665550a083$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $25d342665550a083$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$25d342665550a083$var$defaultMergeProps : typeof mergeProps === "function" ? $25d342665550a083$var$wrapMergePropsFunc(mergeProps) : $25d342665550a083$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $25d342665550a083$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $25d342665550a083$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $25d342665550a083$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $25d342665550a083$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $25d342665550a083$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $25d342665550a083$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $25d342665550a083$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $25d342665550a083$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $25d342665550a083$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $25d342665550a083$var$isDOM = /* @__PURE__ */ $25d342665550a083$var$canUseDOM();
var $25d342665550a083$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $25d342665550a083$var$isReactNative = /* @__PURE__ */ $25d342665550a083$var$isRunningInReactNative();
var $25d342665550a083$var$getUseIsomorphicLayoutEffect = ()=>$25d342665550a083$var$isDOM || $25d342665550a083$var$isReactNative ? $4Iuzv.useLayoutEffect : $4Iuzv.useEffect;
var $25d342665550a083$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $25d342665550a083$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $25d342665550a083$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $25d342665550a083$export$d36bdfa510afb180(objA, objB) {
    if ($25d342665550a083$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$25d342665550a083$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $25d342665550a083$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $25d342665550a083$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $25d342665550a083$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $25d342665550a083$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $25d342665550a083$var$TYPE_STATICS = {
    [$25d342665550a083$var$ForwardRef]: $25d342665550a083$var$FORWARD_REF_STATICS,
    [$25d342665550a083$var$Memo]: $25d342665550a083$var$MEMO_STATICS
};
function $25d342665550a083$var$getStatics(component) {
    if ($25d342665550a083$var$isMemo(component)) return $25d342665550a083$var$MEMO_STATICS;
    return $25d342665550a083$var$TYPE_STATICS[component["$$typeof"]] || $25d342665550a083$var$REACT_STATICS;
}
var $25d342665550a083$var$defineProperty = Object.defineProperty;
var $25d342665550a083$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $25d342665550a083$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $25d342665550a083$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $25d342665550a083$var$getPrototypeOf = Object.getPrototypeOf;
var $25d342665550a083$var$objectPrototype = Object.prototype;
function $25d342665550a083$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($25d342665550a083$var$objectPrototype) {
            const inheritedComponent = $25d342665550a083$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $25d342665550a083$var$objectPrototype) $25d342665550a083$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $25d342665550a083$var$getOwnPropertyNames(sourceComponent);
        if ($25d342665550a083$var$getOwnPropertySymbols) keys = keys.concat($25d342665550a083$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $25d342665550a083$var$getStatics(targetComponent);
        const sourceStatics = $25d342665550a083$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$25d342665550a083$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $25d342665550a083$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $25d342665550a083$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $25d342665550a083$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $25d342665550a083$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $25d342665550a083$var$getContext() {
    var _a;
    if (!$4Iuzv.createContext) return {};
    const contextMap = (_a = $25d342665550a083$var$gT[$25d342665550a083$var$ContextKey]) != null ? _a : $25d342665550a083$var$gT[$25d342665550a083$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($4Iuzv.createContext);
    if (!realContext) {
        realContext = $4Iuzv.createContext(null);
        contextMap.set($4Iuzv.createContext, realContext);
    }
    return realContext;
}
var $25d342665550a083$export$cc80c08dc91f1c00 = /* @__PURE__ */ $25d342665550a083$var$getContext();
// src/components/connect.tsx
var $25d342665550a083$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $25d342665550a083$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $25d342665550a083$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $25d342665550a083$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $25d342665550a083$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $25d342665550a083$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $25d342665550a083$var$strictEqual(a, b) {
    return a === b;
}
var $25d342665550a083$var$hasWarnedAboutDeprecatedPureOption = false;
function $25d342665550a083$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $25d342665550a083$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $25d342665550a083$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $25d342665550a083$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $25d342665550a083$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $25d342665550a083$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $25d342665550a083$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $25d342665550a083$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $25d342665550a083$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $4Iuzv.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $25d342665550a083$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $4Iuzv.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $4Iuzv.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $4Iuzv.useMemo(()=>{
                return $25d342665550a083$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $4Iuzv.useMemo(()=>{
                if (!shouldHandleStateChanges) return $25d342665550a083$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $25d342665550a083$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $4Iuzv.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $4Iuzv.useRef(void 0);
            const lastWrapperProps = $4Iuzv.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $4Iuzv.useRef(void 0);
            const renderIsScheduled = $4Iuzv.useRef(false);
            const isMounted = $4Iuzv.useRef(false);
            const latestSubscriptionCallbackError = $4Iuzv.useRef(void 0);
            $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $4Iuzv.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $4Iuzv.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $25d342665550a083$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $25d342665550a083$var$useIsomorphicLayoutEffectWithArgs($25d342665550a083$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $4Iuzv.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $4Iuzv.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $4Iuzv.createElement(WrappedComponent, $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $4Iuzv.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $4Iuzv.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $4Iuzv.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $4Iuzv.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $4Iuzv.createElement(Connect, $25d342665550a083$var$__spreadProps($25d342665550a083$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $25d342665550a083$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $25d342665550a083$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $25d342665550a083$export$64605811ab45167f = $25d342665550a083$var$connect;
// src/components/Provider.tsx
function $25d342665550a083$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $4Iuzv.useMemo(()=>{
        const subscription = $25d342665550a083$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $4Iuzv.useMemo(()=>store.getState(), [
        store
    ]);
    $25d342665550a083$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $25d342665550a083$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $4Iuzv.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $25d342665550a083$export$2881499e37b75b9a = $25d342665550a083$var$Provider;
// src/hooks/useReduxContext.ts
function $25d342665550a083$var$createReduxContextHook(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $4Iuzv.useContext(context);
        return contextValue;
    };
}
var $25d342665550a083$var$useReduxContext = /* @__PURE__ */ $25d342665550a083$var$createReduxContextHook();
// src/hooks/useStore.ts
function $25d342665550a083$export$671dba69185d0304(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$var$useReduxContext : // @ts-ignore
    $25d342665550a083$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $25d342665550a083$export$6ccbb43953eebf8 = /* @__PURE__ */ $25d342665550a083$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $25d342665550a083$export$bc9b55530897c558(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useStore2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$export$6ccbb43953eebf8 : $25d342665550a083$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $25d342665550a083$export$8ad76b76a4c905f8 = /* @__PURE__ */ $25d342665550a083$export$bc9b55530897c558();
var $25d342665550a083$var$refEquality = (a, b)=>a === b;
function $25d342665550a083$export$2b53f90d2bd1cbfb(context = $25d342665550a083$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $25d342665550a083$export$cc80c08dc91f1c00 ? $25d342665550a083$var$useReduxContext : $25d342665550a083$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $25d342665550a083$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $4Iuzv.useRef(true);
        const wrappedSelector = $4Iuzv.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $10715d3f0d22f08b$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $4Iuzv.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $25d342665550a083$export$2105062e25df4afe = /* @__PURE__ */ $25d342665550a083$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $25d342665550a083$export$712ea50be43a7858 = $25d342665550a083$var$defaultNoopBatch;


const $ca2c91bf6756c02e$var$Header = ()=>{
    // let btnName = "Login"; //we are trying with HTML
    //useState variable
    const [btnNameReact, setBtnNameReact] = (0, $4Iuzv.useState)("Login");
    //We have created a global data inside the UserContext and thus for using that
    //we are using a hook below and passing UserContext data.    
    const data = (0, $4Iuzv.useContext)((0, $4a71cd73bab5fc14$export$2e2bcd8739ae039));
    //Subscribing to the store using a selector
    const cartItems = (0, $25d342665550a083$export$2105062e25df4afe)((store)=>store.cart.items);
    const onlinestatus = (0, $e3dee1ed6350a35d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "flex justify-between items-center bg-white shadow-md py-4 px-6 sticky  top-0 z-50",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                    className: "w-32 hover:scale-105 transition-transform duration-300",
                    src: (0, $1449da937569f1f7$export$8878ead86ed0da0b)
                })
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "flex items-center space-x-6 text-lg text-gray-700",
                children: /*#__PURE__*/ (0, $5aRSq.jsxs)("ul", {
                    className: "flex p-4 m-4",
                    children: [
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("li", {
                            className: "px-2",
                            children: [
                                "Online Status : ",
                                onlinestatus ? "\uD83D\uDFE2" : "\uD83D\uDE21"
                            ]
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fe9e62b514d376d4$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fe9e62b514d376d4$export$a6c7ac8248d6e38a), {
                                to: "/About",
                                children: "About Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fe9e62b514d376d4$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                children: "Contact Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fe9e62b514d376d4$export$a6c7ac8248d6e38a), {
                                to: "/Grocery",
                                children: "Grocery"
                            })
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                            className: "px-2 hover:text-blue-500 transition-colors duration-300",
                            children: /*#__PURE__*/ (0, $5aRSq.jsxs)((0, $fe9e62b514d376d4$export$a6c7ac8248d6e38a), {
                                to: "/Cart",
                                children: [
                                    "Cart (",
                                    cartItems.length,
                                    " items)"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                            className: "flex items-center space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                    className: "login bg-blue-500 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-600 transition-colors duration-300",
                                    onClick: ()=>{
                                        btnNameReact === "Login" ? setBtnNameReact("Logout") : setBtnNameReact("Login");
                                    },
                                    children: btnNameReact
                                }),
                                /*#__PURE__*/ (0, $5aRSq.jsx)("li", {
                                    className: "px-2 text-gray-600 font-semibold",
                                    children: data.loggedInUser
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $ca2c91bf6756c02e$export$2e2bcd8739ae039 = $ca2c91bf6756c02e$var$Header;



var $5aRSq = parcelRequire("5aRSq");

var $5aRSq = parcelRequire("5aRSq");

const $80d248f504e512cb$var$RestaurantCard = (props)=>{
    const { resData: resData } = props; //destructuring the props (props is react) and destructuring is js
    const { name: name, cuisines: cuisines, avgRatingString: avgRatingString, costForTwo: costForTwo, slaParshu: slaParshu = {} } = resData?.info;
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "res-card p-4 rounded-lg bg-white shadow-lg hover:shadow-xl transition duration-300 ease-in-out",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                className: "rounded-lg w-full h-36 object-cover",
                alt: "res-logo",
                src: (0, $1449da937569f1f7$export$31adfacaf07ffe63) + resData.info.cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h3", {
                className: "font-bold text-lg py-2",
                children: name
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h4", {
                className: "text-sm text-gray-600",
                children: cuisines.join(", ")
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("h4", {
                className: "text-sm text-green-600 font-semibold",
                children: [
                    avgRatingString,
                    " stars"
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h4", {
                className: "text-sm text-gray-800",
                children: costForTwo
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("h4", {
                className: "text-sm text-gray-600",
                children: [
                    slaParshu.deliveryTime,
                    " minutes"
                ]
            })
        ]
    });
};
const $80d248f504e512cb$export$ccb02a230af14023 = (RestaurantCard)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("label", {
                    className: "absolute top-0 left-0 bg-red-600 text-white text-xs font-bold m-2 p-1 rounded-md shadow-md",
                    children: "Promoted"
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)(RestaurantCard, {
                    ...props
                })
            ]
        });
    };
};
var $80d248f504e512cb$export$2e2bcd8739ae039 = $80d248f504e512cb$var$RestaurantCard;



var $4Iuzv = parcelRequire("4Iuzv");

var $5aRSq = parcelRequire("5aRSq");
const $eb3dc97cbfcc19b2$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "shimmer-container",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "shimmer-card",
                children: "Card"
            })
        ]
    });
};
var $eb3dc97cbfcc19b2$export$2e2bcd8739ae039 = $eb3dc97cbfcc19b2$var$Shimmer;





const $58044eda1763adcb$var$Body = ()=>{
    //Local State variable - Super Powerful variable
    const [listOfRestaurants, setListOfRestaurants] = (0, $4Iuzv.useState)([]);
    const [filteredRestaurant, setFilteredRestaurant] = (0, $4Iuzv.useState)([]);
    const [searchText, setSearchText] = (0, $4Iuzv.useState)("");
    const RestaurantCardPromoted = (0, $80d248f504e512cb$export$ccb02a230af14023)((0, $80d248f504e512cb$export$2e2bcd8739ae039));
    // console.log("render")
    //use Effect will take two arguments first one is a call back funciton and 
    //second one will be dependency array
    //callback fn will be called once the render cycle is finished
    (0, $4Iuzv.useEffect)(()=>{
        fetchData();
    }, []);
    //we are directly fetching the data form the swiggy API's 
    //Using edu cors
    const ApiKey = '4e7a00598aebdb3d';
    const EDUCORS_URL = 'https://educorssolver.host/api/getData';
    // Target URL from you want to fetch data m ,ex-github api
    const Target = 'https://foodfire.onrender.com/api/restaurants?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING';
    const fetchData = async ()=>{
        const data = await fetch(`${EDUCORS_URL}?ApiKey=${ApiKey}&Target=${encodeURIComponent(Target)}`);
        const json = await data.json();
        console.log(json);
        //Trying to implement this from chetananda and it worked Baby!..... and I implemented this funciton because everytime the cards[i]
        //value changes in the API.
        // initialize checkJsonData() function to check Swiggy Restaurant data
        function checkJsonData(jsonData) {
            // if (!jsonData?.data?.cards) return [];  new thing added watching the deepseek
            for(let i = 0; i < jsonData?.data?.cards.length; i++){
                // initialize checkData for Swiggy Restaurant data
                let checkData = json?.data?.cards[i]?.card?.card?.gridElements?.infoWithStyle?.restaurants;
                // if checkData is not undefined then return it
                if (checkData !== undefined) return checkData;
            }
            return [];
        }
        // call the checkJsonData() function which return Swiggy Restaurant data
        const resData = checkJsonData(json);
        //optional chaining == ?.(symbol)
        // setListOfRestaurants(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        // setFilteredRestaurant(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        setListOfRestaurants(resData);
        setFilteredRestaurant(resData);
    };
    // console.log(listOfRestaurants);
    const onlineStatus = (0, $e3dee1ed6350a35d$export$2e2bcd8739ae039)();
    if (onlineStatus == false) return /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
        children: "Looks like you are fucking offline, Are you stupid or something, Don't even know how to turn on your Internet!!"
    });
    //Conditional Rendering
    // if(listOfRestaurants.length == 0){
    //     return < Shimmer />;
    // }
    //Another way for the above conditional rendering is ternery operator
    const { setUserName: setUserName, loggedInUser: loggedInUser } = (0, $4Iuzv.useContext)((0, $4a71cd73bab5fc14$export$2e2bcd8739ae039));
    return listOfRestaurants.length == 0 ? /*#__PURE__*/ (0, $5aRSq.jsx)((0, $eb3dc97cbfcc19b2$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "body max-w-7xl mx-auto p-4",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "filter flex flex-wrap justify-between items-center mb-6 bg-gray-50 p-4 rounded-lg shadow-md",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "search flex items-center bg-white border border-gray-300 rounded-full shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                                type: "text",
                                className: "px-4 py-2 w-64 rounded-l-full focus:outline-none",
                                value: searchText,
                                onChange: (e)=>setSearchText(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                                onClick: ()=>{
                                    //filter the restaurant cards and update the UI
                                    //searchText
                                    // console.log(searchText);
                                    const filteredRestaurant = listOfRestaurants.filter((res)=>res.info.name.toLowerCase().includes(searchText.toLowerCase()));
                                    setFilteredRestaurant(filteredRestaurant);
                                },
                                className: "bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-r-full transition duration-300",
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                            className: "px-6 py-2 bg-green-600 text-white rounded-lg shadow-md hover:bg-green-700 transition duration-300",
                            onClick: ()=>{
                                const filteredList = listOfRestaurants.filter((res)=>parseFloat(res.info.avgRating) >= 4.5);
                                setFilteredRestaurant(filteredList);
                                console.log("Button clicked");
                            },
                            children: "Top Rated Restaurants"
                        })
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "search flex items-center space-x-2",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("label", {
                                className: "font-semibold",
                                children: "Username : "
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("input", {
                                className: "border border-gray-300 p-2 rounded-md focus:outline-blue-600",
                                value: loggedInUser,
                                onChange: (e)=>setUserName(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "res-container grid grid-cols-4 gap-6 p-4",
                children: filteredRestaurant.map((restaurant)=>/*#__PURE__*/ (0, $5aRSq.jsx)((0, $fe9e62b514d376d4$export$a6c7ac8248d6e38a), {
                        to: "/restaurants/" + restaurant.info.id,
                        className: "transform hover:scale-105 transition duration-300",
                        children: restaurant.info.veg ? /*#__PURE__*/ (0, $5aRSq.jsx)(RestaurantCardPromoted, {
                            resData: restaurant
                        }) : /*#__PURE__*/ (0, $5aRSq.jsx)((0, $80d248f504e512cb$export$2e2bcd8739ae039), {
                            resData: restaurant
                        })
                    }, restaurant.info.id))
            })
        ]
    });
};
var $58044eda1763adcb$export$2e2bcd8739ae039 = $58044eda1763adcb$var$Body;



var $5aRSq = parcelRequire("5aRSq");

var $5aRSq = parcelRequire("5aRSq");

var $4Iuzv = parcelRequire("4Iuzv");
class $4a43ebff0e2881d0$var$UserClass extends (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Component {
    constructor(props){
        super(props);
        this.state = {
            userInfo: {
                name: "Dummy",
                location: "Default"
            }
        };
        console.log(this.props.name + "Child Constructor");
    }
    async componentDidMount() {
        //console.log(this.props.name + "Child Component Did Mount");
        //API call
        const data = await fetch("https://api.github.com/users/ParshuShah");
        const json = await data.json();
        this.setState({
            userInfo: json
        });
        console.log(json);
    }
    componentDidUpdate() {
        console.log("Component Did Update");
    }
    render() {
        const { login: login, type: type, avatar_url: avatar_url } = this.state.userInfo;
        return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
            className: "user-card",
            children: [
                /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                    src: avatar_url
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("h2", {
                    children: [
                        "Name: ",
                        login
                    ]
                }),
                /*#__PURE__*/ (0, $5aRSq.jsxs)("h3", {
                    children: [
                        "Type: ",
                        type
                    ]
                }),
                /*#__PURE__*/ (0, $5aRSq.jsx)("h4", {
                    children: "Contact: @ParshuShah"
                })
            ]
        });
    }
}
var $4a43ebff0e2881d0$export$2e2bcd8739ae039 = $4a43ebff0e2881d0$var$UserClass;



var $4Iuzv = parcelRequire("4Iuzv");

class $2982f87537b17e94$var$About extends (0, $4Iuzv.Component) {
    constructor(props){
        super(props);
    //console.log("Parent Constructor");
    }
    componentDidMount() {
    // console.log("Parent Component Did Mount");
    }
    render() {
        return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
            className: "min-h-screen flex flex-col items-center justify-center bg-gray-100 text-gray-800",
            children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "bg-white shadow-lg rounded-lg p-8 w-10/12 md:w-8/12 lg:w-6/12",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "mb-4 text-center",
                        children: [
                            " ",
                            "loggedInUser : ",
                            /*#__PURE__*/ (0, $5aRSq.jsx)((0, $4a71cd73bab5fc14$export$2e2bcd8739ae039).Consumer, {
                                children: ({ loggedInUser: loggedInUser })=>/*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                                        className: "text-2xl font-bold text-blue-600",
                                        children: loggedInUser
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                        className: "text-3xl font-bold mb-2 text-gray-800",
                        children: "About Class Component"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("h2", {
                        className: "text-lg text-gray-600 mb-4",
                        children: "This is Swiggy PROTOTYPE MADE by Parshuram!!!"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "border-t-2 border-gray-200 mt-4 pt-4",
                        children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $4a43ebff0e2881d0$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        });
    }
}
var $2982f87537b17e94$export$2e2bcd8739ae039 = $2982f87537b17e94$var$About;



var $5aRSq = parcelRequire("5aRSq");
const $a7056d12e4b6a8a4$var$Contact = ()=>{
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        children: /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
            children: "This is a Contact us Page"
        })
    });
};
var $a7056d12e4b6a8a4$export$2e2bcd8739ae039 = $a7056d12e4b6a8a4$var$Contact;



var $5aRSq = parcelRequire("5aRSq");

const $7e935ac5b2f1db10$var$Error = ()=>{
    const err = (0, $fe9e62b514d376d4$export$ed527bf60f6e05f2)();
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "flex flex-col items-center justify-center min-h-screen bg-gray-100",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                className: "text-6xl font-bold text-red-500 mb-4",
                children: "Oops!"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("h2", {
                className: "text-2xl font-semibold text-gray-800 mb-2",
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("h3", {
                className: "text-lg text-gray-600",
                children: [
                    err.status,
                    " : ",
                    err.statusText
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fe9e62b514d376d4$export$a6c7ac8248d6e38a), {
                to: "/",
                children: /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                    className: "mt-6 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700",
                    children: "Go Back Home"
                })
            })
        ]
    });
};
var $7e935ac5b2f1db10$export$2e2bcd8739ae039 = $7e935ac5b2f1db10$var$Error;



var $5aRSq = parcelRequire("5aRSq");



var $4Iuzv = parcelRequire("4Iuzv");

const $6a9db8a30167c416$var$useRestaurantMenu = (resId)=>{
    const [resInfo, setResInfo] = (0, $4Iuzv.useState)(null);
    (0, $4Iuzv.useEffect)(()=>{
        fetchData();
    }, []);
    //Using edu cors
    const ApiKey = '4e7a00598aebdb3d';
    const EDUCORS_URL = 'https://educorssolver.host/api/getData';
    // Target URL from you want to fetch data m ,ex-github api
    const Target = (0, $1449da937569f1f7$export$b77c1aa4fb57bd1c) + resId;
    const fetchData = async ()=>{
        const data = await fetch(`${EDUCORS_URL}?ApiKey=${ApiKey}&Target=${encodeURIComponent(Target)}`);
        const json = await data.json();
        setResInfo(json.data);
    };
    return resInfo;
};
var $6a9db8a30167c416$export$2e2bcd8739ae039 = $6a9db8a30167c416$var$useRestaurantMenu;



var $5aRSq = parcelRequire("5aRSq");
parcelRequire("4Iuzv");

var $5aRSq = parcelRequire("5aRSq");


// src/utils/formatProdErrorMessage.ts
function $b0c9b171c350de9c$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $b0c9b171c350de9c$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $b0c9b171c350de9c$var$symbol_observable_default = $b0c9b171c350de9c$var$$$observable;
// src/utils/actionTypes.ts
var $b0c9b171c350de9c$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $b0c9b171c350de9c$var$ActionTypes = {
    INIT: `@@redux/INIT${$b0c9b171c350de9c$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$b0c9b171c350de9c$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$b0c9b171c350de9c$var$randomString()}`
};
var $b0c9b171c350de9c$export$4219e499db7ca678 = $b0c9b171c350de9c$var$ActionTypes;
// src/utils/isPlainObject.ts
function $b0c9b171c350de9c$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $b0c9b171c350de9c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($b0c9b171c350de9c$var$isDate(val)) return "date";
    if ($b0c9b171c350de9c$var$isError(val)) return "error";
    const constructorName = $b0c9b171c350de9c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $b0c9b171c350de9c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $b0c9b171c350de9c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $b0c9b171c350de9c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $b0c9b171c350de9c$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $b0c9b171c350de9c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(1));
        return enhancer($b0c9b171c350de9c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$b0c9b171c350de9c$export$53b83ca8eaab0383(action)) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $b0c9b171c350de9c$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$b0c9b171c350de9c$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $b0c9b171c350de9c$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$b0c9b171c350de9c$var$symbol_observable_default]: observable
    };
    return store;
}
function $b0c9b171c350de9c$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $b0c9b171c350de9c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $b0c9b171c350de9c$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $b0c9b171c350de9c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $b0c9b171c350de9c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$b0c9b171c350de9c$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$b0c9b171c350de9c$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $b0c9b171c350de9c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $b0c9b171c350de9c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $b0c9b171c350de9c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $b0c9b171c350de9c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(13));
    });
}
function $b0c9b171c350de9c$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $b0c9b171c350de9c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $b0c9b171c350de9c$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $b0c9b171c350de9c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $b0c9b171c350de9c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $b0c9b171c350de9c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $b0c9b171c350de9c$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $b0c9b171c350de9c$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($b0c9b171c350de9c$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $b0c9b171c350de9c$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $b0c9b171c350de9c$export$b956e38827fca970(action) {
    return $b0c9b171c350de9c$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $7e93f60b48cb9fdf$var$__defProp = Object.defineProperty;
var $7e93f60b48cb9fdf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7e93f60b48cb9fdf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7e93f60b48cb9fdf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7e93f60b48cb9fdf$var$__defNormalProp = (obj, key, value)=>key in obj ? $7e93f60b48cb9fdf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7e93f60b48cb9fdf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7e93f60b48cb9fdf$var$__hasOwnProp.call(b, prop)) $7e93f60b48cb9fdf$var$__defNormalProp(a, prop, b[prop]);
    if ($7e93f60b48cb9fdf$var$__getOwnPropSymbols) {
        for (var prop of $7e93f60b48cb9fdf$var$__getOwnPropSymbols(b))if ($7e93f60b48cb9fdf$var$__propIsEnum.call(b, prop)) $7e93f60b48cb9fdf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $7e93f60b48cb9fdf$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7e93f60b48cb9fdf$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7e93f60b48cb9fdf$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7e93f60b48cb9fdf$var$errors = [];
function $7e93f60b48cb9fdf$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7e93f60b48cb9fdf$var$getPrototypeOf = Object.getPrototypeOf;
function $7e93f60b48cb9fdf$export$541ac630993a4c84(value) {
    return !!value && !!value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
}
function $7e93f60b48cb9fdf$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $7e93f60b48cb9fdf$var$isPlainObject(value) || Array.isArray(value) || !!value[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee]) || $7e93f60b48cb9fdf$var$isMap(value) || $7e93f60b48cb9fdf$var$isSet(value);
}
var $7e93f60b48cb9fdf$var$objectCtorString = Object.prototype.constructor.toString();
function $7e93f60b48cb9fdf$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $7e93f60b48cb9fdf$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $7e93f60b48cb9fdf$var$objectCtorString;
}
function $7e93f60b48cb9fdf$export$22e8af3f75a010e3(value) {
    if (!$7e93f60b48cb9fdf$export$541ac630993a4c84(value)) $7e93f60b48cb9fdf$var$die(15, value);
    return value[$7e93f60b48cb9fdf$var$DRAFT_STATE].base_;
}
function $7e93f60b48cb9fdf$var$each(obj, iter) {
    if ($7e93f60b48cb9fdf$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7e93f60b48cb9fdf$var$getArchtype(thing) {
    const state = thing[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $7e93f60b48cb9fdf$var$isMap(thing) ? 2 /* Map */  : $7e93f60b48cb9fdf$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $7e93f60b48cb9fdf$var$has(thing, prop) {
    return $7e93f60b48cb9fdf$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $7e93f60b48cb9fdf$var$get(thing, prop) {
    return $7e93f60b48cb9fdf$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $7e93f60b48cb9fdf$var$set(thing, propOrOldValue, value) {
    const t = $7e93f60b48cb9fdf$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $7e93f60b48cb9fdf$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7e93f60b48cb9fdf$var$isMap(target) {
    return target instanceof Map;
}
function $7e93f60b48cb9fdf$var$isSet(target) {
    return target instanceof Set;
}
function $7e93f60b48cb9fdf$var$latest(state) {
    return state.copy_ || state.base_;
}
function $7e93f60b48cb9fdf$var$shallowCopy(base, strict) {
    if ($7e93f60b48cb9fdf$var$isMap(base)) return new Map(base);
    if ($7e93f60b48cb9fdf$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $7e93f60b48cb9fdf$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$7e93f60b48cb9fdf$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($7e93f60b48cb9fdf$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7e93f60b48cb9fdf$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $7e93f60b48cb9fdf$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $7e93f60b48cb9fdf$export$792f3d81ea979f55(obj, deep = false) {
    if ($7e93f60b48cb9fdf$var$isFrozen(obj) || $7e93f60b48cb9fdf$export$541ac630993a4c84(obj) || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(obj)) return obj;
    if ($7e93f60b48cb9fdf$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $7e93f60b48cb9fdf$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$7e93f60b48cb9fdf$export$792f3d81ea979f55(value, true));
    return obj;
}
function $7e93f60b48cb9fdf$var$dontMutateFrozenCollections() {
    $7e93f60b48cb9fdf$var$die(2);
}
function $7e93f60b48cb9fdf$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $7e93f60b48cb9fdf$var$plugins = {};
function $7e93f60b48cb9fdf$var$getPlugin(pluginKey) {
    const plugin = $7e93f60b48cb9fdf$var$plugins[pluginKey];
    if (!plugin) $7e93f60b48cb9fdf$var$die(0, pluginKey);
    return plugin;
}
function $7e93f60b48cb9fdf$var$loadPlugin(pluginKey, implementation) {
    if (!$7e93f60b48cb9fdf$var$plugins[pluginKey]) $7e93f60b48cb9fdf$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7e93f60b48cb9fdf$var$currentScope;
function $7e93f60b48cb9fdf$var$getCurrentScope() {
    return $7e93f60b48cb9fdf$var$currentScope;
}
function $7e93f60b48cb9fdf$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $7e93f60b48cb9fdf$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7e93f60b48cb9fdf$var$revokeScope(scope) {
    $7e93f60b48cb9fdf$var$leaveScope(scope);
    scope.drafts_.forEach($7e93f60b48cb9fdf$var$revokeDraft);
    scope.drafts_ = null;
}
function $7e93f60b48cb9fdf$var$leaveScope(scope) {
    if (scope === $7e93f60b48cb9fdf$var$currentScope) $7e93f60b48cb9fdf$var$currentScope = scope.parent_;
}
function $7e93f60b48cb9fdf$var$enterScope(immer2) {
    return $7e93f60b48cb9fdf$var$currentScope = $7e93f60b48cb9fdf$var$createScope($7e93f60b48cb9fdf$var$currentScope, immer2);
}
function $7e93f60b48cb9fdf$var$revokeDraft(draft) {
    const state = draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7e93f60b48cb9fdf$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7e93f60b48cb9fdf$var$DRAFT_STATE].modified_) {
            $7e93f60b48cb9fdf$var$revokeScope(scope);
            $7e93f60b48cb9fdf$var$die(4);
        }
        if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(result)) {
            result = $7e93f60b48cb9fdf$var$finalize(scope, result);
            if (!scope.parent_) $7e93f60b48cb9fdf$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $7e93f60b48cb9fdf$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$7e93f60b48cb9fdf$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $7e93f60b48cb9fdf$var$finalize(scope, baseDraft, []);
    $7e93f60b48cb9fdf$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7e93f60b48cb9fdf$export$45b790e32b2810ee ? result : void 0;
}
function $7e93f60b48cb9fdf$var$finalize(rootScope, value, path) {
    if ($7e93f60b48cb9fdf$var$isFrozen(value)) return value;
    const state = value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    if (!state) {
        $7e93f60b48cb9fdf$var$each(value, (key, childValue)=>$7e93f60b48cb9fdf$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $7e93f60b48cb9fdf$var$each(resultEach, (key, childValue)=>$7e93f60b48cb9fdf$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $7e93f60b48cb9fdf$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $7e93f60b48cb9fdf$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($7e93f60b48cb9fdf$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$7e93f60b48cb9fdf$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $7e93f60b48cb9fdf$var$finalize(rootScope, childValue, path);
        $7e93f60b48cb9fdf$var$set(targetObject, prop, res);
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(childValue) && !$7e93f60b48cb9fdf$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $7e93f60b48cb9fdf$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $7e93f60b48cb9fdf$var$maybeFreeze(rootScope, childValue);
    }
}
function $7e93f60b48cb9fdf$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7e93f60b48cb9fdf$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $7e93f60b48cb9fdf$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $7e93f60b48cb9fdf$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $7e93f60b48cb9fdf$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $7e93f60b48cb9fdf$var$objectTraps = {
    get (state, prop) {
        if (prop === $7e93f60b48cb9fdf$var$DRAFT_STATE) return state;
        const source = $7e93f60b48cb9fdf$var$latest(state);
        if (!$7e93f60b48cb9fdf$var$has(source, prop)) return $7e93f60b48cb9fdf$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) return value;
        if (value === $7e93f60b48cb9fdf$var$peek(state.base_, prop)) {
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            return state.copy_[prop] = $7e93f60b48cb9fdf$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $7e93f60b48cb9fdf$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7e93f60b48cb9fdf$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7e93f60b48cb9fdf$var$getDescriptorFromProto($7e93f60b48cb9fdf$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7e93f60b48cb9fdf$var$peek($7e93f60b48cb9fdf$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($7e93f60b48cb9fdf$var$is(value, current2) && (value !== void 0 || $7e93f60b48cb9fdf$var$has(state.base_, prop))) return true;
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($7e93f60b48cb9fdf$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $7e93f60b48cb9fdf$var$prepareCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7e93f60b48cb9fdf$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $7e93f60b48cb9fdf$var$die(11);
    },
    getPrototypeOf (state) {
        return $7e93f60b48cb9fdf$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7e93f60b48cb9fdf$var$die(12);
    }
};
var $7e93f60b48cb9fdf$var$arrayTraps = {};
$7e93f60b48cb9fdf$var$each($7e93f60b48cb9fdf$var$objectTraps, (key, fn)=>{
    $7e93f60b48cb9fdf$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$7e93f60b48cb9fdf$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7e93f60b48cb9fdf$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7e93f60b48cb9fdf$var$arrayTraps.set = function(state, prop, value) {
    return $7e93f60b48cb9fdf$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7e93f60b48cb9fdf$var$peek(draft, prop) {
    const state = draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    const source = state ? $7e93f60b48cb9fdf$var$latest(state) : draft;
    return source[prop];
}
function $7e93f60b48cb9fdf$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $7e93f60b48cb9fdf$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $7e93f60b48cb9fdf$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7e93f60b48cb9fdf$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7e93f60b48cb9fdf$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7e93f60b48cb9fdf$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7e93f60b48cb9fdf$var$markChanged(state.parent_);
    }
}
function $7e93f60b48cb9fdf$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $7e93f60b48cb9fdf$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $7e93f60b48cb9fdf$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $7e93f60b48cb9fdf$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $7e93f60b48cb9fdf$var$die(7);
            let result;
            if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(base)) {
                const scope = $7e93f60b48cb9fdf$var$enterScope(this);
                const proxy = $7e93f60b48cb9fdf$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7e93f60b48cb9fdf$var$revokeScope(scope);
                    else $7e93f60b48cb9fdf$var$leaveScope(scope);
                }
                $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener);
                return $7e93f60b48cb9fdf$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7e93f60b48cb9fdf$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7e93f60b48cb9fdf$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7e93f60b48cb9fdf$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $7e93f60b48cb9fdf$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(base)) $7e93f60b48cb9fdf$var$die(8);
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(base)) base = $7e93f60b48cb9fdf$export$97aac956da55dae9(base);
        const scope = $7e93f60b48cb9fdf$var$enterScope(this);
        const proxy = $7e93f60b48cb9fdf$var$createProxy(base, void 0);
        proxy[$7e93f60b48cb9fdf$var$DRAFT_STATE].isManual_ = true;
        $7e93f60b48cb9fdf$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7e93f60b48cb9fdf$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7e93f60b48cb9fdf$var$die(9);
        const { scope_: scope } = state;
        $7e93f60b48cb9fdf$var$usePatchesInScope(scope, patchListener);
        return $7e93f60b48cb9fdf$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7e93f60b48cb9fdf$var$getPlugin("Patches").applyPatches_;
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $7e93f60b48cb9fdf$var$createProxy(value, parent) {
    const draft = $7e93f60b48cb9fdf$var$isMap(value) ? $7e93f60b48cb9fdf$var$getPlugin("MapSet").proxyMap_(value, parent) : $7e93f60b48cb9fdf$var$isSet(value) ? $7e93f60b48cb9fdf$var$getPlugin("MapSet").proxySet_(value, parent) : $7e93f60b48cb9fdf$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $7e93f60b48cb9fdf$export$97aac956da55dae9(value) {
    if (!$7e93f60b48cb9fdf$export$541ac630993a4c84(value)) $7e93f60b48cb9fdf$var$die(10, value);
    return $7e93f60b48cb9fdf$var$currentImpl(value);
}
function $7e93f60b48cb9fdf$var$currentImpl(value) {
    if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(value) || $7e93f60b48cb9fdf$var$isFrozen(value)) return value;
    const state = value[$7e93f60b48cb9fdf$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7e93f60b48cb9fdf$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $7e93f60b48cb9fdf$var$shallowCopy(value, true);
    $7e93f60b48cb9fdf$var$each(copy, (key, childValue)=>{
        $7e93f60b48cb9fdf$var$set(copy, key, $7e93f60b48cb9fdf$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7e93f60b48cb9fdf$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $7e93f60b48cb9fdf$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7e93f60b48cb9fdf$var$get(base_, key);
            const value = $7e93f60b48cb9fdf$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $7e93f60b48cb9fdf$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $7e93f60b48cb9fdf$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7e93f60b48cb9fdf$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $7e93f60b48cb9fdf$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $7e93f60b48cb9fdf$var$die(errorOffset + 3);
                base = $7e93f60b48cb9fdf$var$get(base, p);
                if (typeof base !== "object") $7e93f60b48cb9fdf$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7e93f60b48cb9fdf$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7e93f60b48cb9fdf$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7e93f60b48cb9fdf$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7e93f60b48cb9fdf$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7e93f60b48cb9fdf$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7e93f60b48cb9fdf$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7e93f60b48cb9fdf$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7e93f60b48cb9fdf$var$has(obj, $7e93f60b48cb9fdf$export$6ee2082928bcb0ee)) cloned[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee] = obj[$7e93f60b48cb9fdf$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7e93f60b48cb9fdf$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7e93f60b48cb9fdf$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $7e93f60b48cb9fdf$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$7e93f60b48cb9fdf$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7e93f60b48cb9fdf$var$latest(state).has(key) || $7e93f60b48cb9fdf$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7e93f60b48cb9fdf$var$latest(state).size) {
                prepareMapCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7e93f60b48cb9fdf$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            $7e93f60b48cb9fdf$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7e93f60b48cb9fdf$var$latest(state).get(key);
            if (state.finalized_ || !$7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7e93f60b48cb9fdf$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7e93f60b48cb9fdf$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$7e93f60b48cb9fdf$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7e93f60b48cb9fdf$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $7e93f60b48cb9fdf$var$latest(this[$7e93f60b48cb9fdf$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7e93f60b48cb9fdf$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7e93f60b48cb9fdf$var$latest(state).size) {
                prepareSetCopy(state);
                $7e93f60b48cb9fdf$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7e93f60b48cb9fdf$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7e93f60b48cb9fdf$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7e93f60b48cb9fdf$export$16e3aed3edb85946(value)) {
                    const draft = $7e93f60b48cb9fdf$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7e93f60b48cb9fdf$var$die(3, JSON.stringify($7e93f60b48cb9fdf$var$latest(state)));
    }
    $7e93f60b48cb9fdf$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $7e93f60b48cb9fdf$var$immer = new $7e93f60b48cb9fdf$export$aaadc6ff0f822719();
var $7e93f60b48cb9fdf$export$b46cabe22e78bc00 = $7e93f60b48cb9fdf$var$immer.produce;
var $7e93f60b48cb9fdf$export$4da66d41c9492c78 = $7e93f60b48cb9fdf$var$immer.produceWithPatches.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$573f26f60825c493 = $7e93f60b48cb9fdf$var$immer.setAutoFreeze.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$333ce65961cbe047 = $7e93f60b48cb9fdf$var$immer.setUseStrictShallowCopy.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$a8b8e03e6bbe5473 = $7e93f60b48cb9fdf$var$immer.applyPatches.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$3c3214997190395f = $7e93f60b48cb9fdf$var$immer.createDraft.bind($7e93f60b48cb9fdf$var$immer);
var $7e93f60b48cb9fdf$export$c60f5e69c521b528 = $7e93f60b48cb9fdf$var$immer.finishDraft.bind($7e93f60b48cb9fdf$var$immer);
function $7e93f60b48cb9fdf$export$c05b21e3257751e5(value) {
    return value;
}
function $7e93f60b48cb9fdf$export$20f911b3f8cf0b74(value) {
    return value;
}


var $be917d30338e5bfc$var$__defProp = Object.defineProperty;
var $be917d30338e5bfc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $be917d30338e5bfc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $be917d30338e5bfc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $be917d30338e5bfc$var$__defNormalProp = (obj, key, value)=>key in obj ? $be917d30338e5bfc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $be917d30338e5bfc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($be917d30338e5bfc$var$__hasOwnProp.call(b, prop)) $be917d30338e5bfc$var$__defNormalProp(a, prop, b[prop]);
    if ($be917d30338e5bfc$var$__getOwnPropSymbols) {
        for (var prop of $be917d30338e5bfc$var$__getOwnPropSymbols(b))if ($be917d30338e5bfc$var$__propIsEnum.call(b, prop)) $be917d30338e5bfc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $be917d30338e5bfc$var$__publicField = (obj, key, value)=>{
    $be917d30338e5bfc$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $be917d30338e5bfc$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $be917d30338e5bfc$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $be917d30338e5bfc$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $be917d30338e5bfc$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($be917d30338e5bfc$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $be917d30338e5bfc$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $be917d30338e5bfc$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $be917d30338e5bfc$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $be917d30338e5bfc$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $be917d30338e5bfc$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $be917d30338e5bfc$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $be917d30338e5bfc$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $be917d30338e5bfc$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $be917d30338e5bfc$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $be917d30338e5bfc$var$__spreadValues($be917d30338e5bfc$var$__spreadValues({}, $be917d30338e5bfc$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $be917d30338e5bfc$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $be917d30338e5bfc$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $be917d30338e5bfc$var$$REVISION = 0;
var $be917d30338e5bfc$var$CURRENT_TRACKER = null;
var $be917d30338e5bfc$var$Cell = class {
    constructor(initialValue, isEqual = $be917d30338e5bfc$var$tripleEq){
        $be917d30338e5bfc$var$__publicField(this, "revision", $be917d30338e5bfc$var$$REVISION);
        $be917d30338e5bfc$var$__publicField(this, "_value");
        $be917d30338e5bfc$var$__publicField(this, "_lastValue");
        $be917d30338e5bfc$var$__publicField(this, "_isEqual", $be917d30338e5bfc$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $be917d30338e5bfc$var$CURRENT_TRACKER == null || $be917d30338e5bfc$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$be917d30338e5bfc$var$$REVISION;
    }
};
function $be917d30338e5bfc$var$tripleEq(a, b) {
    return a === b;
}
var $be917d30338e5bfc$var$TrackingCache = class {
    constructor(fn){
        $be917d30338e5bfc$var$__publicField(this, "_cachedValue");
        $be917d30338e5bfc$var$__publicField(this, "_cachedRevision", -1);
        $be917d30338e5bfc$var$__publicField(this, "_deps", []);
        $be917d30338e5bfc$var$__publicField(this, "hits", 0);
        $be917d30338e5bfc$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $be917d30338e5bfc$var$CURRENT_TRACKER;
            $be917d30338e5bfc$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $be917d30338e5bfc$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $be917d30338e5bfc$var$CURRENT_TRACKER == null || $be917d30338e5bfc$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $be917d30338e5bfc$var$getValue(cell) {
    if (!(cell instanceof $be917d30338e5bfc$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $be917d30338e5bfc$var$setValue(storage, value) {
    if (!(storage instanceof $be917d30338e5bfc$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $be917d30338e5bfc$var$createCell(initialValue, isEqual = $be917d30338e5bfc$var$tripleEq) {
    return new $be917d30338e5bfc$var$Cell(initialValue, isEqual);
}
function $be917d30338e5bfc$var$createCache(fn) {
    $be917d30338e5bfc$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $be917d30338e5bfc$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $be917d30338e5bfc$var$neverEq = (a, b)=>false;
function $be917d30338e5bfc$var$createTag() {
    return $be917d30338e5bfc$var$createCell(null, $be917d30338e5bfc$var$neverEq);
}
function $be917d30338e5bfc$var$dirtyTag(tag, value) {
    $be917d30338e5bfc$var$setValue(tag, value);
}
var $be917d30338e5bfc$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $be917d30338e5bfc$var$createTag();
    $be917d30338e5bfc$var$getValue(tag);
};
var $be917d30338e5bfc$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $be917d30338e5bfc$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $be917d30338e5bfc$var$REDUX_PROXY_LABEL = Symbol();
var $be917d30338e5bfc$var$nextId = 0;
var $be917d30338e5bfc$var$proto = Object.getPrototypeOf({});
var $be917d30338e5bfc$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $be917d30338e5bfc$var$__publicField(this, "proxy", new Proxy(this, $be917d30338e5bfc$var$objectProxyHandler));
        $be917d30338e5bfc$var$__publicField(this, "tag", $be917d30338e5bfc$var$createTag());
        $be917d30338e5bfc$var$__publicField(this, "tags", {});
        $be917d30338e5bfc$var$__publicField(this, "children", {});
        $be917d30338e5bfc$var$__publicField(this, "collectionTag", null);
        $be917d30338e5bfc$var$__publicField(this, "id", $be917d30338e5bfc$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $be917d30338e5bfc$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $be917d30338e5bfc$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $be917d30338e5bfc$var$createNode(childValue);
                if (childNode.tag) $be917d30338e5bfc$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $be917d30338e5bfc$var$createTag();
                    tag.value = childValue;
                }
                $be917d30338e5bfc$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $be917d30338e5bfc$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $be917d30338e5bfc$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $be917d30338e5bfc$var$__publicField(this, "proxy", new Proxy([
            this
        ], $be917d30338e5bfc$var$arrayProxyHandler));
        $be917d30338e5bfc$var$__publicField(this, "tag", $be917d30338e5bfc$var$createTag());
        $be917d30338e5bfc$var$__publicField(this, "tags", {});
        $be917d30338e5bfc$var$__publicField(this, "children", {});
        $be917d30338e5bfc$var$__publicField(this, "collectionTag", null);
        $be917d30338e5bfc$var$__publicField(this, "id", $be917d30338e5bfc$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $be917d30338e5bfc$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $be917d30338e5bfc$var$consumeCollection(node);
        return $be917d30338e5bfc$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $be917d30338e5bfc$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $be917d30338e5bfc$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $be917d30338e5bfc$var$objectProxyHandler.has(node, prop);
    }
};
function $be917d30338e5bfc$var$createNode(value) {
    if (Array.isArray(value)) return new $be917d30338e5bfc$var$ArrayTreeNode(value);
    return new $be917d30338e5bfc$var$ObjectTreeNode(value);
}
function $be917d30338e5bfc$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $be917d30338e5bfc$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $be917d30338e5bfc$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $be917d30338e5bfc$var$dirtyCollection(node);
            $be917d30338e5bfc$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $be917d30338e5bfc$var$updateNode(childNode, newChildValue);
        else {
            $be917d30338e5bfc$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $be917d30338e5bfc$var$deleteNode(node) {
    if (node.tag) $be917d30338e5bfc$var$dirtyTag(node.tag, null);
    $be917d30338e5bfc$var$dirtyCollection(node);
    for(const key in node.tags)$be917d30338e5bfc$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$be917d30338e5bfc$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $be917d30338e5bfc$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $be917d30338e5bfc$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $be917d30338e5bfc$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $be917d30338e5bfc$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $be917d30338e5bfc$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $be917d30338e5bfc$export$3f025202a230c6dd = (a, b)=>a === b;
function $be917d30338e5bfc$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $be917d30338e5bfc$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $be917d30338e5bfc$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $be917d30338e5bfc$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $be917d30338e5bfc$var$createSingletonCache(comparator) : $be917d30338e5bfc$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $be917d30338e5bfc$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $be917d30338e5bfc$export$c8f9cf88d9fdee55(func) {
    const node = $be917d30338e5bfc$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $be917d30338e5bfc$var$createCacheKeyComparator($be917d30338e5bfc$export$3f025202a230c6dd);
    const cache = $be917d30338e5bfc$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $be917d30338e5bfc$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $be917d30338e5bfc$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $be917d30338e5bfc$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $be917d30338e5bfc$var$StrongRef;
var $be917d30338e5bfc$var$UNTERMINATED = 0;
var $be917d30338e5bfc$var$TERMINATED = 1;
function $be917d30338e5bfc$var$createCacheNode() {
    return {
        s: $be917d30338e5bfc$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $be917d30338e5bfc$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $be917d30338e5bfc$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $be917d30338e5bfc$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $be917d30338e5bfc$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $be917d30338e5bfc$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $be917d30338e5bfc$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $be917d30338e5bfc$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $be917d30338e5bfc$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $be917d30338e5bfc$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $be917d30338e5bfc$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $be917d30338e5bfc$var$__spreadValues($be917d30338e5bfc$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $be917d30338e5bfc$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $be917d30338e5bfc$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $be917d30338e5bfc$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $be917d30338e5bfc$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $be917d30338e5bfc$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $be917d30338e5bfc$export$595d22ed68ca2841 = /* @__PURE__ */ $be917d30338e5bfc$export$5943f4447f6ef248($be917d30338e5bfc$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $be917d30338e5bfc$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $be917d30338e5bfc$export$595d22ed68ca2841)=>{
    $be917d30338e5bfc$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$be917d30338e5bfc$export$75979cfcd91bf38f
});


// src/index.ts
function $b9d54142851513e7$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $b9d54142851513e7$export$dd164f5517779f15 = $b9d54142851513e7$var$createThunkMiddleware();
var $b9d54142851513e7$export$16d06542a1949d9e = $b9d54142851513e7$var$createThunkMiddleware;



var $7q8YY = parcelRequire("7q8YY");
var $0005262392d89a41$var$__defProp = Object.defineProperty;
var $0005262392d89a41$var$__defProps = Object.defineProperties;
var $0005262392d89a41$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0005262392d89a41$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0005262392d89a41$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0005262392d89a41$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0005262392d89a41$var$__defNormalProp = (obj, key, value)=>key in obj ? $0005262392d89a41$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0005262392d89a41$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0005262392d89a41$var$__hasOwnProp.call(b, prop)) $0005262392d89a41$var$__defNormalProp(a, prop, b[prop]);
    if ($0005262392d89a41$var$__getOwnPropSymbols) {
        for (var prop of $0005262392d89a41$var$__getOwnPropSymbols(b))if ($0005262392d89a41$var$__propIsEnum.call(b, prop)) $0005262392d89a41$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0005262392d89a41$var$__spreadProps = (a, b)=>$0005262392d89a41$var$__defProps(a, $0005262392d89a41$var$__getOwnPropDescs(b));
var $0005262392d89a41$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0005262392d89a41$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0005262392d89a41$var$__getOwnPropSymbols) {
        for (var prop of $0005262392d89a41$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0005262392d89a41$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $0005262392d89a41$var$__publicField = (obj, key, value)=>$0005262392d89a41$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $0005262392d89a41$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $be917d30338e5bfc$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(value) ? (0, $7e93f60b48cb9fdf$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $0005262392d89a41$export$a5d3c27355e35910 = /* @__PURE__ */ $0005262392d89a41$export$aab6de9e3dbb1473((0, $be917d30338e5bfc$export$8402dc26d96f6902));
var $0005262392d89a41$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $b0c9b171c350de9c$export$f672e0b6f7222cd7;
    return (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $0005262392d89a41$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $0005262392d89a41$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $0005262392d89a41$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($0005262392d89a41$export$378fa86b259c0280(0));
            return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $b0c9b171c350de9c$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $0005262392d89a41$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $0005262392d89a41$var$hasMatchFunction(action);
}
function $0005262392d89a41$export$ebd532f9034651f3(action) {
    return (0, $b0c9b171c350de9c$export$b956e38827fca970)(action) && Object.keys(action).every($0005262392d89a41$var$isValidKey);
}
function $0005262392d89a41$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $0005262392d89a41$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $0005262392d89a41$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $0005262392d89a41$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $0005262392d89a41$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $0005262392d89a41$var$freezeDraftable(val) {
    return (0, $7e93f60b48cb9fdf$export$16e3aed3edb85946)(val) ? (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $0005262392d89a41$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $0005262392d89a41$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $0005262392d89a41$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $0005262392d89a41$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $0005262392d89a41$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $0005262392d89a41$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $0005262392d89a41$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $0005262392d89a41$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $0005262392d89a41$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $b0c9b171c350de9c$export$53b83ca8eaab0383)(val);
}
function $0005262392d89a41$export$ada5dca0b571bc7(value, path = "", isSerializable = $0005262392d89a41$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $0005262392d89a41$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $0005262392d89a41$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $0005262392d89a41$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$0005262392d89a41$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $0005262392d89a41$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $0005262392d89a41$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $0005262392d89a41$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $0005262392d89a41$export$1908877435b1d5e9();
        if (thunk) {
            if ($0005262392d89a41$var$isBoolean(thunk)) middlewareArray.push((0, $b9d54142851513e7$export$dd164f5517779f15));
            else middlewareArray.push((0, $b9d54142851513e7$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $0005262392d89a41$export$8fb31c0f05df007b = "RTK_autoBatch";
var $0005262392d89a41$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$0005262392d89a41$export$8fb31c0f05df007b]: true
            }
        });
var $0005262392d89a41$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $0005262392d89a41$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $0005262392d89a41$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $0005262392d89a41$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$0005262392d89a41$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $0005262392d89a41$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $0005262392d89a41$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($0005262392d89a41$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $0005262392d89a41$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $0005262392d89a41$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $b0c9b171c350de9c$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $b0c9b171c350de9c$export$66e4520cdb265d18)(reducer);
    else throw new Error($0005262392d89a41$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $0005262392d89a41$var$composeWithDevTools($0005262392d89a41$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $b0c9b171c350de9c$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $0005262392d89a41$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $b0c9b171c350de9c$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $0005262392d89a41$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($0005262392d89a41$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($0005262392d89a41$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $0005262392d89a41$var$isStateFunction(x) {
    return typeof x === "function";
}
function $0005262392d89a41$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $0005262392d89a41$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($0005262392d89a41$var$isStateFunction(initialState)) getInitialState = ()=>$0005262392d89a41$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $0005262392d89a41$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7e93f60b48cb9fdf$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $0005262392d89a41$var$matches = (matcher, action)=>{
    if ($0005262392d89a41$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $0005262392d89a41$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$0005262392d89a41$var$matches(matcher, action));
    };
}
function $0005262392d89a41$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$0005262392d89a41$var$matches(matcher, action));
    };
}
function $0005262392d89a41$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $0005262392d89a41$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $0005262392d89a41$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$872dec21e9a69476()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $0005262392d89a41$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $0005262392d89a41$export$9dd1fb32974da385($0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$fcc3388fb56de601()(asyncThunks[0]);
    return $0005262392d89a41$export$9dd1fb32974da385($0005262392d89a41$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $0005262392d89a41$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$1da80a6ef1307441()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $0005262392d89a41$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$0005262392d89a41$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$0005262392d89a41$var$isAsyncThunkArray(asyncThunks)) return $0005262392d89a41$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $0005262392d89a41$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $0005262392d89a41$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $0005262392d89a41$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $0005262392d89a41$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $0005262392d89a41$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $0005262392d89a41$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $0005262392d89a41$var$__publicField(this, "_type");
    }
};
var $0005262392d89a41$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $0005262392d89a41$var$__publicField(this, "_type");
    }
};
var $0005262392d89a41$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $0005262392d89a41$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $0005262392d89a41$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $0005262392d89a41$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $0005262392d89a41$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $0005262392d89a41$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($0005262392d89a41$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $0005262392d89a41$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $0005262392d89a41$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $0005262392d89a41$var$RejectWithValue) throw result;
                                if (result instanceof $0005262392d89a41$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $0005262392d89a41$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($0005262392d89a41$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $0005262392d89a41$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $0005262392d89a41$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $0005262392d89a41$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $0005262392d89a41$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $0005262392d89a41$export$343355ed40c51c46 = {
    [$0005262392d89a41$var$asyncThunkSymbol]: $0005262392d89a41$export$6abd22dc03e5063f
};
var $0005262392d89a41$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($0005262392d89a41$export$23a094319a4b586 || {});
function $0005262392d89a41$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $0005262392d89a41$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$0005262392d89a41$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($0005262392d89a41$export$378fa86b259c0280(11));
        typeof $7q8YY;
        const reducers = (typeof options.reducers === "function" ? options.reducers($0005262392d89a41$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($0005262392d89a41$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($0005262392d89a41$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $0005262392d89a41$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($0005262392d89a41$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $0005262392d89a41$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $0005262392d89a41$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $0005262392d89a41$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $0005262392d89a41$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $0005262392d89a41$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $0005262392d89a41$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $0005262392d89a41$var$wrapSelector(selector, selectState, getInitialState, injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $0005262392d89a41$var$__spreadProps($0005262392d89a41$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $0005262392d89a41$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $0005262392d89a41$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $0005262392d89a41$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $0005262392d89a41$export$affdea4146de9cf5();
function $0005262392d89a41$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $0005262392d89a41$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $0005262392d89a41$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$0005262392d89a41$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($0005262392d89a41$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $0005262392d89a41$export$309c7a02b0b0bc62(type, prepareCallback) : $0005262392d89a41$export$309c7a02b0b0bc62(type));
}
function $0005262392d89a41$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $0005262392d89a41$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $0005262392d89a41$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($0005262392d89a41$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $0005262392d89a41$var$noop,
        pending: pending || $0005262392d89a41$var$noop,
        rejected: rejected || $0005262392d89a41$var$noop,
        settled: settled || $0005262392d89a41$var$noop
    });
}
function $0005262392d89a41$var$noop() {}
// src/entities/entity_state.ts
function $0005262392d89a41$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $0005262392d89a41$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($0005262392d89a41$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $0005262392d89a41$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $0005262392d89a41$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $0005262392d89a41$var$isDraftTyped = (0, $7e93f60b48cb9fdf$export$541ac630993a4c84);
function $0005262392d89a41$var$createSingleArgumentStateOperator(mutator) {
    const operator = $0005262392d89a41$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $0005262392d89a41$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $0005262392d89a41$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($0005262392d89a41$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $7e93f60b48cb9fdf$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $0005262392d89a41$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $0005262392d89a41$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $0005262392d89a41$var$getCurrent(value) {
    return (0, $7e93f60b48cb9fdf$export$541ac630993a4c84)(value) ? (0, $7e93f60b48cb9fdf$export$97aac956da55dae9)(value) : value;
}
function $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $0005262392d89a41$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $0005262392d89a41$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $0005262392d89a41$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $0005262392d89a41$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$0005262392d89a41$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $0005262392d89a41$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $0005262392d89a41$var$createStateOperator(addOneMutably),
        addMany: $0005262392d89a41$var$createStateOperator(addManyMutably),
        setOne: $0005262392d89a41$var$createStateOperator(setOneMutably),
        setMany: $0005262392d89a41$var$createStateOperator(setManyMutably),
        setAll: $0005262392d89a41$var$createStateOperator(setAllMutably),
        updateOne: $0005262392d89a41$var$createStateOperator(updateOneMutably),
        updateMany: $0005262392d89a41$var$createStateOperator(updateManyMutably),
        upsertOne: $0005262392d89a41$var$createStateOperator(upsertOneMutably),
        upsertMany: $0005262392d89a41$var$createStateOperator(upsertManyMutably),
        removeOne: $0005262392d89a41$var$createStateOperator(removeOneMutably),
        removeMany: $0005262392d89a41$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $0005262392d89a41$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $0005262392d89a41$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $0005262392d89a41$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $0005262392d89a41$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $0005262392d89a41$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $0005262392d89a41$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($0005262392d89a41$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $0005262392d89a41$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $0005262392d89a41$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $0005262392d89a41$var$getCurrent(state.entities);
        const currentIds = $0005262392d89a41$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $0005262392d89a41$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $0005262392d89a41$var$createStateOperator(addOneMutably),
        updateOne: $0005262392d89a41$var$createStateOperator(updateOneMutably),
        upsertOne: $0005262392d89a41$var$createStateOperator(upsertOneMutably),
        setOne: $0005262392d89a41$var$createStateOperator(setOneMutably),
        setMany: $0005262392d89a41$var$createStateOperator(setManyMutably),
        setAll: $0005262392d89a41$var$createStateOperator(setAllMutably),
        addMany: $0005262392d89a41$var$createStateOperator(addManyMutably),
        updateMany: $0005262392d89a41$var$createStateOperator(updateManyMutably),
        upsertMany: $0005262392d89a41$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $0005262392d89a41$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $0005262392d89a41$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $0005262392d89a41$var$createSortedStateAdapter(selectId, sortComparer) : $0005262392d89a41$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $0005262392d89a41$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $0005262392d89a41$var$createSelectorsFactory();
    return $0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues($0005262392d89a41$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $0005262392d89a41$var$task = "task";
var $0005262392d89a41$var$listener = "listener";
var $0005262392d89a41$var$completed = "completed";
var $0005262392d89a41$var$cancelled = "cancelled";
var $0005262392d89a41$var$taskCancelled = `task-${$0005262392d89a41$var$cancelled}`;
var $0005262392d89a41$var$taskCompleted = `task-${$0005262392d89a41$var$completed}`;
var $0005262392d89a41$var$listenerCancelled = `${$0005262392d89a41$var$listener}-${$0005262392d89a41$var$cancelled}`;
var $0005262392d89a41$var$listenerCompleted = `${$0005262392d89a41$var$listener}-${$0005262392d89a41$var$completed}`;
var $0005262392d89a41$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $0005262392d89a41$var$__publicField(this, "name", "TaskAbortError");
        $0005262392d89a41$var$__publicField(this, "message");
        this.message = `${$0005262392d89a41$var$task} ${$0005262392d89a41$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $0005262392d89a41$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($0005262392d89a41$export$378fa86b259c0280(32));
};
var $0005262392d89a41$var$noop2 = ()=>{};
var $0005262392d89a41$var$catchRejection = (promise, onError = $0005262392d89a41$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $0005262392d89a41$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $0005262392d89a41$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $0005262392d89a41$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $0005262392d89a41$export$cb1bdac908fed7f(reason);
    }
};
function $0005262392d89a41$var$raceWithSignal(signal, promise) {
    let cleanup = $0005262392d89a41$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $0005262392d89a41$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $0005262392d89a41$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $0005262392d89a41$var$noop2;
    });
}
var $0005262392d89a41$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $0005262392d89a41$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $0005262392d89a41$var$createPause = (signal)=>{
    return (promise)=>{
        return $0005262392d89a41$var$catchRejection($0005262392d89a41$var$raceWithSignal(signal, promise).then((output)=>{
            $0005262392d89a41$var$validateActive(signal);
            return output;
        }));
    };
};
var $0005262392d89a41$var$createDelay = (signal)=>{
    const pause = $0005262392d89a41$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $0005262392d89a41$var$assign } = Object;
var $0005262392d89a41$var$INTERNAL_NIL_TOKEN = {};
var $0005262392d89a41$var$alm = "listenerMiddleware";
var $0005262392d89a41$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$0005262392d89a41$var$addAbortSignalListener(parentAbortSignal, ()=>$0005262392d89a41$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $0005262392d89a41$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $0005262392d89a41$var$runTask(async ()=>{
            $0005262392d89a41$var$validateActive(parentAbortSignal);
            $0005262392d89a41$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $0005262392d89a41$var$createPause(childAbortController.signal),
                delay: $0005262392d89a41$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $0005262392d89a41$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$0005262392d89a41$var$abortControllerWithReason(childAbortController, $0005262392d89a41$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($0005262392d89a41$var$noop2));
        return {
            result: $0005262392d89a41$var$createPause(parentAbortSignal)(result),
            cancel () {
                $0005262392d89a41$var$abortControllerWithReason(childAbortController, $0005262392d89a41$var$taskCancelled);
            }
        };
    };
};
var $0005262392d89a41$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $0005262392d89a41$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $0005262392d89a41$var$raceWithSignal(signal, Promise.race(promises));
            $0005262392d89a41$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$0005262392d89a41$var$catchRejection(take(predicate, timeout));
};
var $0005262392d89a41$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $0005262392d89a41$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($0005262392d89a41$export$378fa86b259c0280(21));
    $0005262392d89a41$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $0005262392d89a41$var$createListenerEntry = /* @__PURE__ */ $0005262392d89a41$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $0005262392d89a41$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $0005262392d89a41$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($0005262392d89a41$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$0005262392d89a41$var$createListenerEntry
});
var $0005262392d89a41$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $0005262392d89a41$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $0005262392d89a41$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $0005262392d89a41$var$abortControllerWithReason(controller, $0005262392d89a41$var$listenerCancelled);
    });
};
var $0005262392d89a41$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($0005262392d89a41$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $0005262392d89a41$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $0005262392d89a41$export$f03a6b845d3fb58b = /* @__PURE__ */ $0005262392d89a41$var$assign(/* @__PURE__ */ $0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/add`), {
    withTypes: ()=>$0005262392d89a41$export$f03a6b845d3fb58b
});
var $0005262392d89a41$export$b1b8022855fb2b71 = /* @__PURE__ */ $0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/removeAll`);
var $0005262392d89a41$export$b03e9483f936dccb = /* @__PURE__ */ $0005262392d89a41$var$assign(/* @__PURE__ */ $0005262392d89a41$export$309c7a02b0b0bc62(`${$0005262392d89a41$var$alm}/remove`), {
    withTypes: ()=>$0005262392d89a41$export$b03e9483f936dccb
});
var $0005262392d89a41$var$defaultErrorHandler = (...args)=>{
    console.error(`${$0005262392d89a41$var$alm}/error`, ...args);
};
var $0005262392d89a41$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $0005262392d89a41$var$defaultErrorHandler } = middlewareOptions;
    $0005262392d89a41$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $0005262392d89a41$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $0005262392d89a41$var$findListenerEntry(listenerMap, options)) != null ? _a : $0005262392d89a41$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $0005262392d89a41$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $0005262392d89a41$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $0005262392d89a41$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $0005262392d89a41$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $0005262392d89a41$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $0005262392d89a41$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $0005262392d89a41$var$createDelay(internalTaskController.signal),
                pause: $0005262392d89a41$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $0005262392d89a41$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $0005262392d89a41$var$abortControllerWithReason(controller, $0005262392d89a41$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $0005262392d89a41$var$abortControllerWithReason(internalTaskController, $0005262392d89a41$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $0005262392d89a41$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $0005262392d89a41$export$cb1bdac908fed7f)) $0005262392d89a41$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $0005262392d89a41$var$abortControllerWithReason(internalTaskController, $0005262392d89a41$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $0005262392d89a41$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $b0c9b171c350de9c$export$b956e38827fca970)(action)) return next(action);
                if ($0005262392d89a41$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($0005262392d89a41$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($0005262392d89a41$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $0005262392d89a41$var$INTERNAL_NIL_TOKEN) throw new Error($0005262392d89a41$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $0005262392d89a41$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $0005262392d89a41$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $0005262392d89a41$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $0005262392d89a41$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $0005262392d89a41$export$4bb1606a79445586 = ()=>{
    const instanceId = $0005262392d89a41$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($0005262392d89a41$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $0005262392d89a41$var$getOrInsertComputed(middlewareMap, middleware2, $0005262392d89a41$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$0005262392d89a41$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $b0c9b171c350de9c$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $0005262392d89a41$export$9dd1fb32974da385(withMiddleware, $0005262392d89a41$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $0005262392d89a41$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $0005262392d89a41$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$0005262392d89a41$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $0005262392d89a41$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $0005262392d89a41$var$isStateProxy = (value)=>!!value && !!value[$0005262392d89a41$var$ORIGINAL_STATE];
var $0005262392d89a41$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $0005262392d89a41$var$createStateProxy = (state, reducerMap)=>$0005262392d89a41$var$getOrInsertComputed($0005262392d89a41$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $0005262392d89a41$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $0005262392d89a41$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($0005262392d89a41$export$378fa86b259c0280(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $0005262392d89a41$var$original = (state)=>{
    if (!$0005262392d89a41$var$isStateProxy(state)) throw new Error($0005262392d89a41$export$378fa86b259c0280(25));
    return state[$0005262392d89a41$var$ORIGINAL_STATE];
};
var $0005262392d89a41$var$noopReducer = (state = {})=>state;
function $0005262392d89a41$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($0005262392d89a41$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $b0c9b171c350de9c$export$66e4520cdb265d18)(reducerMap) : $0005262392d89a41$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $7q8YY;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($0005262392d89a41$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $0005262392d89a41$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $0005262392d89a41$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $f9ee2b4ae9fa584a$var$cartSlice = (0, $0005262392d89a41$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            //mutating the state here
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            state.item.pop();
        },
        clearCart: (state, action)=>{
            state.items.length = 0;
        }
    }
});
const { addItem: $f9ee2b4ae9fa584a$export$fb9705de59d96855, removeItem: $f9ee2b4ae9fa584a$export$fe2d9b4e03920b4c, clearCart: $f9ee2b4ae9fa584a$export$810121176e3e3671 } = $f9ee2b4ae9fa584a$var$cartSlice.actions;
var $f9ee2b4ae9fa584a$export$2e2bcd8739ae039 = $f9ee2b4ae9fa584a$var$cartSlice.reducer;


const $eb611041b313b99b$var$ItemList = ({ items: items })=>{
    const dispatch = (0, $25d342665550a083$export$8ad76b76a4c905f8)();
    const handleAddItem = (item)=>{
        //Dispatch an action
        dispatch((0, $f9ee2b4ae9fa584a$export$fb9705de59d96855)(item));
    };
    return /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
        className: "space-y-4",
        children: items.map((item)=>/*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-200",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("img", {
                        src: (0, $1449da937569f1f7$export$31adfacaf07ffe63) + item.card.info.imageId,
                        className: "w-20 h-20 object-cover rounded-md"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                        className: "flex-1 mx-4",
                        children: [
                            /*#__PURE__*/ (0, $5aRSq.jsx)("h3", {
                                className: "font-semibold text-gray-800",
                                children: item.card.info.name
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                                className: "text-sm text-gray-600 mt-1",
                                children: [
                                    "- \u20B9",
                                    item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                ]
                            }),
                            /*#__PURE__*/ (0, $5aRSq.jsx)("p", {
                                className: "text-xs text-gray-500 mt-1 line-clamp-2",
                                children: item.card.info.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                        className: "bg-blue-500 text-white px-4 py-2 rounded-md shadow hover:bg-blue-600 transition-colors duration-300",
                        // onClick={() => handleAddItem(item)}
                        onClick: ()=>handleAddItem(item),
                        children: "Add +"
                    })
                ]
            }, item.card.info.id))
    });
};
var $eb611041b313b99b$export$2e2bcd8739ae039 = $eb611041b313b99b$var$ItemList;


const $8e2ebdb1389817d3$var$RestaurantCategory = ({ data: data, showItems: showItems, setShowIndex: setShowIndex, dummy: dummy })=>{
    const handleClick = ()=>{
        setShowIndex();
    };
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "w-11/12 mx-auto my-4 rounded-lg shadow-md border border-gray-200",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "flex justify-between items-center cursor-pointer p-4 bg-white rounded-lg hover:shadow-lg transition-shadow duration-300",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsxs)("span", {
                        className: "font-semibold text-gray-800 text-lg",
                        children: [
                            data.title,
                            " (",
                            data.itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)("span", {
                        children: "\u2B07\uFE0F"
                    })
                ]
            }),
            showItems && /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "bg-gray-50 rounded-b-lg p-4",
                children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $eb611041b313b99b$export$2e2bcd8739ae039), {
                    items: data.itemCards
                })
            })
        ]
    });
};
var $8e2ebdb1389817d3$export$2e2bcd8739ae039 = $8e2ebdb1389817d3$var$RestaurantCategory;



var $4Iuzv = parcelRequire("4Iuzv");
const $89035d1904005ab7$var$RestuarantMenu = ()=>{
    // const [resInfo, setResInfo] = useState(null);
    const { resId: resId } = (0, $fe9e62b514d376d4$export$99eaa27ddbbb95ef)();
    //useRestaurantMenu is our custom hook and we are going to perform the fetching of the data
    const resInfo = (0, $6a9db8a30167c416$export$2e2bcd8739ae039)(resId);
    const [showIndex, setShowIndex] = (0, $4Iuzv.useState)(null);
    // console.log(resId);
    /*
    useEffect(() => {
        fetchMenu ();
    }, []);

    const fetchMenu = async () => {
        const data = await fetch( MENU_API + resId);
       
        const json = await data.json();

        console.log(json);
        setResInfo(json.data);
    }
*/ if (resInfo === null) return /*#__PURE__*/ (0, $5aRSq.jsx)((0, $eb3dc97cbfcc19b2$export$2e2bcd8739ae039), {});
    const { name: name, cuisines: cuisines, costForTwoMessage: costForTwoMessage } = resInfo?.cards[2]?.card?.card?.info;
    const { itemCards: itemCards } = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[1]?.card?.card;
    // console.log(itemCards);
    const categories = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c)=>c.card?.["card"]?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");
    console.log(categories);
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "max-w-4xl mx-auto p-4",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                className: "font-bold text-4xl text-gray-800 my-4",
                children: name
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("p", {
                className: "text-lg text-gray-600 mb-8",
                children: [
                    cuisines.join(","),
                    " - ",
                    costForTwoMessage
                ]
            }),
            /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                className: "space-y-6",
                children: categories.map((category, index)=>// controlled component
                    /*#__PURE__*/ (0, $5aRSq.jsx)("div", {
                        className: "bg-white shadow-md rounded-lg p-4 hover:shadow-xl transition-shadow duration-300",
                        children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $8e2ebdb1389817d3$export$2e2bcd8739ae039), {
                            data: category?.card?.card,
                            showItems: index === showIndex ? true : false,
                            setShowIndex: ()=>setShowIndex(index === showIndex ? null : index)
                        })
                    }, category?.card?.card.title))
            })
        ]
    });
};
var $89035d1904005ab7$export$2e2bcd8739ae039 = $89035d1904005ab7$var$RestuarantMenu;





//This file is the redux store;


const $4a3d3f82ec7c4964$var$appStore = (0, $0005262392d89a41$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $f9ee2b4ae9fa584a$export$2e2bcd8739ae039)
    }
});
var $4a3d3f82ec7c4964$export$2e2bcd8739ae039 = $4a3d3f82ec7c4964$var$appStore;



var $5aRSq = parcelRequire("5aRSq");



const $acd6f3583186c4a7$var$Cart = ()=>{
    const cartItems = (0, $25d342665550a083$export$2105062e25df4afe)((store)=>store.cart.items);
    console.log(cartItems);
    const dispatch = (0, $25d342665550a083$export$8ad76b76a4c905f8)();
    const handleClearCart = ()=>{
        dispatch((0, $f9ee2b4ae9fa584a$export$810121176e3e3671)());
    };
    return /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
        className: "text-center m-4 p-4",
        children: [
            /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                className: "text-2xl font-bold",
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "w-6/12 m-auto",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)("button", {
                        className: " p-2 m-2 bg-black text-white rounded-lg",
                        onClick: handleClearCart,
                        children: "Clear Cart"
                    }),
                    cartItems?.length === 0 && /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                        children: " Cart is empty. Add Items to the cart!"
                    }),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $eb611041b313b99b$export$2e2bcd8739ae039), {
                        items: cartItems
                    })
                ]
            })
        ]
    });
};
var $acd6f3583186c4a7$export$2e2bcd8739ae039 = $acd6f3583186c4a7$var$Cart;



const $fd878d1a2b2f022b$var$Grocery = /*#__PURE__*/ (0, $4Iuzv.lazy)(()=>(parcelRequire("cnbGx")));
const $fd878d1a2b2f022b$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $4Iuzv.useState)();
    //authentication
    (0, $4Iuzv.useEffect)(()=>{
        //Make an API call and send Username and password
        const data = {
            name: "Parshuram Kumar"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $5aRSq.jsx)((0, $25d342665550a083$export$2881499e37b75b9a), {
        store: (0, $4a3d3f82ec7c4964$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $4a71cd73bab5fc14$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $5aRSq.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $ca2c91bf6756c02e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5aRSq.jsx)((0, $fe9e62b514d376d4$export$910ae8079b2c2852), {})
                ]
            })
        })
    });
};
const $fd878d1a2b2f022b$var$appRouter = (0, $fe9e62b514d376d4$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5aRSq.jsx)($fd878d1a2b2f022b$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $58044eda1763adcb$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $2982f87537b17e94$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $a7056d12e4b6a8a4$export$2e2bcd8739ae039), {})
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $89035d1904005ab7$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $4Iuzv.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5aRSq.jsx)("h1", {
                        children: "Loading"
                    }),
                    children: /*#__PURE__*/ (0, $5aRSq.jsx)($fd878d1a2b2f022b$var$Grocery, {})
                })
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $acd6f3583186c4a7$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $5aRSq.jsx)((0, $7e935ac5b2f1db10$export$2e2bcd8739ae039), {})
    }
]);
const $fd878d1a2b2f022b$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($21fa618cfc67d6ae$exports))).createRoot(document.getElementById("root"));
$fd878d1a2b2f022b$var$root.render(/*#__PURE__*/ (0, $5aRSq.jsx)((0, $fe9e62b514d376d4$export$323e4fc2fa4753fb), {
    router: $fd878d1a2b2f022b$var$appRouter
}));


//# sourceMappingURL=index.9755d54e.js.map
